const enMessages = {
  "rules.override.session": "Substituição de sessão",
  "rules.override.active.session": "Permitir substituição de sessão ativa",
  "common.api.key.message": "Por favor, configure sua chave de API nas configurações",
  "apis.google.maps.description": "O Google Maps oferece mapas e rotas precisas em tempo real",
  "common.long": "Longitude",
  "common.lat": "Latitude",
  "common.maps": "Mapa",
  "common.maps.satellite": "Satélite",
  "common.maps.terrain": "Terreno",
  "common.maps.hybrid": "Híbrido",
  "common.master": "Matriz",
  "common.filial": "Filial",
  "common.id": "ID",
  "common.portuguese": "Português",
  "common.english": "Inglês",
  "common.sync": "Sincronização",
  "common.next": "Próximo",
  "common.prev": "Anterior",
  "common.none": "Nenhum",
  "common.user": "Usuário",
  "common.password": "Senha",
  "common.security": "Segurança",
  "common.malware": "Malware",
  "common.site": "Site",
  "common.threat": "Ameaça",
  "common.malicious": "IP Malicioso",
  "common.server": "Servidor",
  "common.success": "Sucesso",
  "google.maps": "Google Maps",
  "common.api.key.missing": "Chave da API do Google Maps faltando",
  "common.api.config": "Configuração de API",
  "common.api.configs": "Configurações de API",
  "common.api.configs.add": "Adicionar Configuração de API",
  "common.api.configs.edit": "Editar Configuração de API",
  "common.api.configs.delete": "Excluir Configuração de API",
  "common.api.configs.delete.multiple": "Excluir Configurações de API",
  "common.api.configs.delete.multiple.confirm": "Tem certeza que deseja excluir as configurações de API selecionadas?",
  "common.api.configs.delete.multiple.success": "Configurações de API excluídas com sucesso",
  "common.api.key": "Chave de API",
  "common.delete.error": "Erro ao excluir",
  "common.servers": "Servidores",
  "common.port": "Porta",
  "common.hostname": "Nome do Host",
  "common.host": "Host",
  "common.domain": "Domínio",
  "common.force.safe.search": "Forçar Pesquisa Segura",
  "common.timezone": "Fuso horário",
  "common.language": "Idioma",
  "common.cancel": "Cancelar",
  "common.yes": "Sim",
  "common.no": "Não",
  "common.close": "Fechar",
  "common.save": "Salvar",
  "common.backup": "Backup",
  "common.backups": "Backups",
  "common.restore": "Restaurar",
  "common.used": "Uso",
  "common.uptime": "Tempo de Atividade",
  "common.disc": "Disco",
  "common.idle": "Ociosidade",
  "common.time.system": "Hora do Sistema",
  "common.add.to.list": "Adicionar à lista",
  "common.add.to.filter": "Adicionar ao filtro",
  "common.del.to.list": "Remover da lista",
  "common.group": "Grupo",
  "common.create": "Criar",
  "common.delete": "Excluir",
  "common.create.name": "Criar {name}",
  "common.delete.name": "Excluir {name}",
  "common.system.updates": "Updates",
  "common.update": "Atualizar",
  "common.updates": "Atualizações",
  "common.edit": "Editar",
  "common.configure": "Configurar",
  "common.view": "Visualizar",
  "common.name": "Nome",
  "common.description": "Descrição",
  "common.workers": "Workers",
  "common.import-file": "Importar arquivo",
  "common.Lease": "Leases",

  "common.version": "Versão",
  "common.mode": "Modo",
  "common.protocol": "Protocolo",
  "common.protocols": "Protocolos",
  "common.position": "Posição",
  "common.enabled": "Habilitado",
  "common.disabled": "Desabilitado",
  "common.disableds": "Desabilitados",
  "common.active": "Ativo",
  "common.inactive": "Inativo",
  "common.any": "Qualquer",
  "common.always": "Sempre",
  "common.total": "Total",
  "common.back": "Voltar",
  "common.clear": "Limpar",
  "common.template": "Template",
  "common.template.name": "Nome do Template",
  "common.confirm":
    "Você tem certeza que deseja {action} o(s) seguinte(s) {type}{len, plural, one {} other {s}}{value}?",
  "common.confirm.group":
    "Você tem certeza que deseja excluir o(s) seguinte(s) grupo(s)?",
  "common.confirm.policy":
    "Você tem certeza que deseja excluir a(s) seguinte(s) politica(s)?",
  "common.confirm.delete": "Tem certeza?",
  "common.select_all": "Selecionar Todos",
  "common.allow_all": "Permitir Todos",
  "common.deny_all": "Recusar Todos",
  "common.block_all": "Bloquear Todos",
  "common.disable_all": "Desabilitar Todos",
  "common.warning_all": "Alertar Todos",
  "common.deselect_all": "Deselecionar Todos",
  "common.noGroup": "Nenhum Grupo",
  "common.invalid.value": "Valor inválido!",
  "common.invalid.form": "Por favor revise este formulário!",
  "common.required.field": "Campo obrigatório",
  "common.text.too.long": "Limite máximo de caracteres atingido",
  "common.text.too.long.70c": "O valor não deve ser maior que 70 caracteres",
  "common.perSecond": "por segundo",
  "common.perMinute": "por minuto",
  "common.perHour": "por hora",
  "common.passive": "Passivo",
  "common.informations": "Informações",
  "common.conditions": "Condições",
  "common.inspection": "Inspeção",
  "common.controls": "Controles",
  "common.rule": "Regra",
  "common.reason": "Razão",
  "common.user.agent": "Plataforma",
  "common.allow": "Permitir",
  "common.allowed": "Permitido",
  "common.alloweds": "Permitidos",
  "common.deny": "Recusar",
  "common.declined": "Recusado",
  "common.decline": "Recusar",
  "common.denied": "Negados",
  "common.warning": "Atenção",
  "common.reject": "Rejeitar",
  "common.all": "Todos",
  "common.allDevices": "Todos os Dispositivos",
  "common.selected": "Selecionado",
  "common.selected.objects": "{count} selecionados",
  "common.general": "Geral",
  "common.config": "Configuração",
  "common.type": "Tipo",
  "common.logtype": "Tipo de log",
  "common.logs": "Logs",
  "common.groups": "Grupos",
  "common.devicesWithoutGroup": "Dispositivos sem Grupo",
  "common.sources": "Origens",
  "common.clone": "Clonar",
  "common.working": "Processando...",
  "common.actions": "Ações",
  "common.action": "Ação",
  "common.client": "Cliente",
  "common.system": "Sistema",
  "common.license": "Licença",
  "common.sessions": "Sessões",
  "common.services": "Serviços",
  "common.interfaces": "Interfaces",
  "common.interface": "Interface",
  "common.email": "E-mail",
  "common.email.report": "Enviar Relatório por E-mail",
  "common.email.group.report": "Enviar Relatório para Grupo de email",
  "common.error.email.group.report": "Alguns emails não são válidos",
  "common.placeholder.email.group.report": "Adicionar emails",
  "common.users": "Usuários",
  "common.profiles": "Perfis",
  "common.audit": "Auditoria",
  "common.save.success": "Salvo com sucesso",
  "common.save.error": "Erro ao salvar!",
  "common.processes": "Processos",
  "common.remove": "Remover",
  "common.device": "Device",
  "common.deviceLogger": "Device/Logger",
  "common.status": "Status",
  "common.block": "Bloquear",
  "common.quarantine": "Quarentena",
  "common.quantity": "Quantidade",
  "common.risk": "Risco",
  "common.high": "Alto",
  "common.medium": "Médio",
  "common.low": "Baixo",
  "common.category": "Categoria",
  "common.sid": "SID",
  "common.pcap": "PCAP",
  "common.packetLogger": "Packet Logger",
  "common.minFile": "Tamanho mínimo do arquivo (MB)",
  "common.profile_filesize": "Tamanho máximo do arquivo (MB)",
  "common.prefixPcap": "Prefixo do arquivo",
  "common.blocked": "Bloqueado",
  "common.blockeds": "Bloqueados",
  "common.unblocked": "Desbloqueado",
  "common.source": "Origem",
  "common.destination": "Destino",
  "common.enable": "Habilitar",
  "common.disable": "Desabilitar",
  "common.unblock": "Desbloquear",
  "common.profile": "Perfil",
  "common.custom": "Customizar",
  "common.deleted": "{name} deletado com sucesso",
  "common.date": "Data",
  "common.archive": "Arquivo",
  "common.service": "Serviço",
  "common.search": "Busca",
  "common.filters": "Filtros",
  "common.filter": "Filtro",
  "common.task": "Task",
  "common.auditor": "Auditor",
  "common.created": "Criado",
  "common.accept": "Aceitar",
  "common.activity": "Atividade",
  "common.logger": "Logger",
  "common.error": "Erro",
  "common.error.network": "Erro de rede!",
  "common.error.required": "{name} é obrigatório",
  "common.error.required.ip.forwarding": "IP é obrigatório",
  "common.error.required.advancedSettings": "O valor é obrigatório",
  "common.error.alphanumeric":
    "Campo alfanumérico minúsculo obrigatório (a-z0-9_-)",
  "common.error.invalid": "{name} é inválido",
  "common.error.invalid.value": "Valor inválido",
  "common.error.invalid.format": "Formato inválido",
  "common.error.invalid.format.core.max": "Valor acima do limite, máximo permitido",
  "common.error.invalid.format.core.min": "Valor abaixo do limite, mínimo permitido",
  "common.error.fetch": "Erro ao buscar os dados.",
  "common.error.character": "Caractere inválido.",
  "common.error.min.character":
    "O campo deve ter no mínimo {number} caracteres.",
  "common.authentication.required": "Campo MFA é obrigatório",
  "common.error.version": "Versão não suportada",
  "common.error.file.notFound": "Arquivo não encontrado",
  "common.error.url": "{name} deve ser um url válido.",
  "common.error.url.fail": "Url inválida.",
  "common.error.url.https": "Está URL deve ser do tipo https.",
  "common.error.email": "{name} deve ser um email válido.",
  "common.error.saml.service.name":
    "Somente texto alfanumérico e minúsculo. ([a-z0-9_-])",
  "common.error.snap.version":
    "Snapshot incompátivel - Versão do servidor: {serverVersion} - Versão do snapshot: {snapVersion}",
  "common.error.dont.permition": "Seu login não permite acesso a esta area.",
  "common.error.action.not.allowed":"Ação não permitida.",
  "common.top": "Top",
  "common.hits": "Hits",
  "common.traffic": "Tráfego",
  "common.select": "Selecionar",
  "common.page": "Página",
  "common.done": "Concluído",
  "common.provisioning": "Provisionamento",
  "common.connect": "Conectado",
  "common.identification": "Identificação",
  "common.model": "Modelo",
  "common.scheduled": "Agendado",
  "common.firewall": "Firewall",
  "common.default": "Default",
  "common.dhcp": "DHCP",
  "common.confirm.ok": "Confirmar",
  "common.uuid": "UUID",
  "common.add": "Adicionar",
  "common.company": "Companhia",
  "common.devTemplate": "Template de Device",
  "common.polPackage": "Pacote de Política",
  "common.devComm": "Comunidade de Device",
  "common.alreadyExists": "Já existe",
  "common.dns": "DNS",
  "common.dns_server": "Servidor DNS",
  "common.progress": "Progresso",
  "common.import": "Importar {name}",
  "common.list": "Lista",
  "common.templates": "Templates de Device",
  "common.templates.combo": "Template de Device",
  "common.community": "Comunidade de Device",
  "common.certificate": "Certificado",
  "common.certificate.remote": "CA Remota",
  "common.certificates": "Certificados",
  "common.years": "Anos",
  "common.country": "País",
  "common.state": "Estado",
  "common.city": "Cidade",
  "common.organization": "Empresa",
  "common.unit": "Unidade Organizacional",
  "common.expires": "Expira em (anos)",
  "common.license.expires.at": "Licença irá expirar em:",
  "common.show.all": "Visualizar todos",
  "common.items.not.found": "Nenhum ítem encontrado",
  "common.apply": "Aplicar",
  "common.values": "Valores",
  "common.time": "Tempo",
  "common.ip": "IP",
  "common.ips": "IP's",
  "common.network": "Rede",
  "common.simultaneous.transfers": "Transferências Simultâneas",
  "common.whitelist": "Endereços Liberados",
  "common.blacklist": "Endereços Bloqueados",
  "common.invalid.fields": "Campos inválidos",
  "common.dnsServer": "Servidor DNS",
  "common.domain1": "Dominio.com.br",
  "common.dns1": "DNS Primário",
  "common.dns2": "DNS Secundário",
  "common.dnssuffix": "Sufixo DNS",
  "common.gateway": "Gateway",
  "common.ntpserver": "Servidor NTP",
  "common.ipExample": "1.1.1.1",
  "common.maskExample": "255.255.255.255",
  "common.object.address": "Endereço",
  "common.object.service": "Serviço",
  "common.object.time": "Tempo",
  "common.object.schedule": "Agendamento",
  "common.object.dictionary": "Dicionário",
  "common.object.content": "Conteúdo",
  "common.profile.webfilter": "Perfil de Web Filter",
  "common.profile.webfilter.inUse":
    "Não foi possível excluir o perfil! Perfil em uso",
  "common.profile.appcontrol": "Perfil de Application Control",
  "common.profile.atp": "Perfil de Threat Protection",
  "common.profile.ips": "Perfil de Intrusion Prevention",
  "common.profile.ssl": "Perfil de Inspeção SSL",
  "common.profile.sdwan": "Perfil de SD-WAN",
  "common.profile.sdwan.space.error": "Nome do Perfil com espaço",
  "common.manager.delete.group.message.withdevice":
    "Existe um device associado ao grupo {name}! Tem certeza de que deseja excluí-lo?",
  "common.manager.delete.group.message":
    "Tem certeza de que deseja excluir o grupo {name}?",
  "common.wizard.network.dns1": "Servidor DNS 1",
  "common.wizard.network.dns2": "Servidor DNS 2",
  "common.wizard.network.dns1.error": "Servidor DNS 1 é obrigatório",
  "common.policy": "Política",
  "common.established": "Estabelecido",
  "common.new": "Novo",
  "common.start": "Iniciar",
  "common.paste.here": "Cole Aqui",
  "common.stop": "Parar",
  "common.zone": "Zona",
  "common.bytes": "Bytes",
  "common.bytes.received": "Bytes Recebidos",
  "common.bytes.sent": "Bytes Enviados",
  "common.bytes.total": "Bytes Total",
  "common.packages": "Pacotes",
  "common.packages.combo": "Pacotes de Políticas",
  "common.packages.received": "Packages Recebidos",
  "common.packages.sent": "Packages Enviados",
  "common.packages.total": "Packages Total",
  "common.connection": "Conexão",
  "common.connections": "Conexões",
  "commom.confirm.delete": "Tem certeza de que deseja excluir?",
  "common.application": "Aplicação",
  "common.attack": "Ataque",
  "common.latency": "Latência",
  "common.jitter": "Jitter",
  "common.packetLoss": "Perda de Pacotes",
  "common.bandwidth": "Bandwidth",
  "common.balancing": "Balanceamento",
  "common.traffic.distribution": "Distribuição de Tráfego",
  "common.deploy": "Deploy",
  "common.custom-signature": "Assinatura Customizada",
  "common.wizard.admin.repass.mismatch":
    "A senha do campo de confirmação não corresponde à senha digitada no campo anterior",
  "common.authentication": "Autenticação",
  "common.routes": "Rotas",
  "common.dont.permission": "Você não tem permissão para executar essa ação.",
  "common.dont.permission.page":
    "Você não tem permissão para acessar essa página.",
  "common.dont.permission.delete":
    "Você não tem permissão para deletar esse registro.",
  "common.dont.permission.clone":
    "Você não tem permissão para clonar esse registro.",
  "common.dont.permission.edit":
    "Você não tem permissão para editar esse registro.",
  "common.blocked.ha": "High Availabilty Habilitado - Estado: Backup - Acesso Bloqueado.",
  "common.server.error":
    "Erro no servidor, por favor entre em contato com o administrador do sistema",
  "common.login.form": "Acesse sua conta",
  "common.login.form.email": "Endereço de E-mail",
  "common.login.form.email.required": "E-mail é obrigatório",
  "common.login.form.password": "Senha",
  "common.login.form.password.required": "Senha é obrigatória",
  "common.login.form.forgot": "Esqueceu a senha?",
  "common.devin": "Device",
  "common.mask": "Máscara",
  "common.mac": "MAC",
  "common.sso": "SSO",
  "common.read": "Leitura",
  "common.write": "Escrita",
  "common.settings": "Configurações",
  "common.exception": "Exceção",
  "common.transparent": "Transparente",
  "common.select.time.ini": "Selecione a hora inicial",
  "common.select.time.end": "Selecione a hora final",
  "common.records": "registros",
  "common.first": "Primeiro",
  "common.record": "registro",
  "common.limit.profile": "Limite de perfis criados.",
  "common.src": "Origem",
  "common.dst": "Destino",
  "common.virtualAddress": "Endereço Virtual",
  "common.duration": "Duração",
  "common.packets": "Packets",
  "common.event": "Evento",
  "common.storages": "Armazenamentos",
  "common.storage": "Armazenamento",
  "common.virtualDomain": "Domínio Virtual",
  "common.logging": "Logging",
  "common.notifications": "Notificações",
  "common.highAvailability": "High Availability",
  "common.vdom": "Domínios Virtuais",
  "common.days": "Dias",
  "common.months": "Meses",
  "common.unlimited": "Ilimitado",
  "common.disk": "disco",
  "common.ipAddress": "Endereço IP",
  "common.reload": "Recarregar",
  "common.time.conection": "Tempo de Conexão",
  "common.secret": "Segredo",
  "common.seconds": "segundo(s)",
  "common.size": "Tamanho",
  "common.login": "Login",
  "common.logout": "Logout",
  "common.share": "Compartilhamento",
  "common.directory": "Diretório",
  "common.copied": "Copiado",
  "common.max": "Max",
  "common.authenticated": "Autenticado",
  "common.auth": "Autenticado",
  "common.modules": "Módulos",
  "common.delete.success": "Removido com sucesso",
  "common.disabled.success": "Desabilitado com sucesso",
  "common.clone.success": "Clonado com sucesso",
  "common.clone.error": "Error ao clonar",
  "common.nothing.delete": "Nenhum item a ser deletado",
  "common.disclaimer": "Termo de responsabilidade",
  "common.minutes": "Minutos",
  "common.hours": "Horas",
  "common.at.hours": "às",
  "common.at.day": "Dia",
  "common.completed": "Completo",
  "common.administrators": "Administradores",
  "common.users.profiles": "Perfis de Usuários",
  "common.auth.servers": "Servidores de Autenticação",
  "common.identity.provider": "Provedor de Identidade",
  "common.audit.log": "Log de Auditoria",
  "common.high.availability": "Alta Disponibilidade",
  "common.standalone": "Remoto",
  "common.integrated": "Integrado",
  "common.disclaimer.login.title": "Termo de Responsabilidade de Login",
  "common.initial.space.error": "Espaço inicial não é permitido",
  "common.remote": "Remoto",
  "common.complete": "Completo",
  "common.diff": "Diferencial",
  "common.name.already.exists": "Nome de perfil já existe!",
  "common.access.control": "Controle de Acesso",
  "common.select.device.logger": "Selecione Device/Logger",
  "common.vpn": "VPN",
  "common.static.routing": "Roteamento Estático",
  "common.relevance": "Relevância",
  "common.local": "Local",
  "common.maintenance": "Manutenção",
  "common.all.files": "Todos os arquivos",
  "common.temporary": "Temporário",
  "common.reports": "Relatórios",
  "common.statistics": "Estatísticas",
  "common.invalid.form.risk.item": "Não é permitido escolher mais de dois itens por risco",
  "common.copy": "Copiar",
  "common.access.multifactor": "MFA",
  "common.access.multifactor.active": "Identificação por dois fatores",
  "common.access.multifactor.validate": "Usuário com chave cadastrada",
  "device.config.success": "Dispositivo configurado",
  "common.waiting": "Aguardando",
  "common.waiting.approval": "Aguardando aprovação",
  "common.in_progress": "Aplicando configurações iniciais",
  "common.registry": "Registrando",
  "common.license.expired": "Licença expirada",
  "provisioning.batch": "Verificando lote",
  "provisioning.error.batch": "Erro no lote",
  "common.config.device": "Configurando dispositivo",
  "common.waiting.key.exchange": "Aguardando troca de chaves",
  "common.connecting": "Conectando dispositivo",
  "common.confirmSignatures": "Confirmar alteração em {value} assinaturas?",
  "deploy.sending": "Enviando deploy",
  "deploy.applying": "Aplicando deploy",
  "administration.profiles.datagrid.name": "Nome",
  "administration.profiles.datagrid.email": "E-mail",
  "administration.profiles.datagrid.key": "Chave",
  "country.local": "Rede Local",
  "country.AD": "Andorra",
  "country.AE": "United Arab Emirates",
  "country.AF": "Afghanistan",
  "country.AG": "Antigua and Barbuda",
  "country.AI": "Anguilla",
  "country.AL": "Albania",
  "country.AM": "Armenia",
  "country.AO": "Angola",
  "country.AP": "Asia/Pacific Region",
  "country.AQ": "Antarctica",
  "country.AR": "Argentina",
  "country.AS": "American Samoa",
  "country.AT": "Austria",
  "country.AU": "Australia",
  "country.AW": "Aruba",
  "country.AX": "Aland Islands",
  "country.AZ": "Azerbaijan",
  "country.BA": "Bosnia and Herzegovina",
  "country.BB": "Barbados",
  "country.BD": "Bangladesh",
  "country.BE": "Belgium",
  "country.BF": "Burkina Faso",
  "country.BG": "Bulgaria",
  "country.BH": "Bahrain",
  "country.BI": "Burundi",
  "country.BJ": "Benin",
  "country.BL": "Saint Barthelemy",
  "country.BM": "Bermuda",
  "country.BN": "Brunei Darussalam",
  "country.BO": "Bolivia",
  "country.BQ": "Bonaire, Saint Eustatius and Saba",
  "country.BR": "Brazil",
  "country.BS": "Bahamas",
  "country.BT": "Bhutan",
  "country.BV": "Bouvet Island",
  "country.BW": "Botswana",
  "country.BY": "Belarus",
  "country.BZ": "Belize",
  "country.CA": "Canada",
  "country.CC": "Cocos (Keeling) Islands",
  "country.CD": "Congo, The Democratic Republic of the",
  "country.CF": "Central African Republic",
  "country.CG": "Congo",
  "country.CH": "Switzerland",
  "country.CI": "Cote d'Ivoire",
  "country.CK": "Cook Islands",
  "country.CL": "Chile",
  "country.CM": "Cameroon",
  "country.CN": "China",
  "country.CO": "Colombia",
  "country.CR": "Costa Rica",
  "country.CU": "Cuba",
  "country.CV": "Cape Verde",
  "country.CW": "Curacao",
  "country.CX": "Christmas Island",
  "country.CY": "Cyprus",
  "country.CZ": "Czech Republic",
  "country.DE": "Germany",
  "country.DJ": "Djibouti",
  "country.DK": "Denmark",
  "country.DM": "Dominica",
  "country.DO": "Dominican Republic",
  "country.DZ": "Algeria",
  "country.EC": "Ecuador",
  "country.EE": "Estonia",
  "country.EG": "Egypt",
  "country.EH": "Western Sahara",
  "country.ER": "Eritrea",
  "country.ES": "Spain",
  "country.ET": "Ethiopia",
  "country.EU": "Europe",
  "country.FI": "Finland",
  "country.FJ": "Fiji",
  "country.FK": "Falkland Islands (Malvinas)",
  "country.FM": "Micronesia, Federated States of",
  "country.FO": "Faroe Islands",
  "country.FR": "France",
  "country.GA": "Gabon",
  "country.GB": "United Kingdom",
  "country.GD": "Grenada",
  "country.GE": "Georgia",
  "country.GF": "French Guiana",
  "country.GG": "Guernsey",
  "country.GH": "Ghana",
  "country.GI": "Gibraltar",
  "country.GL": "Greenland",
  "country.GM": "Gambia",
  "country.GN": "Guinea",
  "country.GP": "Guadeloupe",
  "country.GQ": "Equatorial Guinea",
  "country.GR": "Greece",
  "country.GS": "South Georgia and the South Sandwich Islands",
  "country.GT": "Guatemala",
  "country.GU": "Guam",
  "country.GW": "Guinea-Bissau",
  "country.GY": "Guyana",
  "country.HK": "Hong Kong",
  "country.HM": "Heard Island and McDonald Islands",
  "country.HN": "Honduras",
  "country.HR": "Croatia",
  "country.HT": "Haiti",
  "country.HU": "Hungary",
  "country.ID": "Indonesia",
  "country.IE": "Ireland",
  "country.IL": "Israel",
  "country.IM": "Isle of Man",
  "country.IN": "India",
  "country.IO": "British Indian Ocean Territory",
  "country.IQ": "Iraq",
  "country.IR": "Iran, Islamic Republic of",
  "country.IS": "Iceland",
  "country.IT": "Italy",
  "country.JE": "Jersey",
  "country.JM": "Jamaica",
  "country.JO": "Jordan",
  "country.JP": "Japan",
  "country.KE": "Kenya",
  "country.KG": "Kyrgyzstan",
  "country.KH": "Cambodia",
  "country.KI": "Kiribati",
  "country.KM": "Comoros",
  "country.KN": "Saint Kitts and Nevis",
  "country.KP": "Korea, Democratic People's Republic of",
  "country.KR": "Korea, Republic of",
  "country.KW": "Kuwait",
  "country.KY": "Cayman Islands",
  "country.KZ": "Kazakhstan",
  "country.LA": "Lao People's Democratic Republic",
  "country.LB": "Lebanon",
  "country.LC": "Saint Lucia",
  "country.LI": "Liechtenstein",
  "country.LK": "Sri Lanka",
  "country.LR": "Liberia",
  "country.LS": "Lesotho",
  "country.LT": "Lithuania",
  "country.LU": "Luxembourg",
  "country.LV": "Latvia",
  "country.LY": "Libyan Arab Jamahiriya",
  "country.MA": "Morocco",
  "country.MC": "Monaco",
  "country.MD": "Moldova, Republic of",
  "country.ME": "Montenegro",
  "country.MF": "Saint Martin",
  "country.MG": "Madagascar",
  "country.MH": "Marshall Islands",
  "country.MK": "Macedonia",
  "country.ML": "Mali",
  "country.MM": "Myanmar",
  "country.MN": "Mongolia",
  "country.MO": "Macao",
  "country.MP": "Northern Mariana Islands",
  "country.MQ": "Martinique",
  "country.MR": "Mauritania",
  "country.MS": "Montserrat",
  "country.MT": "Malta",
  "country.MU": "Mauritius",
  "country.MV": "Maldives",
  "country.MW": "Malawi",
  "country.MX": "Mexico",
  "country.MY": "Malaysia",
  "country.MZ": "Mozambique",
  "country.NA": "Namibia",
  "country.NC": "New Caledonia",
  "country.NE": "Niger",
  "country.NF": "Norfolk Island",
  "country.NG": "Nigeria",
  "country.NI": "Nicaragua",
  "country.NL": "Netherlands",
  "country.NO": "Norway",
  "country.NP": "Nepal",
  "country.NR": "Nauru",
  "country.NU": "Niue",
  "country.NZ": "New Zealand",
  "country.OM": "Oman",
  "country.PA": "Panama",
  "country.PE": "Peru",
  "country.PF": "French Polynesia",
  "country.PG": "Papua New Guinea",
  "country.PH": "Philippines",
  "country.PK": "Pakistan",
  "country.PL": "Poland",
  "country.PM": "Saint Pierre and Miquelon",
  "country.PN": "Pitcairn",
  "country.PR": "Puerto Rico",
  "country.PS": "Palestinian Territory",
  "country.PT": "Portugal",
  "country.PW": "Palau",
  "country.PY": "Paraguay",
  "country.QA": "Qatar",
  "country.RE": "Reunion",
  "country.RO": "Romania",
  "country.RS": "Serbia",
  "country.RU": "Russian Federation",
  "country.RW": "Rwanda",
  "country.SA": "Saudi Arabia",
  "country.SB": "Solomon Islands",
  "country.SC": "Seychelles",
  "country.SD": "Sudan",
  "country.SE": "Sweden",
  "country.SG": "Singapore",
  "country.SH": "Saint Helena",
  "country.SI": "Slovenia",
  "country.SJ": "Svalbard and Jan Mayen",
  "country.SK": "Slovakia",
  "country.SL": "Sierra Leone",
  "country.SM": "San Marino",
  "country.SN": "Senegal",
  "country.SO": "Somalia",
  "country.SR": "Suriname",
  "country.SS": "South Sudan",
  "country.ST": "Sao Tome and Principe",
  "country.SV": "El Salvador",
  "country.SX": "Sint Maarten",
  "country.SY": "Syrian Arab Republic",
  "country.SZ": "Swaziland",
  "country.TC": "Turks and Caicos Islands",
  "country.TD": "Chad",
  "country.TF": "French Southern Territories",
  "country.TG": "Togo",
  "country.TH": "Thailand",
  "country.TJ": "Tajikistan",
  "country.TK": "Tokelau",
  "country.TL": "Timor-Leste",
  "country.TM": "Turkmenistan",
  "country.TN": "Tunisia",
  "country.TO": "Tonga",
  "country.TR": "Turkey",
  "country.TT": "Trinidad and Tobago",
  "country.TV": "Tuvalu",
  "country.TW": "Taiwan",
  "country.TZ": "Tanzania, United Republic of",
  "country.UA": "Ukraine",
  "country.UG": "Uganda",
  "country.UM": "United States Minor Outlying Islands",
  "country.US": "United States",
  "country.UY": "Uruguay",
  "country.UZ": "Uzbekistan",
  "country.VA": "Holy See (Vatican City State)",
  "country.VC": "Saint Vincent and the Grenadines",
  "country.VE": "Venezuela",
  "country.VG": "Virgin Islands, British",
  "country.VI": "Virgin Islands, U.S.",
  "country.VN": "Vietnam",
  "country.VU": "Vanuatu",
  "country.WF": "Wallis and Futuna",
  "country.WS": "Samoa",
  "country.YE": "Yemen",
  "country.YT": "Mayotte",
  "country.ZA": "South Africa",
  "country.ZM": "Zambia",
  "country.ZW": "Zimbabwe",
  "certificate.country": "Abreviação de duas letras. Ex .: US",
  "certificate.state": "Ex. Completo: Nova York",
  "certificate.organization": "Nome da empresa",
  "certificate.unit": "Ex .: Departamento",
  "certificate.email": "admin@domínio",
  "certificate.keysize": "Tamanho da chave",

  "maintenance.success.clear.directory": "Diretório limpo com sucesso.",
  "maintenance.remove.clear.directory": "Deseja limpar todo o diretório?",
  "maintenance.remove.clear.directory.restart.proxy": "Deseja limpar todo o diretório? Será necessário reiniciar o serviço de proxy.",

  "network.settings.title": "Configurações de rede",
  "network.general.form.gateway": "Gateway",
  "network.general.form.dns1": "Servidor DNS 1",
  "network.general.form.dns2": "Servidor DNS 2",
  "network.general.form.ntp1": "Servidor NTP 1",
  "network.general.form.ntp2": "Servidor NTP 2",
  "network.interface.datagrid.name": "Nome",
  "network.interface.datagrid.address": "Endereço",
  "network.interface.datagrid.mask": "Máscara",
  "network.interface.datagrid.status": "Status",
  "network.interface.datagrid.actions": "Ações",
  "network.interface.form.title": "Editar Interface",
  "network.interface.form.status": "Habilitar",
  "network.interface.form.ip": "Endereço IP",
  "network.interface.form.ip.invalid": "Endereço IP inválido",
  "network.interface.form.mask.invalid": "Endereço da máscara inválido",
  "network.interface.form.mask": "Endereço da máscara",
  "network.interface.error.ip": "Campo de endereço IP é obrigatório",
  "network.interface.save.success": "Configurações alteradas com sucesso!",
  "network.interface.save.error": "As configurações não foram salvas!",
  "network.interface.searchInterfaces": "Buscar Interfaces",
  "network.interface.error.mask":
    "O campo de endereço da máscara é obrigatório",
  "network.email.connectionTest": "Testar conexão SMTP",
  "network.email.connectionError": "Falha na conexão SMTP",
  "network.email.connectionAuthFailed": "Falha na autenticação SMTP",
  "network.email.connectionSuccess": "Sucesso na conexão SMTP",
  "network.email.hostname.required": "Nome do host é obrigatório",
  "network.email.port.required": "Porta é obrigatória",
  "network.email.user.required": "Usuário é obrigatório",
  "network.email.pass.required": "Senha é obrigatória",
  "network.email.security.required": "Segurança é obrigatória",

  "administration.title": "Administração",
  "administration.titleComplete": "Perfil de administração",
  "administration.user.title": "Usuário Administrativo",
  "administration.profiles.datagrid.profile": "Perfil",
  "administration.profiles.datagrid.actions": "Ações",
  "administration.profiles.actions.create": "Criar Perfil",
  "administration.profiles.actions.delete": "Excluir Perfil",
  "administration.profiles.actions.clone": "Clonar Perfil",
  "administration.profiles.modal.title": "Criar Perfil",
  "administration.profiles.modal.name": "Nome",
  "administration.profiles.modal.devices": "Devices",
  "administration.profiles.modal.devicesGroups": "Grupo de Devices",
  "administration.profiles.modal.clone.text":
    "Tem certeza de que deseja clonar?",
  "administration.profiles.modal.delete.text":
    "Tem certeza de que deseja excluir?",
  "administration.profiles.modal.clone.success": "Perfil clonado com sucesso!",
  "administration.profiles.modal.clone.error": "O perfil não foi clonado!",
  "administration.profiles.modal.clone.error.already":
    "O perfil já foi clonado",
  "administration.profile.save.deleted": "Perfil excluído com sucesso!",
  "administration.profiles.save.deleted": "Perfis excluídos com sucesso!",
  "administration.profiles.save.deleted.errorAlready":
    "Já é administrador de usuários no perfil {name}",
  "administration.profiles.save.deleted.error":
    "Não é possível excluir o perfil {name}",

  //Controle de acesso -----
  "administration.control.actions.create": "Criar Controle",
  "administration.control.actions.delete": "Deletar Controle",

  "administration.users.datagrid.name": "Nome",
  "administration.users.datagrid.email": "E-mail",
  "administration.users.datagrid.type": "Tipo",
  "administration.users.datagrid.profile": "Perfil",
  "administration.users.datagrid.actions": "Ações",
  "administration.users.datagrid.auditor": "Auditor",
  "administration.users.datagrid.api_access": "Acesso API",
  "administration.users.actions.create": "Criar Usuário",
  "administration.users.actions.delete": "Excluir Usuário",
  "administration.users.actions.clone": "Clonar Usuário",
  "administration.users.modal.title": "Usuário Administrador",
  "administration.users.modal.auditor": "Auditor",
  "administration.users.modal.auditor.required": "É necessário um auditor!",
  "administration.users.modal.api_access": "Acesso a API",
  "administration.users.modal.api_access.required": "É necessário acesso a API!",
  "administration.users.modal.name": "Nome",
  "administration.users.modal.name.required": "Nome é obrigatório!",
  "administration.users.modal.email": "E-mail",
  "administration.users.modal.email.required": "E-mail é obrigatório!",
  "administration.users.modal.user": "Usuário",
  "administration.users.modal.user.required": "Usuário é obrigatório!",
  "administration.users.modal.type": "Tipo",
  "administration.users.modal.type.required": "Tipo é obrigatório!",
  "administration.users.modal.server": "Servidor",
  "administration.users.modal.server.required": "Servidor é obrigatório!",
  "administration.users.modal.password": "Senha",
  "administration.users.modal.password.required": "Senha é obrigatória!",
  "administration.users.modal.confirmPassword": "Confirmar Senha",
  "administration.users.modal.confirmPassword.required":
    "É obrigatório confirmar a senha!",
  "administration.users.modal.profile": "Perfil",
  "administration.users.modal.profile.required": "Perfil é obrigatório!",
  "administration.users.save.success": "Usuário salvo com sucesso!",
  "administration.users.save.error": "O usuário não foi salvo!",
  "administration.users.delete.error": "Os usuários não foram excluídos!",
  "administration.user.delete.error": "O usuário não foi excluído!",
  "administration.user.delete.pk":
    "Falha ao excluir usuário! Existem tarefas vinculadas a este usuário.",

  "administration.users.save.error.differentPass": "As senhas não coincidem",
  "administration.users.save.error.wakePass": "Senha fraca",

  "administration.users.save.deleted": "Usuários excluídos com sucesso!",
  "administration.user.save.deleted": "Usuário excluído com sucesso!",

  "administration.servers.datagrid.server.name": "Nome",
  "administration.servers.datagrid.primary.server": "Primeiro",
  "administration.servers.datagrid.secondary.server": "Segundo",
  "administration.servers.datagrid.authentication.type": "Tipo de Autenticação",
  "administration.servers.datagrid.type.server": "Tipo",
  "administration.servers.form.nas.ip.addresses": "NAS IP Addresses",
  "administration.servers.form.secondary.server": "Segundo Servidor",
  "administration.servers.form.primary.server": "Primeiro Servidor",
  "administration.servers.form.server.error": "Servidores devem ser diferentes",
  "administration.servers.form.already.exists":
    "Já existe um campo com o mesmo nome",
  "administration.servers.form.duplicate.server": "Servidor duplicado",
  "administration.servers.form.settings": "Configurações",
  "administration.servers.form.filter.user": "Filtro de usuário",
  "administration.servers.form.login": "Login",
  "administration.servers.form.password": "Senha",
  "administration.servers.form.ssl": "SSL",
  "administration.servers.form.radius": "Radius",
  "administration.servers.form.ldap": "Ldap",
  "administration.servers.form.base": "Base",
  "administration.servers.form.title.ldap": "servidor LDAP",
  "administration.servers.form.modalAddLdap.help.hostname": "Insira Hostname (FQDN) ou Endereço IP",
  "administration.servers.form.servers.title": "Servidores de sincronismo",
  "administration.servers.form.servers.error.inuse": "Não foi possível excluir o perfil! Servidor em uso",
  "administration.servers.form.modalAddLdap.help.port": "Inserir a Porta do Comunicação",
  "administration.servers.form.modalAddLdap.type": "Opção Certificado ou Login e Senha",
  "administration.servers.form.modalAddLdap.identity.name": "Atributo Nome",
  "administration.servers.form.modalAddLdap.identity.member": "Atributo Membro",
  "administration.servers.form.modalAddLdap.identity.description": "Atributo Descrição",
  "administration.servers.form.modalAddLdap.filter.group": "Filtro de Grupo",
  "administration.servers.form.modalAddLdap.info.ssl": "Para Tipo de autenticação com certificado o checkbox SSL é necessário.",
  "administration.servers.form.login.attribute": "Atributo Login",
  "administration.servers.datagrid.save.success": "Perfil salvo com sucesso",
  "administration.servers.datagrid.edit.success": "Perfil editado com sucesso",
  "administration.servers.action.delete.success":
    "Perfil excluído com sucesso",
  "administration.servers.action.delete.error": "Erro ao excluir perfil",
  "administration.servers.action.create.radius": "Criar Radius",
  "administration.servers.action.create.ldap": "Criar Ldap",
  "administration.servers.action.delete": "Deletar Servidor",
  "administration.servers.action.delete.text":
    "Tem certeza de que deseja excluir?",
  "administration.servers.action.connection.test": "Testar Conexão",
  "administration.servers.action.auth.test": "Testar Autenticação",
  "administration.servers.action.connection.success":
    "Conexão feita com sucesso",
  "administration.servers.action.connection.error": "Erro de conexão",
  "administration.servers.action.auth.success":
    "Autenticação feita com sucesso",
  "administration.servers.action.auth.error": "Erro de autenticação",
  "administration.audit.modal.title": "Visualização de auditoria",

  /* START - Adicionado por Fabio Dias 10/12/200 - PT */
  "administration.identity.user.interface": "Interface de Login padrão",
  "administration.identity.service.provider": "Provedor de Serviço",
  "administration.identity.service.provider.disabled":
    "Provedor de Serviço está desabilitado",
  "administration.identity.saml.enable": "Habilitar",
  "administration.identity.service.name": "Nome do Serviço",
  "administration.identity.service.description": "Descrição do Serviço",
  "administration.identity.url.base": "URL Base",
  "administration.identity.url.base.login": "URL Base Login",
  "administration.identity.url.base.logout": "URL Base Logout",
  "administration.identity.url.base.metadata": "URL Base Metadata",
  "administration.identity.x509.cert": "Certificado",
  "administration.identity.x509.cert.new": "Adicionar Certificado",
  "administration.identity.x509.cert.public":
    "Certificado - Chave Pública (.crt)",
  "administration.identity.x509.cert.private":
    "Certificado - Chave Privada (.key)",
  "administration.identity.x509.cert.pem": "Certificado (.pem)",
  "administration.identity.x509.cert.type": "Tipo do Certificado",
  "administration.identity.x509.cert.type.pem": "(.pem)",
  "administration.identity.x509.cert.type.other": "(.crt/key)",
  "administration.identity.nameid.format": "Identificador de Nome",
  "administration.identity.url.test": "URL de Teste",
  "administration.identity.url.assertion": "URL de Confirmação",
  "administration.identity.url.logout": "URL de Logout",
  "administration.identity.url.metadata": "URL de Metadata",
  "administration.identity.id": "ID da Entidade",
  "administration.identity.sson.url": "URL de serviço de login único",
  "administration.identity.ssoff.url": "URL de serviço de logout único",
  "administration.identity.binding.sso": "SSO Binding",
  "administration.identity.binding.slo": "SLO Binding",
  "administration.identity.binding.post": "Postar",
  "administration.identity.binding.redirect": "Redirecionar",
  "administration.identity.username": "Usuário",
  "administration.identity.email.address": "Endereço de e-mail",
  "administration.identity.user.name": "Atributo do Usuário",
  "administration.identity.user.email": "Atributo do Email",
  "administration.identity.saml.profile": "Atributo do Perfil",
  "administration.identity.user.profile": "Perfis de Usuários do GSM",
  "administration.identity.user.persist": "Persistir Usuário",
  "administration.identity.user.audit": "Auditor",
  "administration.identity.export.metadata":
    "Exportar Metadata do Provedor de Identidade (XML)",
  "administration.identity.import.metadata":
    "Importar Metadata do Provedor de Identidade (XML)",
  "administration.identity.import.file": "Importar Certificado",
  "administration.identity.export.file": "Exportar Certificado",
  "administration.identity.add.file": "Adicionar Certificado",
  "administration.identity.add.certificate":
    "Certificado adicionado com sucesso",
  "administration.identity.add.certificate.fail":
    "Falha ao adicionar certificado",
  "administration.identity.import.certificate":
    "Certificado importado com sucesso",
  "administration.identity.import.certificate.fail":
    "Falha ao importar certificado",
  "administration.identity.import.certificate.invalid":
    "não foi encontrado no certificado",
  "administration.identity.save.certificate.error":
    "Adicione ou importe um certificado antes de baixar",
  "administration.identity.save.success":
    "Provedor de identidade salvo com sucesso",
  "administration.identity.save.error": "Erro ao salvar Provedor de identidade",
  "administration.identity.login.error":
    "Erro no login com o Provedor de Identidade. Por favor, verifique suas configurações.",
  /* END - Adicionado por Fabio Dias 10/12/200 - PT */

  "system.general.timezone.select": "Selecione um fuso horário",
  "system.general.language.select": "Selecione um idioma",
  "system.general.save.success": "Configurações alteradas com sucesso!",
  "system.general.save.disclaimer": "Salvar Termo de Responsabilidade",
  "system.general.save.sessions": "Salvar Sessões",
  "system.general.save.services": "Salvar Serviços",
  "system.general.save.error": "As configurações não foram salvas!",

  "system.general.host.domain.error":
    "O hostname somado ao domínio devem conter no máximo 64 caracteres",
  "system.backupModal.title": "Backup de sistema",
  "system.backupModal.key": "Chave",
  "system.backupModal.confirm": "Confirme a Chave",
  "system.backupModal.error.key": "O campo chave é obrigatório",
  "system.backupModal.error.confirm":
    "O campo de confirmação de chave é obrigatório",
  "system.backupModal.error.duplicate.key": "As chaves precisam ser iguais",
  "system.general.message.disclaimer.pt": "Mensagem - Português Brasileiro",
  "system.general.message.disclaimer.en": "Mensagem - Inglês",
  "system.general.message": "Mensagem",
  "system.restoreModal.title": "Restauração do sistema",
  "system.restoreModal.success": "Sistema restaurado com sucesso!",
  "system.restoreModal.error.invalid": "Chave ou arquivo de backup inválido!",
  "system.restoreModal.key": "Chave",
  "system.restoreModal.file": "Arquivo de Backup",
  "system.restoreModal.error.key": "Campo chave é obrigatório",
  "system.restoreModal.error.file": "O campo Arquivo de backup é obrigatório",
  "system.restoreModal.upload.success": "Arquivo Carregado com Sucesso",
  "system.restoreModal.upload.failed": "Upload de arquivo de falhou",
  "system.restoreModal.upload.error.name":
    "Nome do arquivo não pode conter espaços em branco!",

  "system.updates.connection.success": "Conexão realizada com sucesso",
  "system.updates.connection.error": "Conexão falhou",
  "system.updates.test.connection": "Testar Conexão",
  "system.updates.save.proxy": "Salvar Proxy",
  "system.updates.reload.server": "Recarregar Servidor",
  "system.updates.save.server": "Salvar Servidor",
  "system.updates.confirm.reload.server":
    "Deseja atualizar o sistema e as bases?",
  "system.updates.scheduled.update": "Agendamento da atualização",
  "system.updates.automatically": "Atualizar o sistema automaticamente",
  "system.updates.bases.automatically": "Atualizar as bases automaticamente",
  "system.updates.server.proxy": "Servidor Proxy",
  "system.updates.proxy": "Atualização",

  "system.storages.delete.confirm":
    "Tem certeza de que deseja excluir o armazenamento?",
  "system.storages.delete.confirmMult":
    "Tem certeza de que deseja excluir os seguintes armazenamentos?",
  "system.storage.delete.title": "Confirmar exclusão",

  "system.storages.actions.create.success": "Armazenamento criado com sucesso",
  "system.storages.actions.create.error":
    "O backup de armazenamento não foi salvo",
  "system.storages.actions.delete.success":
    "Armazenamento excluído com sucesso",
  "system.storages.actions.delete.error": "Erro ao excluir armazenamento",
  "system.storages.actions.delete.error.total":
    "{number} item(ns) não foram excluídos. Armazenamento em uso.",

  "system.storages.smb": "Armazenamento SMB",
  "system.storages.nfs": "Armazenamento NFS",
  "system.storages.ssh": "Armazenamento SSH",
  "system.storages.usb": "Armazenamento USB",
  "system.storages.ssh.public.key": "Chave Pública",
  "system.storages.usb.public.key": "Chave Pública",
  "system.storages.sftp.public.key": "Chave Pública",
  "system.storages.ssh.compression": "Compressão",
  "system.storages.sftp.compression": "Compressão",
  "system.storages.usb.compression": "Compressão",
  "system.storages.ssh.copy": "Copiar chave pública",
  "system.storages.sftp.copy": "Copiar chave pública",
  "system.storages.usb.copy": "Copiar chave pública",
  "system.storages.nfs.bytes.reading": "Bytes Leitura",
  "system.storages.nfs.bytes.writing": "Bytes Escrita",
  "system.storages.nfs.bytes.block.size": "Bytes tamanho block",
  "system.storages.nfs.disable.locking": "Disable locking",
  "system.storages.nfs.operation.mode": "Operation Mode",
  "system.storages.nfs.soft": "Soft",
  "system.storages.nfs.hard": "Hard",
  "system.storages.nfs.enable.posix": "Enable posix",
  "system.storages.nfs.extra.options": "Opções Extras",
  "system.storages.add.actions.success": "Armazenamento salvo com sucesso",
  "system.storages.del.actions.success": "Armazenamento excluído com sucesso!",
  "system.virtualDomain.del.actions.success":
    "Domínio Virtual excluído com sucesso!",
  "system.virtualDomain.add.actions.success":
    "Domínio Virtual salvo com sucesso",
  "system.storages.upd.actions.success":
    "Armazenamento atualizado com sucesso!",
  "system.storages.del.actions.error.use":
    "Erro ao deletar. Armazenamento em uso.",
  "system.storages.usb.device_usb": "Dispositivo USB",
  "system.storages.storage.only.logger":
    "O armazenamento está montado na Logger",
  "system.storages.storage.unavailable": "Armazenamento indisponível",
  "system.storages.only.logger": "Somente Logger",

  "system.certificate.save.success": "Certificado salvo com sucesso",
  "system.certificate.save.error": "O certificado não foi salvo",
  "system.certificate.save.settings": "Salvar certificado",

  "license.serial": "Número de série",
  "license.key": "Chave de licença",
  "license.key.required": "Chave de licença é necessária",
  "license.status": "Status da licença",
  "license.expire": "Data de validade",
  "license.registry": "Data de Registro",
  "license.devices": "Número de devices",
  "license.terms.accept": "Aceitar",
  "license.terms.accept.terms.of.use": "Termos de Uso",
  "license.terms.required": "Por favor, aceite os termos e condições!",
  "license.terms.EULA":
    "BLOCKBIT\n" +
    "\n" +
    "CONTRATO DE LICENÇA DE USUÁRIO FINAL\n" +
    "\n" +
    'AO CLICAR EM "CONTINUAR", VOCÊ OU A ENTIDADE QUE REPRESENTA ("LICENCIADO") CONSIDERA INCONDICIONALMENTE QUE SEJA LIMITADO E TORNA-SE PARTE DESTE CONTRATO DE LICENÇA DE USUÁRIO FINAL ("CONTRATO") COM A BLOCKBIT TECNOLOGIA LTDA. ("BLOCKBIT"). SE ESSES TERMOS SÃO CONSIDERADOS UMA OFERTA, A ACEITAÇÃO É EXPRESSAMENTE LIMITADA A ESSES TERMOS. SE O LICENCIADO NÃO CONCORDAR INCONDICIONALMENTE COM O ACIMA EXPOSTO, CLIQUE NO BOTÃO "CANCELAR" E O PROCESSO DE INSTALAÇÃO NÃO CONTINUARÁ. SE CLICAR NO BOTÃO "ACEITAR" PARA CONTINUAR COM A INSTALAÇÃO, VOCÊ ESTÁ REPRESENTANDO E GARANTIDO QUE VOCÊ ESTÁ AUTORIZADO A LIGAR O LICENCIADO.\n' +
    "\n" +
    "\n" +
    "1. Concessão de Licença e Restrições. Sujeito aos termos deste contrato, pagamento de todas as taxas e quaisquer limitações aplicáveis de usuário/uso, o BLOCKBIT concede ao Licenciado um direito pessoal, não sublicenciável e não exclusivo, de usar o software que é diretamente acessível por esse processo de instalação, mas apenas: (i) apenas no formato de código do objeto (“Software”); (ii) em uma máquina especificamente autorizada, localizada em um local de Licenciado autorizado pela BLOCKBIT; e (iii) de acordo com a lista de preços da BLOCKBIT. A BLOCKBIT mantém a propriedade do Software e o Licenciado manterá o aviso de direitos autorais e quaisquer outros avisos que apareçam no Software ou em qualquer mídia que contenha o Software.\n" +
    "2. Atualizações, conteúdo e serviços de suporte. Atualizações, conteúdo e / ou serviços de suporte não são necessariamente fornecidos com o Software e podem exigir pagamento adicional ou incluir termos e condições adicionais. No entanto, na medida em que for fornecida uma atualização para o Software e/ou conteúdo, essa atualização/conteúdo será considerada “Software” fornecido sujeito a este Contrato e deverá ser licenciada para uso somente na máquina específica para a qual foi licenciada. Se serviços de conteúdo/suporte forem fornecidos, a BLOCKBIT se reserva o direito de alterar o escopo ou a duração de tais serviços a qualquer momento e de acessar, usar e distribuir livremente os dados coletados do Licenciado através desses serviços. Se tais serviços forem disponibilizados, o Licenciado poderá ser obrigado a pagar taxas ou outros encargos pelo uso ou acesso a alguns ou todos esses serviços, taxas e termos especificados na fatura ou no formulário de pedido para tal serviço.\n" +
    "3. Restrições. O Licenciado não (e não permitirá que terceiros): (i) fazer engenharia reversa, tentar descobrir qualquer código fonte, ideias ou algoritmos subjacentes do Software; (ii) fornecer, arrendar, emprestar, divulgar, usar para fins de compartilhamento de tempo, agência de serviços ou de outra forma usar ou permitir que outros usem para o benefício de terceiros, o Software (exceto conforme expressamente e especificamente autorizado pela BLOCKBIT); (iii) sem o consentimento prévio e expresso por escrito da BLOCKBIT, realizar qualquer estudo, avaliação comparativa ou análise envolvendo o Software (“Benchmarking”) por qualquer motivo ou finalidade, exceto, na extensão limitada absolutamente necessária, para determinar a adequação do Software para interoperar com os sistemas informáticos internos do Licenciado; (iv) divulgar a terceiros qualquer Benchmarking ou qualquer outra informação relacionada a estes; (v) usar o Software ou qualquer Benchmarking em conexão com o desenvolvimento de produtos que competem com o Software; ou (vi) reproduzir, alterar ou modificar o Software. Antes de descartar qualquer mídia ou aparelho que contenha qualquer parte do Software, o Licenciado deve destruir completamente o Software nele contido. Todas as limitações e restrições do Software neste Contrato também se aplicam à documentação, relatórios e telas. Além disso, o Software licenciado sem encargos ou por um encargo nominal será considerado uma licença de avaliação gratuita e só poderá ser usado para fins de avaliação da obtenção de uma licença paga e não para qualquer uso produtivo. O LICENCIADO RECONHECE QUE O SOFTWARE PODE INCLUIR RECURSOS PARA IMPEDIR O USO APÓS O PERÍODO DE LICENÇA APLICÁVEL E/OU USOS INCONSISTENTES DESTE. O Licenciado reconhece que o Software pode ser distribuído juntamente, conter ou usar determinado software de código aberto ou outro software de terceiros (“Third Party Software”). O SOFTWARE DE TERCEIROS ESTÁ (ALÉM DOS TERMOS E CONDIÇÕES DESTE CONTRATO), SUJEITO E GOVERNADO PELO (E O LICENCIADO CONCORDA E INDENIZARÁ BLOCKBIT POR NÃO CUMPRIMENTO) AS LICENÇAS RESPECTIVAS PARA SOFTWARE DE TERCEIROS. Não são concedidos direitos ou licenças que não sejam expressamente e sem ambiguidade estabelecidos aqui.\n" +
    "4. Confidencialidade. O Software na forma de código-fonte permanece um segredo comercial confidencial da BLOCKBIT e/ou de seus fornecedores. O Software está protegido pelas leis de direitos autorais e outras leis de propriedade intelectual dos Estados Unidos e tratados internacionais. O Licenciado reconhece que, durante o uso do Software, o Licenciado pode obter ou aprender informações relacionadas ao Software, as quais podem incluir, sem limitação, informações relacionadas ao desempenho, confiabilidade ou estabilidade do Software, operação do Software, know-how, técnicas, processos, ideias, algoritmos, design e arquitetura de software (“Informações proprietárias”). Entre as partes, essas informações proprietárias pertencerão exclusivamente à BLOCKBIT. Durante e após a vigência deste Contrato, o Licenciado deve manter a confiança e proteger, e não deve usar (exceto conforme expressamente autorizado por este Contrato) ou divulgar Informações de Propriedade a terceiros.\n" +
    "5. Rescisão. Este Contrato estará em vigor até sua rescisão. O Licenciado pode rescindir este Contrato a qualquer momento, destruindo todas as cópias do Software e documentação relacionada. Este Contrato será rescindido automaticamente se o Licenciado deixar de pagar o valor total faturado pelo Software quando devido ou não cumprir com qualquer termo ou condição deste Contrato, incluindo qualquer tentativa de transferir uma cópia do Software para outra parte, exceto conforme previsto neste contrato. O Licenciado concorda que, com esse término, o Licenciado destruirá todas as cópias do Software e documentação relacionada. Exceto quando expressamente disposto aqui, os termos deste instrumento se manterão independente de qualquer rescisão. A rescisão não é um recurso exclusivo e todas as outras soluções estarão disponíveis, independentemente da rescisão ocorrer ou não.\n" +
    "6. Garantia Limitada e Isenção de Responsabilidade. O LICENCIADO RECONHECE E COMPREENDE QUE O SOFTWARE LICENCIADO DE ACORDO COM ESTE CONTRATO É FORNECIDO 'TAL COMO ESTÁ' SEM QUALQUER GARANTIA QUALQUER RELATIVA À INSTALAÇÃO, USO OU DESEMPENHO DO SOFTWARE.	A BLOCKBIT EXPRESSAMENTE ISENTA E O LICENCIADO CONCEDE EXPRESSAMENTE TODAS AS OUTRAS GARANTIAS, EXPRESSAS OU IMPLÍCITAS, INCLUINDO GARANTIAS DE COMERCIALIZAÇÃO, ADEQUAÇÃO A UMA FINALIDADE ESPECÍFICA, NÃO INFRAÇÃO, INTEGRAÇÃO DO SISTEMA, NÃO INTERFERÊNCIA, PRECISÃO, CONFIABILIDADE E QUALIDADE DO SOFTWARE, INCLUINDO E SEM DERROGAR DO ACIMA, QUAISQUER GARANTIAS E DIREITOS IMPLÍCITOS AO ABRIGO DO CÓDIGO COMERCIAL UNIFORME DOS EUA, UCITA (UNIFORM COMPUTER INFORMATION TRANSACTIONS ACT) E LEI COMUM. A BLOCKBIT E SEUS FORNECEDORES NÃO GARANTEM QUE O SOFTWARE ATENDE AOS REQUISITOS DO LICENCIADO OU QUE A OPERAÇÃO DO SOFTWARE SERÁ ININTERRUPTA OU SEM ERROS. A BLOCKBIT ISENTA-SE AINDA DE RESPONSABILIDADE E O LICENCIADO CONCEDE EXPRESSAMENTE TODAS AS GARANTIAS RELATIVAS AOS RESULTADOS, INFORMAÇÕES, DADOS E QUALQUER CONSELHO FORNECIDO PELO SOFTWARE. ALGUMAS JURISDIÇÕES NÃO PERMITEM A EXCLUSÃO DE GARANTIAS IMPLÍCITAS, POR ISSO A EXCLUSÃO ACIMA PODE NÃO SE APLICAR A ESTAS. A BLOCKBIT não terá nenhuma responsabilidade em substituir a mídia se a falha da mídia resultar de acidente, abuso ou mau uso da mídia. O SOFTWARE É FORNECIDO AO LICENCIADO SEM GARANTIA DE QUALQUER TIPO, EXPRESSA OU IMPLÍCITA, INCLUINDO SEM LIMITAÇÃO, QUALQUER GARANTIA IMPLÍCITA DE COMERCIALIZAÇÃO, ADEQUAÇÃO A UMA FINALIDADE ESPECÍFICA E NÃO INFRACÇÃO.\n" +
    "7. Limitação de responsabilidade. EM NENHUM CASO, BLOCKBIT OU QUALQUER OUTRA PARTE ENVOLVIDA NA CRIAÇÃO, PRODUÇÃO OU ENTREGA DO SOFTWARE SERÃO RESPONSÁVEIS POR QUALQUER DANO INDIRETO, INCIDENTAL OU CONSEQUENCIAL, INCLUINDO SEM LIMITAÇÃO, LUCROS OU DADOS PERDIDOS, MESMO QUE TENHAM SIDO AVISADOS DA POSSIBILIDADE DE TAIS DANOS.\n" +
    '8. Leis anticorrupção. O Licenciado reconhece que está familiarizado e entende as disposições da Lei Anticorrupção do Brasil nº 12.846/2013, Lei contra Práticas de Corrupção no Exterior dos EUA ("FCPA") e da Lei contra Suborno do Reino Unido de 2010 ("UKBA") e concorda em cumprir seus termos, bem como quaisquer disposições da lei local ou das políticas e procedimentos corporativos da BLOCKBIT relacionados a estes. O Licenciado compreende ainda as disposições relacionadas às proibições da Lei Anticorrupção do Brasil, FCPA e UKBA em relação ao pagamento ou doação de qualquer coisa de valor, incluindo, entre outros, pagamentos, presentes, viagens, entretenimento e refeições, direta ou indiretamente, a um funcionário de um governo estrangeiro ou partido político com o objetivo de influenciar um ato ou decisão em sua capacidade oficial ou induzir o funcionário a usar a influência de seu partido com esse governo, para obter ou manter negócios envolvendo o Software. O Licenciado concorda em não violar ou conscientemente permitir que alguém viole a Lei Anticorrupção do Brasil, FCPA ou UKBA, e o Licenciado concorda que nenhum pagamento feito constituirá suborno, influenciar o pagamento, propina, reembolso ou outro pagamento que viole a Lei Anticorrupção do Brasil, FCPA, o UKBA ou qualquer outra lei aplicável anticorrupção ou anti suborno.\n' +
    "9. Avaliação. Não obstante qualquer coisa contrária a este documento, se o Licenciado estiver usando o Software para fins de avaliação, esse uso estará sujeito aos termos e condições de avaliação atuais da BLOCKBIT ou a outros termos mutuamente acordados para governar essa avaliação.\n" +
    "10. Diversos. Nem este acordo nem as licenças concedidas neste documento são atribuíveis ou transferíveis pelo Licenciado (e qualquer tentativa de fazê-lo será anulada). A BLOCKBIT pode ceder, delegar, licenciar e/ou transferir livremente este Contrato, no todo ou em parte, sem consentimento. Este Contrato será considerado como tendo sido feito e deve ser interpretado de acordo com as leis brasileiras, sem levar em consideração conflitos de disposições legais e sem considerar a Convenção das Nações Unidas sobre a Venda Internacional de Bens ou a Lei Uniforme de Transações de Informações sobre Computadores. Sujeito ao acima exposto, as disposições deste instrumento são apenas para benefício das partes e não para qualquer outra pessoa ou entidade. Qualquer notificação, relatório, aprovação, autorização, acordo ou consentimento exigido ou permitido nos termos deste documento deve ser feito por escrito; as notificações devem ser enviadas para o endereço que a parte aplicável tenha ou possa fornecer mediante notificação por escrito ou, se não houver, o endereço mais recente que a parte que enviar a notificação puder localizar usando esforços razoáveis. Nenhuma falha ou atraso no exercício de qualquer direito deste instrumento operará como uma renúncia, nem qualquer exercício parcial de qualquer direito ou poder deste instrumento impedirá o exercício adicional. Se qualquer disposição for julgada por qualquer tribunal de jurisdição competente como inexequível ou inválida, essa disposição será limitada ou eliminada na extensão mínima necessária para que este acordo permaneça em pleno vigor, efeito e força executória. Esta é a declaração completa e exclusiva do entendimento mútuo das partes com relação à licença aqui concedida e substitui e cancela todos os acordos e comunicações escritos e orais anteriores relacionados a essa licença e quaisquer renúncias ou alterações serão efetivas somente se executadas por escrito pela BLOCKBIT; no entanto, quaisquer termos pré-impressos ou padrão de qualquer pedido de compra, confirmação ou formulário similar, a menos que sejam assinados pela BLOCKBIT após a vigência deste instrumento, não terão força ou efeito. A parte substancialmente predominante em qualquer ação para fazer cumprir este contrato terá o direito de recuperar os honorários e custos de seus advogados relacionados a essa ação.\n",

  "update.runUpdateNow": "Atualizar agora",
  "update.version": "Versão",
  "update.scheduled": "Agendado",
  "update.running": "Atualização em progresso",

  "sessions.administration.modal.title": "Sessões do Administrador",
  "sessions.administration.modal.label.start": "Inicio da Sessão",
  "sessions.administration.modal.label.session": "Sessão",

  "sessions.idle": "Tempo limite inativo (minutos)",
  "sessions.login": "Tentativas de Login",
  "sessions.timeout": "Timeout do bloqueio (minutos)",
  "sessions.active": "Sessões Ativas",
  "sessions.block_concurrent_changes": "Bloquear alterações simultâneas",
  "system.sessions.activeModal.title": "Sessões Ativas",
  "system.sessions.datagrid.start": "Iniciar",
  "system.sessions.datagrid.name": "Nome",
  "system.sessions.datagrid.address": "Endereço",
  "system.sessions.datagrid.status": "Status",
  "system.sessions.datagrid.action": "Ação",
  "system.sessions.datagrid.deleteTitle": "Excluir Sessão",
  "system.sessions.datagrid.delete": "Excluir",
  "system.sessions.datagrid.success": "Sessões excluídas com sucesso",
  "system.sessions.datagrid.error": "Erro ao remover a sessão",

  "system.highAvailability.listNos": "Listagem de Interfaces",
  "system.highAvailability.nodeList": "Listagem de nós",
  "system.highAvailability.interfaceFisica": "Interface de Rede Fisica",
  "system.highAvailability.interfaceVirtual": "Interface de Rede Virtual ",
  "sidebar.settings.system.mainNo": "Nó Principal",
  "settings.system.highAvailability.networkHeartbeat": "Interface Heartbeat",
  "settings.system.highAvailability.networkInterfaceLocal": "Interface de Rede Local",
  "settings.system.highAvailability.networkInterfaceRemoto": "Interface de Rede Virtual",
  "sidebar.settings.system.groupInterface": "Grupo de Interface",
  "sidebar.settings.system.protocolUDP": "Utilizar protocolo UDP",
  "sidebar.settings.system.monitor": "Monitoramento",
  "sidebar.settings.system.on": "ON",
  "sidebar.settings.system.perfomance": "Alta Performance",
  "system.highAvailability.create": "Criar Interface",
  "system.highAvailability.remove": "Remover Interface",

  "system.highAvailability.operation_mode": "Modo de Operação",
  "system.highAvailability.secret_key": "Chave Secreta",
  "system.highAvailability.local_key": "Chave Local",
  "system.highAvailability.peer_ip1": "IP Remoto #1",
  "system.highAvailability.peer_ip2": "IP Remoto #2",
  "system.highAvailability.peer_ip3": "IP Remoto #3",
  "system.highAvailability.peer_interface_1": "Heartbeat Interface #1",
  "system.highAvailability.peer_interface_2": "Heartbeat Interface #2",
  "system.highAvailability.peer_interface_3": "Heartbeat Interface #3",
  "system.highAvailability.peer_key": "Chave Remota",
  "system.highAvailability.heartbeat_interval":
    "Intervalo de Heartbeat (segundos)",
  "system.highAvailability.sync_interval": "Intervalo de Sincronismo (minutos)",
  "system.highAvailability.failover_threshold": "Limite de Failover",
  "system.highAvailability.email_notifications": "Notificações de E-mail",
  "system.highAvailability.auto_activation": "Ativação Automática",
  "system.highAvailability.virtual_ip1": "IP Virtual",
  "system.highAvailability.netmask1": "Máscara de Rede",
  "system.highAvailability.virtual_mac1": "Mac Virtual",
  "system.highAvailability.add.actions.success":
    "Cluster Configurado com sucesso",
  "system.highAvailability.verify":
    "Não deve usar esta interface virtual enquanto for uma interface de pulsação",
  "system.highAvailability.sync": "Cluster Sincronizado com sucesso",
  "system.highAvailability.change.key": "Gerar Chave",
  "system.highAvailability.change.copy": "Copiar Chave",
  "system.highAvailability.settings": "Configurações do Cluster",
  "system.highAvailability.interfaces": "Interfaces do Cluster",
  "system.highAvailability.status": "Estado do Cluster",

  "system.highAvailability.local.state": "Estado Local",
  "system.highAvailability.active.uptime": "Tempo Ativo",
  "system.highAvailability.peer.connection": "Conexão Remota",
  "system.highAvailability.peer.state": "Estado do Ponto Remoto",
  "system.highAvailability.syncronization.date": "Data de Sincronização",
  "system.highAvailability.syncronization.status": "Status de Sincronização",
  "system.highAvailability.primary.active": "Primário Ativo",
  "system.highAvailability.secondary.active": "Secundário Ativo",
  "system.highAvailability.standalone.active": "Standalone",
  "system.highAvailability.secondary.standby": "Secundário em Standby",
  "system.highAvailability.primary.standby": "Primário em Standby",
  "system.highAvailability.secondary.done": "Concluído",
  "system.highAvailability.sincronism": "Sincronizar Agora",
  "system.highAvailability.sincronismCluster": "Atualizar Informações",
  "system.highAvailability.active": "Ativar agora",

  "clone.policy.packages": "Clonar Pacote de Políticas",
  "clone.policy.templates": "Clonar Templates de Políticas",
  "clone.device.templates": "Clonar Templates de Device",
  "clone.confirm.message.policy.packages":
    "Selecione a versão desejada para clonar o Pacote de Política:",
  "clone.confirm.message.policy.templates":
    "Selecione a versão desejada para clonar o Templates de Política:",
  "clone.confirm.message.device.templates":
    "Selecione a versão desejada para clonar o Templates de Device:",

  "profile.application-control.title": "Perfil de Application Control",

  "clone.profile.webfilter.title": "Perfil(s) Web Filter",
  "clone.profile.application-control.title": "Perfil(s) Application Control",
  "clone.profile.threat-protection.title": "Perfil(s) Threat Protection",
  "clone.profile.intrusion-prevention.title": "Perfil(s) Intrusion Prevention",
  "clone.profile.ssl.title": "Perfil(s) Inspeção SSL",
  "clone.profile.sd-wan.title": "Perfil(s) SD-WAN",

  "clone.profile.webfilter": "Clonar Perfil de Web Filter",
  "clone.profile.application-control": "Clonar Perfil de Application Control",
  "clone.profile.threat-protection": "Clonar Perfil de Threat Protection",
  "clone.profile.intrusion-prevention": "Clonar Perfil de Intrusion Prevention",
  "clone.profile.ssl-inspection": "Clonar Perfil de Inspeção SSL",
  "clone.profile.sd-wan": "Clonar Perfil de SD-WAN",

  "clone.confirm.message.profile.webfilter":
    "Selecione a versão desejada para clonar o Perfil de Web Filter:",
  "clone.confirm.message.profile.application-control":
    "Selecione a versão desejada para clonar o Perfil de Application Control:",
  "clone.confirm.message.profile.threat-protection":
    "Selecione a versão desejada para clonar o Perfil de Threat Protection:",
  "clone.confirm.message.profile.intrusion-prevention":
    "Selecione a versão desejada para clonar o Perfil de Intrusion Prevention:",
  "clone.confirm.message.profile.ssl-inspection":
    "Selecione a versão desejada para clonar o Perfil de Inspeção SSL:",
  "clone.confirm.message.profile.sd-wan":
    "Selecione a versão desejada para clonar o Perfil de SD-WAN:",

  "navbar.profile": "Perfil",
  "navbar.logout": "Sair",
  "navbar.deploy": "deploy(s)",
  "navbar.deploy.accept": "aceitar",
  "navbar.deploy.running": "em execução",
  "navbar.deploy.pending": "pendente",
  "navbar.deploy.withError": "com erros",
  "navbar.deploy.deploysPanel": "Painel de Deploys",
  "packages.title": "Instalar Pacotes",
  "packages.what": "O que",
  "packages.who": "Quem",
  "packages.where": "Onde",
  "packages.when": "Quando",
  "packages.packageType": "Tipo de Pacote",
  "packages.installType": "Tipo de instalação",
  "packages.package": "Pacote",
  "packages.device": "Devices & Grupo de Devices",
  "packages.dateTime": "Data e hora",
  "packages.assign": "Atribuir a",
  "packages.assign.tome": "Atribuir para mim",
  "packages.comments": "Comentários",
  "users.title": "Usuários",
  "users.tabs.users": "Usuários",
  "users.tabs.groups": "Grupos",
  "users.groups.datagrid.name": "Nome",
  "users.groups.datagrid.type": "Tipo",
  "users.groups.datagrid.deviceName": "Nome do Device",
  "users.groups.datagrid.used": "Usado",
  "users.groups.datagrid.actions": "Ações",
  "users.groups.actions.create": "Criar Grupo",
  "users.groups.actions.delete": "Excluir Grupo",
  "users.groups.modal.title": "Criar Grupo",
  "users.groups.modal.form.name": "Nome",
  "users.groups.modal.form.description": "Descrição",
  "users.groups.modal.form.users": "Usuários",
  "users.groups.modal.form.error.name": "O campo nome é obrigratório",
  "users.groups.modal.form.error.name.exists": "Este nome de grupo já existe",
  "users.groups.modal.form.error.description": "Campo descrição é obrigatório",
  "users.groups.delete.title": "Confirmar exclusão",
  "users.groups.delete.confirm": "Tem certeza de que deseja excluir o grupo?",
  "users.groups.delete.confirmMult":
    "Tem certeza de que deseja excluir os seguintes grupos?",
  "users.groups.messages.saved": "Grupo salvo com sucesso",
  "users.groups.messages.deleted": "Grupos excluídos com sucesso",
  "users.groups.messages.deleted.single": "Grupo excluído com sucesso",
  "users.users.datagrid.login": "Login",
  "users.users.datagrid.name": "Nome",
  "users.users.datagrid.email": "E-mail",
  "users.users.datagrid.device": "Device",
  "users.users.datagrid.used": "Usado",
  "users.users.datagrid.actions": "Ações",
  "users.users.actions.addToGroup": "Adicionar ao Grupo",
  "users.users.messages.success": "Usuários adicionados com sucesso ao grupo",
  "users.addUserGroup.title": "Adicionar usuários ao grupo",
  "users.addUserGroup.placeholder": "Selecione um grupo",
  "devices.title": "Devices",
  "devices.tabs.inventory": "Inventário",
  "devices.tabs.communities": "Comunidades",
  "devices.tabs.templates": "Templates",
  "devices.tabs.provisioning": "Provisionamento",
  "devices.tabs.backups": "Backups",
  "devices.manager.action.automatic.sync.users": "Sincronia automática de usuários",
  "devices.manager.action.automatic.tymeSync": "Tempo de sincronização (horas)",
  "devices.manager.group.delete.success": "Grupo excluído com sucesso",
  "devices.manager.device.delete.success": "Device excluído com sucesso",
  "devices.manager.device.delete.error":
    "Ocorreu um erro ao tentar excluir o dispositivo",
  "devices.manager.device.resetStatus.error":
    "Ocorreu um erro ao tentar atualizar o status dos dispositivos",
  "devices.manager.device.sync.success":
    "Dispositivos sincronizados com sucesso",
  "devices.manager.device.sync.error":
    "Ocorreu um erro ao tentar sincronizar o status dos dispositivos",
  "devices.manager.device.update.error":
    "Ocorreu um erro ao tentar atualizar os dispositivos",
  "devices.manager.device.grid.connError": "ERRO DE CONEXÃO",
  "devices.manager.device.grid.connOk": "CONEXÃO ESTABELECIDA",
  "devices.manager.device.grid.name": "Nome",
  "devices.manager.device.grid.model": "Modelo",
  "devices.manager.device.grid.license_status": "Status da licença",
  "devices.manager.device.grid.version": "Versão",
  "devices.manager.device.grid.template": "Template",
  "devices.manager.device.grid.policy_ipv4": "Política IPv4",
  "devices.manager.device.grid.policy_ipv6": "Política IPv6",
  "devices.manager.device.grid.actions": "Ações",
  "devices.manager.device.grid.actions.export.json": "Exportar para JSON",
  "devices.manager.device.grid.actions.export.csv": "Exportar para CSV",
  "devices.manager.device.grid.actions.createGroup": "Criar Grupo",
  "devices.manager.device.grid.actions.deleteGroups": "Excluir Grupos",
  "devices.manager.device.grid.actions.managerGroups": "Administrar Grupos",
  "devices.manager.managerGroupsModal.title": "Administrar Groups",
  "devices.manager.device.grid.actions.createDevice": "Criar Device",
  "devices.manager.device.grid.actions.deleteDevices": "Excluir Devices",
  "devices.manager.device.grid.actions.reloadStatus": "Recarregar Status",
  "devices.manager.device.grid.actions.synchronizeDevices":
    "Sincronizar Devices",
  "devices.manager.device.grid.actions.updateDevices": "Atualizar Devices",
  "devices.manager.updateModal.title": "Atualizar/Sincronizar Device",
  "devices.manager.updateModal.update": "Atualizar Device",
  "devices.manager.updateModal.sync": "Sincronizar Device",
  "devices.manager.groupModal.title.create": "Adicionar Grupo",
  "devices.manager.groupModal.title.edit": "Editar Grupo",
  "devices.manager.groupModal.name": "Nome",
  "devices.manager.groupModal.description": "Descrição",
  "devices.manager.groupModal.devices": "Devices",
  "devices.manager.groupModal.logger": "Logger",
  "devices.manager.groupModal.successCreate": "Grupo registrado com sucesso!",
  "devices.manager.groupModal.successUpdate": "Grupo atualizado com sucesso!",
  "devices.manager.deviceModal.title.create": "Device",
  "devices.manager.deviceModal.sshkey": "Chave de Deploy",
  "devices.manager.deviceModal.apikey": "Chave de API",
  "devices.manager.deviceModal.useradmin": "Usuário Administrador",
  "devices.manager.deviceModal.adminpasswd": "Senha",
  "devices.manager.deviceModal.group": "Grupo de Device",
  "devices.manager.deviceModal.logger": "Logger",
  "devices.manager.deviceModal.name": "Nome",
  "devices.manager.deviceModal.company": "Empresa",
  "devices.manager.deviceModal.description": "Descrição",
  "devices.manager.deviceModal.model": "Modelo",
  "devices.manager.deviceModal.successCreate": "Device registrado com sucesso!",
  "devices.manager.deviceModal.successUpdate": "Device atualizado com sucesso!",
  "devices.manager.deviceModal.deviceNameAlready": "Device já existe",
  "devices.manager.deviceModal.error.errorExists": "Device já existe",
  "devices.manager.deviceModal.error.errorMax": "Erro máximo (?)",
  "devices.manager.deviceModal.error.errorMaxDevices": "Você atingiu o número máximo de dispositivos para a sua licença.",
  "devices.manager.deviceModal.error.sshkey": "Chave de Deploy é obrigatória",
  "devices.manager.deviceModal.error.apikey": "Chave de API é obrigatória",
  "devices.manager.deviceModal.error.name": "Nome é obrigatório",
  "devices.manager.deviceModal.error.company": "Empresa é obrigatória",
  "devices.manager.deviceModal.error.useradmin":
    "Login do usuário de administração é obrigatório",
  "devices.manager.deviceModal.error.ipexists":
    "Não é possível registrar o mesmo IP para uma interface",
  "devices.manager.deviceModal.error.special.characters":
    "A senha não pode conter os seguintes caracteres especiais: \" & | ; > < ' ",
  "devices.manager.delete.group.title": "Excluir grupo",
  "devices.manager.delete.group.message":
    "Tem certeza de que deseja excluir o grupo {name}?",
  "devices.manager.delete.device.title": "Excluir device",
  "devices.manager.delete.device.message":
    "Tem certeza de que deseja excluir o dispositivo {name}?",
  "devices.manager.delete.group.title.mult": "Excluir grupos",
  "devices.manager.delete.group.message.mult":
    "Tem certeza de que deseja excluir os grupos {name}?",
  "devices.manager.delete.device.title.mult": "Excluir devices",
  "devices.manager.delete.device.message.mult":
    "Tem certeza de que deseja excluir os dispositivos {name}?",

  "devices.community.modalAdd.title": "Criar comunidade",
  "devices.community.modalDelete.title": "Excluir comunidade",
  "devices.community.modalDelete.message":
    "Tem certeza de que deseja excluir a comunidade: {name}?",
  "devices.community.modalDelete.message.plural":
    "Tem certeza de que deseja excluir as seguintes comunidades?",
  "devices.community.create.title": "Criar comunidade",
  "devices.community.edit.title": "Editar comunidade",
  "devices.community.delete.success": "Comunidade excluída com sucesso",
  "devices.community.form.general": "Geral",
  "devices.community.form.general.name": "Nome",
  "devices.community.form.general.description": "Descrição",
  "devices.community.form.general.ike_version": "Versão do IKE",
  "devices.community.form.general.exchange_mode": "Modo de Troca",
  "devices.community.form.general.exchange_mode.aggressive": "Agressivo",
  "devices.community.form.general.exchange_mode.main": "Principal",
  "devices.community.form.general.topology": "Topologia",
  "devices.community.form.general.shared_key": "Chave de Compartilhamento",
  "devices.community.form.card.settings": "Configurações",
  "devices.community.form.save.error": "Device não foi salvo",
  "devices.community.form.save.success": "Device adicionado com sucesso",
  "devices.community.form.delete.device.success": "Device excluído com sucesso",
  "devices.community.form.error.role.already.exists":
    "Esta comunidade já tem um hub",
  "devices.community.form.error.required":
    "Por favor selecione pelo menos dois devices",

  "devices.community.device.grid.actions.addDevice": "Criar device",
  "devices.community.device.grid.actions.removeDevice": "Excluir device",
  "devices.community.device.modal.device": "Device",
  "devices.community.device.modal.listAdd": "Rede",
  "devices.community.device.modal.host": "Host Local",
  "devices.community.device.modal.localId": "ID Local",
  "devices.community.device.modal.role": "Função",
  "devices.community.device.modal.dynamic": "Dinâmico",

  "devices.community.form.success": "Comunidade salva com sucesso",

  "devices.community.form.encryption": "Criptografia",
  "devices.community.form.encryption.phase1": "Fase 1 (IKE)",
  "devices.community.form.encryption.phase2": "Fase 2 (ESP)",
  "devices.community.form.encryption.cryptography_algorithms": "Algoritmo de criptografía",
  "devices.community.form.encryption.dh.group": "DH Grupo",
  "devices.community.form.encryption.pfs.group": "PFS Grupo",
  "devices.community.form.encryption.encryption_algorithms":
    "Algoritmo de Criptografia",
  "devices.community.form.encryption.authentication_algorithms":
    "Algoritmo de Autenticação",
  "devices.community.form.encryption.dh.group_algorithms": "DH Grupo",
  "devices.community.form.encryption.pfs.group_algorithms": "PFS Grupo",
  "devices.community.form.encryption.diffie_hellman":
    "Grupo Diffie-Hellman (DH)",
  "devices.community.form.encryption.esp_encryption_algorithms":
    "Algoritmos de Criptografia ESP",
  "devices.community.form.encryption.esp_authentication_algorithms":
    "Algoritmos de Autenticação ESP",
  "devices.community.form.encryption.perfect_forward":
    "Grupo Perfect Forward Secrecy (PFS)",

  "devices.community.form.advanced": "Avançado",
  "devices.community.form.advanced.ike_lifetime":
    "Lifetime da(s) IKE (segundos)",
  "devices.community.form.advanced.key_lifetime":
    "Lifetime da(s) Key (segundos)",
  "devices.community.form.advanced.keying_tries": "Tentativas de Keying",
  "devices.community.form.advanced.rekey_margin":
    "Margem(s) de Rekey (segundos)",
  "devices.community.form.advanced.dead_peer_action": "Ação do DPD ",
  "devices.community.form.advanced.dead_peer_action.clear": "Limpar",
  "devices.community.form.advanced.dead_peer_action.hold": "Intervalo",
  "devices.community.form.advanced.dead_peer_action.restart": "Reiniciar",
  "devices.community.form.advanced.dead_peer_action.none": "Nenhum",
  "devices.community.form.advanced.dead_peer_delay":
    "Delay do(s) DPD (segundos)",
  "devices.community.form.advanced.dead_peer_timeout":
    "Timeout do(s) DPD (segundos)",
  "devices.community.form.advanced.reauth": "reautenticação",
  "devices.community.form.advanced.fragmentation": "fragmentação",
  "devices.community.form.advanced.compression": "compressão",
  "devices.community.form.advanced.natt": "NAT-T",

  "devices.community.form.general.name.error": "Nome é obrigatório",
  "devices.community.form.general.shared_key.error":
    "Chave compartilhada é obrigatória",
  "devices.community.form.advanced.ike_lifetime.error":
    "Lifetime do IKE é obrigatório",
  "devices.community.form.advanced.key_lifetime.error":
    "Lifetime da key é obrigatória",
  "devices.community.form.advanced.keying_tries.error":
    "Tentativas de Keying é obrigatória",
  "devices.community.form.advanced.rekey_margin.error":
    "Margem de Rekey é obrigatória",
  "devices.community.form.advanced.dead_peer_delay.error":
    "Delay do DPD é obrigatório",
  "devices.community.form.advanced.dead_peer_timeout.error":
    "Timeout do DPD é obrigatório",
  "devices.community.form.advanced.dead_peer_action.error":
    "Ação do DPD é obrigatório",

  "devices.template.title": "Template de Device",
  "devices.template.datagrid.name": "Nome",
  "devices.template.datagrid.description": "Descrição",
  "devices.template.datagrid.version": "Versão",
  "devices.template.datagrid.actions": "Ações",
  "devices.template.actions.create": "Criar Template",
  "devices.template.actions.delete": "Excluir Template",
  "devices.template.actions.clone": "Clonar Template",
  "devices.template.modal.form.title": "Criar Template",
  "devices.template.modal.form.name": "Nome",
  "devices.template.modal.form.version": "Versão",
  "devices.template.modal.form.description": "Descrição",
  "devices.template.modal.delete.success": "Template excluído com sucesso!",
  "devices.template.modal.delete.error": "Erro na exclusão do grupo!",
  "devices.template.modal.clone.success": "Template clonado com sucesso!",
  "devices.template.modal.clone.error": "Erro na clonagem do template!",

  "devices.template.config.title": "Configurar Template",
  "devices.template.tabs.form.template": "Template",
  "devices.template.tabs.form.firewall": "Firewall",
  "devices.template.tabs.form.proxy": "Proxy",
  "devices.template.tabs.form.webcache": "Web Cache",
  "devices.template.tabs.form.webfilter": "Web Filter",
  "devices.template.tabs.form.antimalware": "Antimalware",
  "devices.template.tabs.form.dpi": "Deep Inspection",
  "devices.template.tabs.form.sdwan": "SD-WAN",
  "devices.template.tabs.form.dhcp": "DHCP",
  "devices.template.tabs.form.dns": "DNS",
  "devices.template.tabs.form.ddns": "DDNS",
  "devices.template.config.name": "Nome",
  "devices.template.config.description": "Descrição",
  "devices.template.config.version": "Versão",
  "devices.template.config.modules": "Módulos",
  "devices.template.config.moduleSelect": "Selecionar o módulo",

  "devices.template.firewall.form.services": "Serviços",
  "devices.template.firewall.form.securitysettings":
    "Configurações de segurança",
  "devices.template.firewall.form.timeouts": "Timeouts",
  "devices.template.firewall.form.create.zone": "Zone Protection",
  "devices.template.firewall.actions.create": "Criar Zone Protection",
  "devices.template.firewall.actions.delete": "Excluir Zone Protection",
  "devices.template.firewall.form.zoneprotection": "Nova Zone Protection",
  "devices.template.firewall.form.addzone": "Zona adicionada com sucesso",
  "devices.template.firewall.form.add.dos":
    "Proteção DoS adicionada com sucesso",
  "devices.template.firewall.form.add.ip.spoofing":
    "IP Spoofing adicionado com sucesso",
  "devices.template.firewall.form.addservice": "Serviço adicionado com sucesso",
  "devices.template.firewall.tab.policy": "Política",
  "devices.template.firewall.tab.condition": "Condição",
  "devices.template.firewall.form.enabled": "Habilitado",
  "devices.template.firewall.form.zone": "Zona",
  "devices.template.firewall.form.zones": "Zonas",
  "devices.template.firewall.form.action": "Ação",
  "devices.template.firewall.form.service": "Serviço",
  "devices.template.firewall.form.description": "Descrição",
  "devices.template.firewall.form.authenticated": "Autenticado",
  "devices.template.firewall.form.user": "Usuário",
  "devices.template.firewall.form.group": "Grupo",
  "devices.template.firewall.form.ipv4src": "IP de origem IPv4",
  "devices.template.firewall.form.ipv4dest": "IP de destino IPv4",
  "devices.template.firewall.form.ipv6src": "IP de origem IPv6",
  "devices.template.firewall.form.ipv6dest": "IP de destino IPv6",
  "devices.template.firewall.form.hour": "Hora",
  "devices.template.firewall.form.dos.protection": "Proteção DoS",
  "devices.template.firewall.form.syn.flood": "SYN flood",
  "devices.template.firewall.form.syn.flood.limit":
    "Limite de SYN flood (por segundo).",
  "devices.template.firewall.form.syn.flood.burst": "Burst de SYN flood",
  "devices.template.firewall.form.tcp.flood": "TCP flood",
  "devices.template.firewall.form.tcp.flood.limit":
    "Limite de TCP flood (por segundo).",
  "devices.template.firewall.form.tcp.flood.burst": "Burst de TCP flood",
  "devices.template.firewall.form.udp.flood": "UDP flood",
  "devices.template.firewall.form.udp.flood.limit":
    "Limite de UDP flood (por segundo).",
  "devices.template.firewall.form.udp.flood.burst": "Burst de UDP flood",
  "devices.template.firewall.form.icmp.flood": "ICMP flood",
  "devices.template.firewall.form.icmp.flood.limit":
    "Limite de ICMP flood (por segundo).",
  "devices.template.firewall.form.icmp.flood.burst": "Burst do ICMP flood",
  "devices.template.firewall.form.ip.spoofing": "Proteção contra IP Spoofing",
  "devices.template.firewall.datagrid.description": "Descrição",
  "devices.template.firewall.datagrid.service": "Serviço",
  "devices.template.firewall.datagrid.action": "Ação",
  "devices.template.firewall.datagrid.zone": "Zona",
  "devices.template.firewall.datagrid.auth": "Autenticação",
  "devices.template.firewall.form.lan": "LAN",
  "devices.template.firewall.form.wan": "WAN",
  "devices.template.firewall.form.dmz": "DMZ",
  "devices.template.firewall.form.both.http":
    "HTTP e HTTPS detectados para a mesma porta ou serviço proxy funcional apenas no modo explícito.",
  "devices.template.firewall.form.options": "Opções",
  "devices.template.firewall.all": "TODOS",
  "devices.template.firewall.error.zone": "Selecione ao menos uma das zonas",
  "devices.template.firewall.error.option": "Selecione ao menos uma das opções",
  "devices.template.firewall.burst.rate": "Taxa de explosão (pacotes/segundo)",
  "devices.template.firewall.packet.rate": "Taxa de pacotes (pacotes/segundo)",

  "devices.template.proxy.form.interface":
    "É necessária pelo menos uma interface ETH",
  "devices.template.proxy.form.sslexception": "Exceção SSL",
  "devices.template.proxy.form.disablessl":
    "Desativar a inspeção SSL no serviço de Proxy",
  "devices.template.proxy.form.required": "É obrigatório",
  "devices.template.proxy.form.invalid": "É inválido",
  "devices.template.proxy.form.port": "Porta",
  "devices.template.proxy.form.ssl": "SSL",
  "devices.template.proxy.form.type": "Tipo",
  "devices.template.proxy.form.port21": "Porta 21",
  "devices.template.proxy.form.port22": "Porta 22",
  "devices.template.proxy.form.malwareScanning": "Verificação de Malware",
  "devices.template.proxy.form.port25": "Porta 25",
  "devices.template.proxy.form.port465": "Porta 465",
  "devices.template.proxy.form.port587": "Porta 587",
  "devices.template.proxy.form.addheader": "Adicionar cabeçalho",
  "devices.template.proxy.form.port110": "Porta 110",
  "devices.template.proxy.form.port995": "Porta 995",
  "devices.template.proxy.form.spamassassin-active": "Filtro de Spam (0~10)",
  "devices.template.proxy.form.spamassassin-value": "Valor entre 0 e 10",
  "devices.template.proxy.form.emailSubject": "Assunto do e-mail",
  "devices.template.proxy.form.emailTemplate": "Modelo de E-mail",
  "devices.template.proxy.form.explicit.proxy": "Proxy explícito",
  "devices.template.proxy.form.explicit.proxy.warning":
    "Para que a funcionalidade do Proxy Explícito funcione corretamente, regras de Zone Protection que por ventura utilizem o mesmo Serviço também devem estar habilitadas",
  "devices.template.proxy.form.explicit.proxy.warning.message.part1": "A regra de Zone Protection nomeada ",
  "devices.template.proxy.form.explicit.proxy.warning.message.part2": " também utiliza o serviço nomeado de ",
  "devices.template.proxy.form.explicit.proxy.warning.message.part3": " e está desativada. Habilite a regra mencionada para que o Proxy Explícito funcione corretamente.",
  "devices.template.proxy.form.explicit.proxy.warning.message.part4": "O serviço selecionado para o Proxy Explícito não é utilizado em nenhuma regra de Zone Protection existente. Para que o Proxy Explícito funcione corretamente é necessário que uma regra de Zone Protection com o serviço seja criada e esteja habilitada.",
  "devices.template.proxy.form.explicit.proxy.warning.message.part5": "Regra de Zone Protection associada:",
  "devices.template.proxy.form.authentication.mode": "Modo de autenticação",
  "devices.template.proxy.form.authentication.mode.basic": "Básico",
  "devices.template.proxy.form.autentication.mode.captive": "Captive Portal",
  "devices.template.proxy.form.modal.error.rule.exists": "Esta regra já existe",

  "devices.template.antimalware.form.detect":
    "Detectar aplicativos potencialmente indesejados",
  "devices.template.antimalware.form.block": "Bloquear arquivos criptografados",
  "devices.template.antimalware.form.heuristic": "Habilitar Analises Comportamental e Dinâmica",
  "devices.template.antimalware.form.passive": "Modo passivo",
  "devices.template.antimalware.form.filesize": "Tamanho máximo do arquivo",
  "devices.template.antimalware.form.quarantine": "Tamanho da quarentena",
  "devices.template.antimalware.form.dayin": "Dias em quarentena",

  "devices.template.webfilter.form.custom": "Personalizar página de bloqueio",
  "devices.template.webfilter.form.blocking.message":
    "A configuração do controle de acesso impede que sua solicitação seja permitida no momento. Por favor, entre em contato com seu provedor de serviços se achar que isso está incorreto.",
  "devices.template.webfilter.form.customnewlogo": "Novo Logo",
  "devices.template.webfilter.form.customblock": "Mensagem de bloqueio",
  "devices.template.webfilter.form.customredirect":
    "Redirecionar para página externa",
  "devices.template.webfilter.form.hostname": "Nome do Host",
  "devices.template.webfilter.form.googledomains": "Domínios Google",
  "devices.template.webfilter.form.googleenabled": "Habilitado",
  "devices.template.webfilter.form.googleaddress": "Endereço IP",
  "devices.template.webfilter.form.googlegroups": "Grupos",
  "devices.template.webfilter.form.googleusers": "Usuários",
  "devices.template.webfilter.form.safe": "Safe search",
  "devices.template.webfilter.form.safeenabled": "Habilitado",
  "devices.template.webfilter.form.safeaddress": "Endereço IP",
  "devices.template.webfilter.form.safegroups": "Grupos",
  "devices.template.webfilter.form.safeusers": "Usuários",

  "devices.template.webcache.form.size": "Tamanho do cache na memória",
  "devices.template.webcache.form.maximum":
    "Tamanho máximo do objeto na memória",
  "devices.template.webcache.form.disk": "Tamanho do cache do disco",
  "devices.template.webcache.form.minimum": "Tamanho mínimo do objeto no disco",
  "devices.template.webcache.form.dynamic": "Cache de conteúdo dinâmico",
  "devices.template.webcache.form.exception": "Cache de exceção",

  "devices.template.dns.form.configuration": "Configuração",
  "devices.template.dns.form.dnsservers": "Servidores DNS",
  "devices.template.dns.form.interfaces": "Interfaces",
  "devices.template.dns.form.dnscache": "Cache DNS",
  "devices.template.dns.form.security": "Segurança",
  "devices.template.dns.form.rebind": "Proteção contra Revinculação",
  "devices.template.dns.form.allowlocal": "Permitir Local",
  "devices.template.dns.form.allowdomains": "Domínios permitidos",
  "devices.template.dns.form.redirection": "Redirecionamento",
  "devices.template.dns.modal.title": "Novo redirecionamento",
  "devices.template.dns.modal.server": "Servidor DNS",
  "devices.template.dns.modal.redirect": "Redirecionar endereço",
  "devices.template.dns.datagrid.server": "Servidor DNS",
  "devices.template.dns.save.success": "Servidor adicionado com sucesso",
  "devices.template.dns.actions.create": "Criar Servidor",
  "devices.template.dns.actions.delete": "Excluir Servidor",

  "devices.template.dpi.modal.titleProfile": "Perfil DPI",
  "devices.template.dpi.modal.titleWhite": "Endereços Liberados",
  "devices.template.dpi.modal.titleBlack": "Endereços Bloqueados",
  "devices.template.dpi.modal.error.delete.profile":
    "Não é possível excluir {nome}. Perfil em uso no Zone Protection.",
  "devices.template.dpi.modal.form.error.name.exists":
    "Um perfil com esse nome já existe.",
  "devices.template.dpi.delete.success": "Perfil excluído com sucesso",
  "devices.template.dpi.delete.error": "Erro no perfil excluído!",
  "devices.template.dpi.delete.error.inUse":
    "Não foi possível excluir o perfil! Perfil em uso",
  "devices.template.dpi.datagrid.profiles": "Perfis",
  "devices.template.dpi.datagrid.name": "Nome",
  "devices.template.dpi.datagrid.type": "Tipo",
  "devices.template.dpi.datagrid.whitelist": "Endereços Liberados",
  "devices.template.dpi.datagrid.blacklist": "Endereços Bloqueados",
  "devices.template.dpi.datagrid.actions": "Ações",
  "devices.template.dpi.datagrid.status": "Status",
  "devices.template.dpi.datagrid.block": "Bloqueio",
  "devices.template.dpi.datagrid.risk": "Risco",
  "devices.template.dpi.datagrid.quarantine": "Quarentena",
  "devices.template.dpi.datagrid.signature": "Assinatura",
  "devices.template.dpi.datagrid.ip.address": "Endereço IP",
  "devices.template.dpi.datagrid.direction": "Direção",
  "devices.template.dpi.datagrid.category": "Categoria",
  "devices.template.dpi.datagrid.hight": "Alto",
  "devices.template.dpi.datagrid.medium": "Médio",
  "devices.template.dpi.datagrid.low": "Baixo",
  "devices.template.dpi.datagrid.required.fields":
    "Todos os campos são obrigatórios",
  "devices.template.dpi.datagrid.already.exists": "Exceção já existe",
  "devices.template.dpi.profile.name": "Nome",
  "devices.template.dpi.profile.description": "Descrição",
  "devices.template.dpi.profile.type": "Tipo",
  "devices.template.dpi.profile.process": "Processo",
  "devices.template.dpi.profile.devin": "Input na Interface",
  "devices.template.dpi.profile.devout": "Output da Interface",
  "devices.template.dpi.profile.intrusionPrevention": "Intrusion Prevention",
  "devices.template.dpi.profile.advancedProtection":
    "Advanced Threat Protection",
  "devices.template.dpi.profile.applicationControl": "Application Control",
  "devices.template.dpi.profile.automaticRules":
    "Habilitar atualização automática de regras",
  "devices.template.dpi.profile.allPorts": "Inspecionar todas as portas",
  "devices.template.dpi.list.ipmask": "IP/MASK",

  "devices.template.sdwan.modal.title": "Perfil SD-WAN",
  "devices.template.sdwan.tab.interface": "Interfaces",
  "devices.template.sdwan.tab.monitor": "Monitor",
  "devices.template.sdwan.actions.createProfile": "Criar Perfil",
  "devices.template.sdwan.actions.deleteProfile": "Excluir Perfil",
  "devices.template.sdwan.save.successProfile": "Perfil salvo com sucesso",
  "devices.template.sdwan.save.errorProfile": "O perfil não foi salvo",
  "devices.template.sdwan.modal.form.error.name.exists":
    "Um perfil com esse nome já existe.",
  "devices.template.sdwan.delete.success": "Perfil excluído com sucesso",
  "devices.template.sdwan.delete.error": "Erro no perfil excluído!",
  "devices.template.sdwan.delete.error.inUse":
    "Não foi possível excluir o perfil! Perfil em uso",
  "devices.template.sdwan.datagrid.profiles": "Perfis",
  "devices.template.sdwan.datagrid.name": "Nome",
  "devices.template.sdwan.datagrid.description": "Descrição",
  "devices.template.sdwan.datagrid.version": "Versão",
  "devices.template.sdwan.datagrid.type": "Tipo",
  "devices.template.sdwan.datagrid.interfaces": "Interfaces",
  "devices.template.sdwan.datagrid.actions": "Ações",
  "devices.template.sdwan.form.name": "Nome",
  "devices.template.sdwan.form.version": "Versão",
  "devices.template.sdwan.form.description": "Descrição",
  "devices.template.sdwan.form.type": "Tipo",
  "devices.template.sdwan.form.interfaces": "Interfaces",
  "devices.template.sdwan.form.monitorInterval":
    "Intervalo de monitoramento (seg)",
  "devices.template.sdwan.form.balancingInterval":
    "Intervalo de balanceamento (min)",
  "devices.template.sdwan.form.failRatio": "Taxa de falhas (1 - 100%)",
  "devices.template.sdwan.form.bandwidth": "Bandwidth (Mbps)",
  "devices.template.sdwan.form.qualityCriteria": "Critério de qualidade (Mbps)",
  "devices.template.sdwan.form.persistentConn": "Conexão persistente",
  "devices.template.sdwan.form.persistenceTimeout":
    "Timeout da presistência 1-1440 minutos",
  "devices.template.sdwan.form.persistenceTimeoutReduce":
    "Timeout da persistência 1-1440 minutos",
  "devices.template.sdwan.form.loadbalance": "Load Balance",
  "devices.template.sdwan.form.valueJitter": "Jitter",
  "devices.template.sdwan.form.valueLatency": "Latência",
  "devices.template.sdwan.form.valuePacketLoss": "Perda de Pacotes",
  "devices.template.sdwan.form.valueBandwidth": "Limite de Banda",
  "devices.template.sdwan.form.address": "Endereço",
  "devices.template.sdwan.form.protocol": "Protocolo",
  "devices.template.sdwan.form.attempts": "Tentativas",
  "devices.template.sdwan.form.timeout": "Timeout",
  "devices.template.sdwan.form.performance": "Indicadores de Performance",
  "devices.template.sdwan.form.monitoring": "Alvos de Monitoramento",
  "devices.template.sdwan.form.error.loadbalance.invalid":
    "Loadbalance total inválido",
  "devices.template.sdwan.form.error.interface.invalid":
    "Por favor, selecione uma interface",
  "devices.template.sdwan.form.error.address": "Endereço Inválido",
  "devices.template.sdwan.form.modal.error.rule.exists":
    "Este endereço já existe",
  "devices.template.sdwan.form.failback": "Failback",
  "devices.template.sdwan.form.device-description": "Device Description",
  "devices.template.sdwan.form.packet-duplication": "Packet Duplication",
  "devices.template.sdwan.form.load-balance": "Load Balance",

  "devices.template.ssl.modal.title": "Perfil SSL",
  "devices.template.ssl.form.name": "Nome",
  "devices.template.ssl.form.settings.workers": "Número de Workers",
  "devices.template.ssl.form.limit": "Número de CPUs disponíveis excedido",
  "devices.template.ssl.form.min": "O número mínimo de Workers é 1",
  "devices.template.ssl.form.version": "Versão",
  "devices.template.ssl.form.description": "Descrição",
  "devices.template.ssl.form.mode": "Modo",
  "devices.template.ssl.form.protocols": "Protocolo",
  "devices.template.ssl.form.exception": "Exceção de inspeção",
  "devices.template.ssl.form.dictionary": "Dicionário",
  "devices.template.ssl.datagrid.name": "Nome",
  "devices.template.ssl.datagrid.description": "Descrição",
  "devices.template.ssl.datagrid.version": "Versão",
  "devices.template.ssl.datagrid.mode": "Modo",
  "devices.template.ssl.datagrid.actions": "Ações",
  "devices.template.ssl.save.successProfile": "Perfil salvo com sucesso",
  "devices.template.ssl.save.errorProfile": "Perfil não foi salvo",
  "devices.template.ssl.delete.success": "Perfil excluído com sucesso",
  "devices.template.ssl.delete.error": "Erro no perfil excluído",
  "devices.template.ssl.delete.error.inUse":
    "Não foi possível excluir o perfil! Perfil em uso",

  "devices.template.sdwan.modal.titleService": "Serviço SD-WAN",
  "devices.template.sdwan.actions.createService": "Criar serviço",
  "devices.template.sdwan.actions.deleteService": "Excluir serviço",
  "devices.template.sdwan.save.successService":
    "Serviço adicionado com sucesso",
  "devices.template.sdwan.form.enable": "Habilitar",
  "devices.template.sdwan.form.service": "Serviço",
  "devices.template.sdwan.form.dstAddress": "Endereço IP de Destino",
  "devices.template.sdwan.form.profile": "Perfil",
  "devices.template.sdwan.actions.delete.service":
    "Tem certeza de que deseja excluir",

  "devices.template.dhcp.datagrid.servers": "Servidores",
  "devices.template.dhcp.datagrid.interface": "Interface",
  "devices.template.dhcp.datagrid.type": "Tipo",
  "devices.template.dhcp.datagrid.range": "Range",
  "devices.template.dhcp.datagrid.relay": "Relay",
  "devices.template.dhcp.datagrid.actions": "Ações",
  "devices.template.dhcp.modal.titleServer": "Servidor DHCP",
  "devices.template.dhcp.modal.titleRange": "Range DHCP",
  "devices.template.dhcp.modal.titleRelay": "Relay DHCP",

  "devices.template.dhcp.modal.interface": "Interface",
  "devices.template.dhcp.modal.description": "Descrição",
  "devices.template.dhcp.modal.type": "Tipo",
  "devices.template.dhcp.modal.gateway": "Gateway",
  "devices.template.dhcp.modal.dnsSufix": "Sufixo DNS",
  "devices.template.dhcp.modal.renewaltime": "Tempo de renovação (Segundos)",
  "devices.template.dhcp.modal.dns": "DNS",
  "devices.template.dhcp.modal.wins": "WINS",
  "devices.template.dhcp.modal.tftp": "TFTP Server (opção 150)",
  "devices.template.dhcp.modal.rangeini": "Início do Range",
  "devices.template.dhcp.modal.rangeend": "Fim do Range",
  "devices.template.dhcp.modal.macfilter": "MAC Filter",
  "devices.template.dhcp.modal.ipv4server": "Servidor IPV4",
  "devices.template.dhcp.modal.ipv6server": "Servidor IPV6",
  "devices.template.dhcp.modal.enableDhcp": "Habilitar DHCP",
  "devices.template.dhcp.modal.renewaltime.invalid": "Tempo de renovação inválido!",

  "devices.template.dhcp.actions.createServer": "Criar Servidor",
  "devices.template.dhcp.actions.deleteServer": "Excluir Servidor",
  "devices.template.dhcp.actions.createRange": "Criar Range",
  "devices.template.dhcp.actions.deleteRange": "Excluir Range",
  "devices.template.dhcp.actions.createRelay": "Criar Relay",
  "devices.template.dhcp.actions.deleteRelay": "Excluir Relay",
  "devices.template.dhcp.actions.remove.text": "Tem certeza de que deseja excluir?",

  "devices.service.dhcp.settings.authentication.radius": "Autenticação RADIUS",
  "devices.service.dhcp.settings.adress.static": "Endereços estáticos",
  "devices.service.dhcp.settings.import.static.title": "Importar Endereços Estáticos",
  "devices.service.dhcp.settings.import.static.add": "Adicionar Host",
  "devices.service.dhcp.settings.import.static.edit": "Editar Host",
  "devices.service.dhcp.settings.range.edit": "Editar Range",
  "devices.service.dhcp.settings.range.add": "Adicionar Range",
  "devices.service.dhcp.settings.range.settings": "Configuração Range",
  "devices.service.dhcp.settings.win.primary": "WINS Primário",
  "devices.service.dhcp.settings.win.secudary": "WINS Secundário",
  "devices.service.dhcp.settings.tftp.primary": "TFTP Primário",
  "devices.service.dhcp.settings.tftp.secudary": "TFTP Secundário",
  "devices.service.dhcp.add.server.noDevice": "Nenhuma interface disponível, verifique as Configurações de Rede.",
  "devices.service.dhcp.add.server.select.interface": "Por favor selecione uma interface!",
  "devices.service.dhcp.add.server.select.type": "tipo de IP",
  "devices.service.dhcp.add.Relay.title.add": "Adicionar Relay",
  "devices.service.dhcp.add.Relay.title.edit": "Edite Relay",
  "devices.service.dhcp.add.Relay.server.ipv6": "Servidores IPv6",
  "devices.service.dhcp.add.Relay.server.ipv4": "Servidores IPv4",
  "devices.service.dhcp.lease.remove": "Você tem certeza que deseja excluir o(s) seguinte(s) Lease(s)?",
  "devices.service.dhcp.datagrid.options.title": "Opções adicionais de DHCP",
  "devices.service.dhcp.modal.options.title.add": "Criar uma nova opção DHCP",
  "devices.service.dhcp.modal.options.title.edit": "Editar opções DHCP",
  "devices.service.dhcp.modal.options.label.code": "Código de opção",
  "devices.service.dhcp.modal.options.placeholder.value": "Digite o Valor",
  "devices.service.dhcp.modal.options.code": "Código",
  "devices.service.dhcp.modal.options.code.error": "O Código customizado deve ser inteiro",
  "devices.service.dhcp.modal.options.info.redirect": "*Ao aplicar a fila o serviço do DHCP, será reiniciado, para verificar seu estado clique aqui.",

  "devices.service.dhcp.message.relay.setting": "Relay DHCP configurado!",
  "devices.service.dhcp.message.no.range": "Range não configurado! Configure um range antes de salvar.",
  "devices.service.dhcp.message.value.integer": "O valor de tempo para lease deve ser inteiro!",
  "devices.service.dhcp.message.ipRadius.required": "O Campo de IP do Radius é obrigatório!",
  "devices.service.dhcp.message.secret.Radius.required": "O Campo de Segredo do Radius é obrigatório!",
  "devices.service.dhcp.message.range.delete.sucess": "Range deletado com sucesso!",
  "devices.service.dhcp.message.object.interface": "Erro! Não se pode editar endereço de interface.",
  "devices.service.dhcp.message.invalid.range": "Intervalo inválido! O Range final deve ser maior que o inicial!",
  "devices.service.dhcp.message.invalid.ranges": "Ranges inválidos!",
  "devices.service.dhcp.message.invalid.ranges.out": "Endereço IP da interface não encontra dentro do range selecionado!",
  "devices.service.dhcp.message.invalid.ranges.AlreadyExists": "Range contido em outro cadastrado!",
  "devices.service.dhcp.message.invalid.ranges.out.interface": "Gateway incorreto: fora do range da interface!",
  "devices.service.dhcp.message.invalid.ranges.broadcast": "Gateway incorreto: endereço de rede ou broadcast!",
  "devices.service.dhcp.message.invalid.mac": "Erro no mac informado!",
  "devices.service.dhcp.message.range.save.sucess": "Range Salvo com sucesso!",
  "devices.service.dhcp.message.static.Already.used": "Host já está sendo usado em endereços estáticos!",
  "devices.service.dhcp.message.static.ip.Already.used": "IP já está sendo usado em endereços estático!",
  "devices.service.dhcp.message.static.mac.Already.used": "Mac já está sendo usado em endereços estáticos!",
  "devices.service.dhcp.message.static.not.subnet": "Endereço IP não pertence a subnet!",
  "devices.service.dhcp.message.import.empty": "importação cancelada! Arquivo vazio!",
  "devices.service.dhcp.message.fields": "Importação cancelada! erro nos campos: ",
  "devices.service.dhcp.message.fields.host": "Importação cancelada! Duplicação do Host Name: ",
  "devices.service.dhcp.message.fields.ip": "Importação cancelada! Duplicação do IP: ",
  "devices.service.dhcp.message.fields.mac": "Importação cancelada! Duplicação do Mac Addess: ",
  "devices.service.dhcp.message.import.sucess": " registros Importados com sucesso!",
  "devices.service.dhcp.message.line": "na linha: ",
  "devices.service.dhcp.message.used.radius": "Atenção! Trocar o servidor DHCP pode gerar conflito de IP.",

  "devices.template.ddns.form.dynamicDNS": "DNS Dinâmico",
  "devices.template.ddns.modal.title": "Novo Host",
  "devices.template.ddns.actions.create": "Criar Host",
  "devices.template.ddns.actions.delete": "Excluir Host",
  "devices.template.ddns.datagrid.service": "Serviço",
  "devices.template.ddns.datagrid.host": "Host",
  "devices.template.ddns.datagrid.interface": "Interface",
  "devices.template.ddns.datagrid.user": "Usuário",
  "devices.template.ddns.datagrid.password": "Senha",
  "devices.template.ddns.datagrid.actions": "Ação",
  "devices.template.ddns.save.success": "Host adicionado com sucesso",

  "devices.template.custom.branding": "Custom Branding",
  "devices.template.custom.custom": "Personalizar",
  "devices.template.custom.title": "Título da página",
  "devices.template.custom.favicon": "Favicon",
  "devices.template.custom.favicon.recommended": "Recomendado PNG ou ICO 32x32",
  "devices.template.custom.logo": "Logotipo",
  "devices.template.custom.logo.recommended": "Recomendado SVG 300x65",
  "devices.template.custom.background": "Background",
  "devices.template.custom.background.recommended":
    "Recomendado PNG ou JPG 1920x1080",
  "devices.template.custom.upload": "Clique para upload",
  "devices.template.custom.preview": "Pré-visualização",
  "devices.template.custom.restore": "Restaurar padrão",
  "devices.template.custom.restore.confirm":
    "Você confirma a restauração do padrão de fábrica?",
  "devices.template.custom.color": "Cor",
  "devices.template.custom.upload.error.size":
    "Arquivo precisa ser menor do que 2MB",
  "devices.template.custom.upload.error.dimension":
    "As dimensões da imagem não estão seguindo o recomendado.",
  "devices.template.custom.color.menu_section_bg_color": "Seção",
  "devices.template.custom.color.menu_section_color": "Fonte Seção",
  "devices.template.custom.color.menu_selected_bg_color": " Selecionado",
  "devices.template.custom.color.menu_selected_color": "Fonte Selec",
  "devices.template.custom.color.menu_open_bg_color": "Aberto",
  "devices.template.custom.color.menu_open_color": "Fonte Aberto",
  "devices.template.custom.color.menu_open_hover_color": "F Aberto Selec",
  "devices.template.custom.color.menu_bg_color": "Menu",
  "devices.template.custom.color.menu_color": "Fonte Menu",
  "devices.template.custom.color.menu_base_bg_color": "Base",

  "devices.profiles.intrusion.prevention.form.name": "Nome",
  "devices.profiles.intrusion.prevention.form.version": "Versão",
  "devices.profiles.intrusion.prevention.form.description": "Descrição",
  "profiles.intrusionprevention.error.processes.limit":
    "Limite do processo atingido",

  "devices.template.provisioning": "Provisionamento de template",
  "devices.template.provisioning.add.batch": "Provisionamento em Lote",
  "devices.template.provisioning.file": "Arquivo",
  "devices.template.provisioning.line": "Linha",
  "devices.template.provisioning.view.uuid": "UUID com erro",
  "devices.template.provisioning.name.and.uuid": "Nome e UUID",
  "devices.template.provisioning.import.file": "Fr arquivo",
  "devices.template.provisioning.download.file": "Download modelo",
  "devices.import-rule.error.file": "Arquivo inválido",
  "devices.template.provisioning.return": "Back",
  "devices.template.provisioning.import.success":
    "{number} item(s) importado(s) com sucesso",
  "devices.template.provisioning.import.error": "Erro ao importar lote",
  "devices.template.provisioning.import.error.check.file":
    "Erro ao importar lote. Verifique seu arquivo de importação.",
  "devices.template.provisioning.batch.import.error":
    "Não foi possível importar o lote",
  "devices.template.provisioning.delete.batch": "Excluir lote",
  "devices.template.provisioning.delete.unique": "Excluir",
  "devices.template.provisioning.error.duplicate.eth": "ETH duplicada",
  "devices.template.provisioning.error.duplicate.uuid": "UUID duplicado",
  "devices.template.provisioning.error.duplicate.name": "Nome duplicado",
  "devices.template.provisioning.error.errorexists":
    "Nome ou UUID já cadastrados",
  "devices.template.provisioning.error.validate.error": "Campo inválido",
  "devices.template.provisioning.error.field": "Campo vazio",
  "devices.template.provisioning.status.costumer": "Erro Customer ID",
  "devices.template.provisioning.status.used": "Licença em uso",
  "devices.template.provisioning.status.expired": "Data de validade expirada",
  "devices.template.provisioning.status.found": "Licença não existe",
  "devices.template.provisioning.status.inactive": "Licença inativa",
  "devices.template.provisioning.error.file.csv":
    "Você só pode fazer upload de arquivos CSV",

  "devices.backups.create": "Criar backup",
  "devices.backups.delete": "Excluir backup",
  "devices.backups.last.backup": "Último backup",
  "devices.backups.last.status": "Último status",
  "devices.backups.next.backup": "Próximo backup",
  "devices.backups.backup.details": "Detalhe dos backups",
  "devices.backups.backup.history": "Histórico de backups",
  "devices.backups.status.error.disk": "Erro no armazenamento",
  "devices.backups.status.error.disk.full": "Armazenamento cheio",
  "devices.backups.backup.system": "Sistema",
  "devices.backups.backup.snapshot": "Snapshot",
  "devices.backups.backup.remote.storage": "Armazenamento Remoto",
  "devices.backups.backup.retention.backup": "Número de Backups Retidos",
  "devices.backups.backup.retention.percent": "Porcentagem de Espaço em Disco",
  "devices.backups.backup.schedule": "Agendamento",
  "devices.backups.backup.select.type": "Selecione um tipo",
  "devices.backups.backup.select.device": "Selecione um device",
  "devices.backups.backup.select.device.group": "Selecione um grupo de devices",
  "devices.backups.backup.devices": "Devices",
  "devices.backups.backup.devices.group": "Grupo de Devices",
  "devices.backups.schedule.disabled": "Desabilitado",
  "devices.backups.schedule.oneshot": "Uma vez",
  "devices.backups.schedule.daily": "Diariamente",
  "devices.backups.schedule.weekly": "Semanalmente",
  "devices.backups.schedule.monthly": "Mensalmente",
  "devices.backups.schedule.month.day": "Dia do mês",
  "devices.backups.schedule.week.day": "Dia da semana",
  "devices.backups.schedule.date.time": "Data e hora",
  "devices.backups.action.save.success": "Backup salvo com sucesso",
  "devices.backups.action.running.success": "O backup está sendo executado",
  "devices.backups.action.save.error": "Erro ao salvar backup",
  "devices.backups.action.delete.success": "Backup(s) excluído(s) com sucesso",
  "devices.backups.action.delete.error": "Erro ao excluir backup",
  "devices.backups.action.delete.storage.error":
    "Erro ao excluir backup. Armazenamento indisponível.",
  "devices.backups.action.restore.success":
    "Aguarde. Seu backup está em processo de restauração.",
  "devices.backups.action.restore.success.manager":
    "Backup restaurado com sucesso",
  "devices.backups.action.restore.already.exists":
    "Aguarde. Já existe um backup em processo de restauração",
  "devices.backups.action.restore.error.encryption.key":
    "Erro ao restaurar backup. Segredo inválido.",
  "devices.backups.action.restore.error": "Erro ao restaurar backup",
  "devices.backups.action.disabled.success": "Backup desabilitado com sucesso",
  "devices.backups.action.disabled.error": "Erro ao desabilitar backup",
  "devices.backups.action.enabled.success": "Backup habilitado com sucesso",
  "devices.backups.action.enabled.error": "Erro ao habilitar backup",
  "devices.backups.action.stop.success": "Backup parado com sucesso",
  "devices.backups.action.stop.error": "Erro ao parar backup",
  "devices.backups.action.duplicate.error": "Campo duplicado",
  "devices.backups.action.already.exists": "Nome de backup já criado",
  "devices.backups.action.disabled": "Desabilitar backup",
  "devices.backups.action.enabled": "Habilitar backup",
  "devices.backups.status.success": "Sucesso",
  "devices.backups.status.stopped": "Parado",
  "devices.backups.status.partial": "Parcial",
  "devices.backups.status.restoring": "Restaurando",
  "devices.backups.status.waiting": "Aguardando",
  "devices.backups.status.waiting.schedule": "Aguardando agendamento",
  "devices.backups.status.running": "Em execução",
  "devices.backups.status.downloading": "Baixando",
  "devices.backups.status.pending": "Pendente",
  "devices.backups.status.error": "Erro",
  "devices.backups.status.deploy.running": "Deploy em andamento",
  "devices.backups.status.cancelled": "Cancelado",
  "devices.backups.backup.not.done": "Não realizado",
  "devices.backups.backup.not.scheduled": "Não agendado",
  "devices.backups.backup.download": "Download",
  "devices.backups.backup.restore": "Restaurar",
  "devices.backups.backup.stop": "Parar",
  "devices.backups.backup.view.details": "Ver detalhes",
  "devices.backups.backup.download.start": "Seu download começará em instantes",
  "devices.backups.backup.download.error": "Erro ao iniciar download",
  "devices.backups.backup.encryption.key": "Segredo",

  "policies.header": "Políticas",
  "policies.tab.package.title": "Pacotes de política",
  "policies.tab.template.title": "Templates de política",

  "policies.package.title": "Pacote de Política",
  "policies.package.grid.policies": "Políticas",
  "policies.package.bulk.create": "Criar Pacote",
  "policies.package.bulk.delete": "Excluir Pacote",
  "policies.package.bulk.clone": "Clonar Pacote",
  "policies.package.saved": "Pacote criado com sucesso",
  "policies.package.edited": "Pacote editado com sucesso",
  "policies.package.cloned": "Pacote clonado com sucesso",
  "policies.package.deleted": "Pacote excluído com sucesso",
  "policies.package.error": "Erro de rede!",

  "policies.templates.title": "Template de Política",
  "policies.templates.bulk.create": "Criar Template",
  "policies.templates.bulk.delete": "Excluir Template",
  "policies.templates.bulk.clone": "Clonar Template",
  "policies.templates.saved": "Pacote criado com sucesso",
  "policies.templates.edited": "Pacote editado com sucesso",
  "policies.templates.cloned": "Pacote clonado com sucesso",
  "policies.templates.deleted": "Pacote excluído com sucesso",
  "policies.templates.error": "Erro!",

  "policy.manager.title": "Gerenciador de Políticas",
  "policy.manager.readonly": "(apenas leitura)",
  "policy.manager.position.header": "Pré-Regras Locais",
  "policy.manager.position.footer": "Pós-Regras Locais",
  "policy.manager.position.local": "Regras Locais",
  "policy.manager.group.create": "Criar Grupo",
  "policy.manager.group.delete": "Excluir Grupos",
  "policy.manager.group.created": "Grupo criado com sucesso",
  "policy.manager.group.edited": "Grupo editado com sucesso",
  "policy.manager.group.deleted": "Grupo excluído com sucesso",
  "policy.manager.order.changed": "Ordem alterada com sucesso",
  "policy.manager.policy.saved": "Política salva com sucesso",
  "policy.manager.policy.enabled": "Política habilitada",
  "policy.manager.policy.disabled": "Política desabilitada",
  "policy.manager.policy.deleted": "Política excluída com sucesso",
  "policy.manager.policy.create": "Criar política",
  "policy.manager.policy.delete": "Excluir Políticas",
  "policy.manager.policy.import": "Importar Template",
  "policy.manager.policy.save": "Salvar Template",
  "policy.manager.policy.action.allow": "Permitir",
  "policy.manager.policy.action.reject": "Rejeitar",
  "policy.manager.policy.action.deny": "Negar",

  "policy.manager.policy.validation.modal.conclicted_with":
    "Em conflito com a regra de ID",
  "policy.manager.policy.validation.modal.type": "Tipo do conflito",
  "policy.manager.policy.validation.modal.type.1": "Ofuscamento",
  "policy.manager.policy.validation.modal.type.2":
    "Parametros iguais e ações diferentes",
  "policy.manager.policy.validation.modal.type.3": "Regra duplicada",
  "policy.manager.policy.validation.modal.verified": "Verificado em",
  "policy.manager.policy.validation.modal.description": "Descrição",

  "policy.manager.group.valid_polices": "Validar políticas",
  "policy.manager.group.clear_valid_policies": "Limpar validações",
  "policy.manager.group.header.rule": "regra",
  "policy.manager.group.header.source": "origem",
  "policy.manager.group.header.destination": "destino",
  "policy.manager.group.header.schedule": "agendamento",
  "policy.manager.group.header.services": "serviços",
  "policy.manager.group.header.tags": "tags",
  "policy.manager.group.header.modules": "módulos",
  "policy.manager.group.header.action": "ação",
  "policy.manager.group.expand_all": "Expandir Todos",
  "policy.manager.group.collapse_all": "Recolher Todos",
  "policy.manager.notags": "sem tags",
  "policy.manager.network_zone": "Zona de rede: {zone}",
  "policy.manager.network_interface": "Interface de rede: {interface}",
  "policy.manager.network_macaddress": "Mac Address: {mac}",
  "policy.manager.filter.changed": "Filtro alterado",
  "policy.manager.error": "Erro!",
  "policy.manager.invalid": "Operação inválida!",
  "policy.manager.template.imported": "Template importado com sucesso",
  "policy.manager.template.saved": "Template salvo com sucesso",
  "policy.manager.policy.cloned": "Regra clonada com sucesso",
  "policy.manager.policy.clone": "Clone",
  "policy.manager.policy.clone.title": "Confirme para clonar",
  "policy.manager.policy.clone.confirm":
    "Você tem certeza que quer clonar a regra {ruleName}?",

  "policy.modal.form.error.name.exists": "Este nome de política já existe",

  "policy.form.properties": "Propriedades",
  "policy.form.properties.general": "Geral",
  "policy.form.properties.name": "Nome",
  "policy.form.properties.name.required": "Por favor insira o nome!",
  "policy.form.properties.description": "Descrição",
  "policy.form.properties.description.required":
    "Por favor insira a descrição!",
  "policy.form.properties.action": "Ação",
  "policy.form.properties.action.required": "Por favor selecione uma ação!",
  "policy.form.properties.tags": "Tags",
  "policy.form.properties.policy.group": "Grupo de política",
  "policy.form.properties.policy.group.required":
    "Por favor selecione um grupo!",
  "policy.form.properties.traffic.monitor": "Traffic Monitor",
  "policy.form.properties.traffic.logging": "Traffic Logging",
  "policy.form.properties.schedule": "Agendamento",
  "policy.form.properties.time": "Tempo",
  "policy.form.properties.time.required": "Por favor selecione um horário!",
  "policy.form.properties.period.date": "Agendamento",
  "policy.form.properties.period.date.required":
    "Selecione um agendamento de data!",
  "policy.form.properties.traffic.monitor.modal":
    "Ao desabilitar esta função, não será mais possível monitorar os dados desta Política em Dashboard e Live Sessions",
  "policy.form.properties.traffic.monitor.modal.title": "Atenção!",
  "policy.form.properties.traffic.monitor.modal.button.ok": "Continuar",
  "policy.form.properties.traffic.monitor.modal.button.cancel": "Cancelar",

  "policy.form.connection": "Conexão",
  "policy.form.connection.item": "Item",
  "policy.form.connection.source": "Origem",
  "policy.form.connection.source.required": "Por favor selecione uma fonte!",
  "policy.form.connection.source.network.zone": "Zona de rede",
  "policy.form.connection.source.network.zone.required":
    "Por favor selecione uma zona de rede de origem!",
  "policy.form.connection.source.network.interface": "Interface de rede",
  "policy.form.connection.source.network.interface.required":
    "Por favor, selecione uma interface de rede de origem!",
  "policy.form.connection.source.ip.address": "Endereço de IP",
  "policy.form.connection.source.ip.address.required":
    "Por favor, selecione algum endereço IP de origem!",
  "policy.form.connection.source.mac.address": "MAC Address",
  "policy.form.connection.source.mac.address.required":
    "Por favor, selecione um endereço MAC de origem!",
  "policy.form.connection.destination": "Destino",
  "policy.form.connection.destination.ip.address": "Endereço IP",
  "policy.form.connection.destination.ip.address.required":
    "Por favor, selecione um endereço IP de destino!",
  "policy.form.connection.destination.service": "Serviço",
  "policy.form.connection.destination.service.required":
    "Por favor, selecione algum serviço de destino!",
  "policy.form.connection.identification": "Identificação",
  "policy.form.connection.authenticated": "Autenticado",
  "policy.form.connection.users": "Usuários",
  "policy.form.connection.users.required":
    "Por favor, selecione algum usuário!",
  "policy.form.connection.groups": "Grupos",
  "policy.form.connection.groups.required": "Por favor, selecione um grupo!",

  "policy.form.inspection": "Inspeção",
  "policy.form.content.web.proxy": "Proxy Web",
  "policy.form.content.ftp": "FTP",
  "policy.form.content.https": "HTTPS",
  "policy.form.content.validate.ssl.certificate": "Validar certificado SSL",
  "policy.form.content.http": "HTTP",
  "policy.form.content.ssl.inspection": "Inspeção SSL",
  "policy.form.content.explicit.proxy": "Proxy Explícito",
  "policy.form.content.ssl.common.name": "Nome comum do SSL",
  "policy.form.content.ssl.common.name.required":
    "Por favor, selecione algum nome comum ssl!",
  "policy.form.content.malware.scanning": "Verificação de Malware",
  "policy.form.content.malware.scanning.required":
    "Por favor, selecione alguma verificação de malware!",
  "policy.form.content.web.filter": "Web Filter",
  "policy.form.content.web.categories": "Categorias Web",
  "policy.form.content.web.categories.required":
    "Por favor, selecione uma categoria!",
  "policy.form.content.applications": "Aplicações",
  "policy.form.content.applications.required":
    "Por favor, selecione alguma aplicação!",
  "policy.form.content.url.filter": "Filtro de URL",
  "policy.form.content.url.filter.required": "Por favor, selecione um URL!",
  "policy.form.content.browsers": "Navegadores",
  "policy.form.content.browsers.required":
    "Por favor, selecione algum navegador!",
  "policy.form.content.http.method": "Método HTTP",
  "policy.form.content.http.method.required":
    "Por favor, selecione algum método http!",
  "policy.form.content.smtp": "SMTP",
  "policy.form.content.pop3": "POP3",

  "policy.form.content.inspection.ssl": "Selecione um perfil para Inspeção SSL.",
  "policy.form.content.inspection.intrusion.prevention": "Selecione um perfil para Intrusion Prevention.",
  "policy.form.content.inspection.threat.protection": "Selecione um perfil para Threat Protection.",
  "policy.form.content.inspection.application.control": "Selecione um perfil para Application Control.",
  "policy.form.content.inspection.web.filter": "Selecione um perfil para Web Filter.",

  "policy.form.control.surfing.control": "Surfing Control",
  "policy.form.control.content.type.filter": "Filtro de tipo de conteúdo",
  "policy.form.control.content.type.filter.required":
    "Por favor selecione um tipo de conteúdo",
  "policy.form.control.http.filter.header": "Cabeçalho do filtro HTTP",
  "policy.form.control.http.filter.header.required": "Valor inválido!",
  "policy.form.control.maximum.time": "Tempo máximo",
  "policy.form.control.maximum.time.required": "Valor inválido!",
  "policy.form.control.maximum.time.select.one": "Selecione um!",
  "policy.form.control.maximum.time.opt.min": "Minutos por dia",
  "policy.form.control.maximum.time.opt.hour": "Horas por dia",
  "policy.form.control.maximum.traffic": "Tráfego máximo",
  "policy.form.control.maximum.traffic.required": "Valor inválido!",
  "policy.form.control.maximum.traffic.select.one": "Selecione um!",
  "policy.form.control.maximum.traffic.opt.day": "MB por dia",
  "policy.form.control.maximum.download.size": "Tamanho máximo de download",
  "policy.form.control.maximum.download.size.required": "Valor inválido!",
  "policy.form.control.maximum.download.size.select.one": "Selecione um!",
  "policy.form.control.maximum.upload.size": "Tamanho máximo de upload",
  "policy.form.control.maximum.upload.size.required": "Valor inválido!",
  "policy.form.control.maximum.upload.size.select.one": "Selecione um!",

  "policy.form.security.deep.inspection": "Deep Inspection",
  "policy.form.security.sensor": "Sensor",
  "policy.form.security.device.template": "Template de device",
  "policy.form.security.device.template.select.one": "Selecione um!",
  "policy.form.security.profile.dpi": "Perfil de DPI",
  "policy.form.security.profile.dpi.select.one": "Selecione um!",
  "policy.form.security.threat.blocking": "Bloqueio de ameaça",
  "policy.form.security.compromised.addresses": "Endereços comprometidos",
  "policy.form.security.compromised.addresses.required":
    "Por favor, selecione um endereço comprometido!",
  "policy.form.security.geolocation": "Geolocalização",
  "policy.form.security.geolocation.select.one": "Selecione um!",
  "policy.form.security.packet.filter": "Filtro de Pacotes",
  "policy.form.security.ttl": "TTL",
  "policy.form.security.ttl.select.one": "Selecione um!",
  "policy.form.security.ttl.required": "Valor inválido!",
  "policy.form.security.package.type": "Tipo de Pacote",
  "policy.form.security.package.type.select.one": "Selecione um!",
  "policy.form.security.packet.content": "Conteúdo do pacote",
  "policy.form.security.packet.content.select.one": "Selecione um!",
  "policy.form.security.tcp.mss": "TCP MSS",
  "policy.form.security.tcp.mss.required": "Valor inválido!",

  "policy.form.routing": "Roteamento",
  "policy.form.routing.gateway": "Gateway",
  "policy.form.routing.nat": "NAT",
  "policy.form.routing.cgnat": "CGNAT",
  "policy.form.routing.cgnat.empty": "Digite um range de portas",
  "policy.form.routing.cgnat.enable": "Ativar CGNAT",
  "policy.form.routing.snat.default": "Gateway Default (Máscarado)",
  "policy.form.routing.sdwan": "SD-WAN",
  "policy.form.routing.device.template": "Template de Device",
  "policy.form.routing.device.template.select.one": "Selecione um!",
  "policy.form.routing.profile.sdwan": "Perfil de SD-WAN",
  "policy.form.routing.profiles.sdwan": "Perfil(is) de SD-WAN",
  "policy.form.routing.profile.sdwan.select.one": "Selecione um!",
  "policy.form.routing.qos": "QoS",
  "policy.form.routing.options": "QoS e Traffic Shaping",
  "policy.form.routing.traffic.shaping": "Controle de Banda",
  "policy.form.routing.traffic.shaping.select.one": "Selecione um!",
  "policy.form.routing.flag.packets.tos": "Marcar Pacotes (TOS)",
  "policy.form.routing.flag.packets.tos.select.one": "Selecione um!",
  "policy.form.routing.flag.packets.dscp": "Marcar Pacotes (DSCP)",
  "policy.form.routing.flag.packets.dscp.select.one": "Selecione um!",
  "policy.form.routing.approuting": "Roteamento de aplicativos",
  "policy.form.routing.webapp": "Aplicativos",

  "policy.form.advanced": "Avançado",
  "policy.form.advanced.dosProtection": "Proteção DoS",
  "policy.form.advanced.packetRate": "Taxa de Pacote (pacotes/segundos)",
  "policy.form.advanced.burstRate": "Taxa de Explosão",
  "policy.form.advanced.options": "Opções",
  "policy.form.advanced.tcpmss": "tcp mss",
  "policy.form.advanced.save": "salvar",
  "sandbox.form.advanced.note": "Probabilidade aceitável (%)",
  "sandbox.form.advanced.note.error": "Informar valor entre 0 e 100",
  "sandbox.form.advanced.token": "Token",

  "highAvailability.warning":
    "Device secundário ativo, qualquer alteração na interface pode comprometer o retorno do servidor primário",

  "objects.mapping.modal.title": "Mapeamento de objeto",
  "objects.mapping.modal.usedin": "Usado",
  "objects.mapping.modal.name": "Nome",
  "objects.mapping.modal.interface": "Interface",
  "objects.title": "Objetos",
  "objects.tabs.address": "Endereços",
  "objects.tabs.service": "Serviços",
  "objects.tabs.time": "Horários",
  "objects.tabs.schedule": "Agendamentos",
  "objects.tabs.dicionarie": "Dicionários",
  "objects.tabs.content": "Conteúdos",

  "objects.actions.create": "Criar objeto",
  "objects.actions.group.create": "Criar Grupo",
  "objects.actions.delete": "Excluir Objeto",
  "objects.modal.title": " Objeto de {object}",
  "objects.modal.group.title": " Grupo de Objeto de {object}",
  "objects.modal.group.title.address": "Grupo de Objetos de Endereços",

  "objects.addressGroup.modal.object": "Objetos",
  "objects.addressGroup.modal.title": "Criar grupo de objetos de endereço",
  "objects.addressGroup.modal.select.type": "Selecionar um tipo",
  "objects.actions.create.success": "Objeto criado com sucesso!",
  "objects.actions.create.error": "O objeto não foi salvo!",
  "objects.actions.create.error.dns": "Endereço Host não resolvido!",
  "objects.actions.delete.success": "Objeto excluído com sucesso!",
  "objects.actions.delete.error": "Erro ao excluir objeto!",
  "objects.actions.delete.error.total":
    "{number} item(ns) não foram excluídos. Objeto em uso.",

  "objects.address.datagrid.name": "Nome",
  "objects.address.datagrid.description": "Descrição",
  "objects.address.datagrid.type": "Tipo",
  "objects.address.datagrid.used": "Usado",
  "objects.address.datagrid.actions": "Ações",
  "objects.address.actions.create": "Criar Objeto",
  "objects.address.actions.delete": "Excluir Objeto",
  "objects.address.actions.delete.success": "Objeto excluído com sucesso!",
  "objects.address.modal.title": "Objeto de endereço",
  "objects.address.modal.form.name": "Nome",
  "objects.address.modal.form.item": "Endereço",
  "objects.address.modal.form.list": "Lista",
  "objects.address.modal.form.type": "Tipo",
  "objects.address.modal.form.description": "Descrição",
  "objects.address.modal.form.ip": "Endereço IPv4",
  "objects.address.modal.form.ipv6": "Endereço IPv6",
  "objects.address.modal.form.mac": "Endereço MAC",
  "objects.address.modal.form.fqdn": "Endereço FQDN",
  "objects.address.modal.form.unique.ip": "Único",
  "objects.address.modal.form.mask": "Máscara",
  "objects.address.modal.form.prefix": "Prefixo",
  "objects.address.modal.form.invalid": "Campos inválidos",
  "objects.address.modal.form.error.name": "Campo Nome é obrigatório",
  "objects.address.modal.form.error.type":
    "Campo Tipo de Endereço é obrigatório",
  "objects.address.modal.form.error.list":
    "Campo Lista de Endereços é obrigatório",
  "objects.address.modal.form.error.description":
    "Campo Descrição é obrigatório",
  "objects.address.modal.form.name.exists":
    "Um endereço com esse nome já existe",
  "objects.address.modal.form.error.unique":
    "Um objeto que é somente um endereço de IP não pode conter mais de um IP/rede",
  "objects.address.modal.save.success": "Configurações alteradas com sucesso!",
  "objects.address.modal.import.success":
    "{number} item(s) importado(s) com sucesso",
  "objects.address.modal.import.error":
    "{number} item(s) não foi(foram) importado(s) com sucesso",
  "objects.address.modal.import.warning":
    "O arquivo de importação deve conter um item por linha",
  "objects.address.modal.error.file.bigger": "O arquivo deve ter menos de 2 MB",
  "objects.address.modal.error.file.txt":
    "Você só pode fazer upload de arquivos TXT",
  "objects.address.modal.save.error": "As configurações não foram salvas!",
  "objects.address.delete.title": "Confirmar exclusão",
  "objects.address.delete.confirm":
    "Tem certeza de que deseja excluir o objeto de endereço",
  "objects.address.delete.confirmMult":
    "Tem certeza de que deseja excluir o seguinte objetos de endereço?",

  "objects.services.datagrid.name": "Nome",
  "objects.services.datagrid.description": "Descrição",
  "objects.services.datagrid.type": "Tipo",
  "objects.services.datagrid.used": "Usado",
  "objects.services.datagrid.actions": "Ações",
  "objects.services.actions.create": "Criar Objeto",
  "objects.services.actions.delete": "Excluir Objeto",
  "objects.services.modal.title": "Criar objeto de Serviço",
  "objects.services.modal.form.name": "Nome",
  "objects.services.modal.form.type": "Tipo de protocolo",
  "objects.services.modal.form.item": "Tipos",
  "objects.services.modal.form.list": "Lista",
  "objects.services.modal.form.description": "Descrição",
  "objects.services.modal.form.tcp": "TCP",
  "objects.services.modal.form.udp": "UDP",
  "objects.services.modal.form.ip": "IP",
  "objects.services.modal.form.icmp": "ICMP V4",
  "objects.services.modal.form.icmpv6": "ICMP V6",
  "objects.services.modal.form.portType": "Tipo de porta",
  "objects.services.modal.form.port": "Porta",
  "objects.services.modal.form.protocol": "Protocolo",
  "objects.services.modal.form.types": "Tipos",
  "objects.services.modal.form.source.port": "Porta de origem",
  "objects.services.modal.form.destination.port": "Porta de destino",
  "objects.services.modal.form.initial.port": "Porta inicial",
  "objects.services.modal.form.end.port": "Porta final",
  "objects.services.modal.form.save.success": "Objeto salvo com sucesso",
  "objects.services.modal.form.save.error": "O objeto não foi salvo",
  "objects.services.modal.form.invalid": "Campos inválidos",
  "objects.services.modal.form.name.exists":
    "Um objeto com esse nome já existe",

  "objects.services.modal.form.error.name": "O campo nome é obrigatório",
  "objects.services.modal.form.error.type":
    "O campo tipo de protocolo é obrigatório",
  "objects.services.modal.form.error.list":
    "O campo Lista de Protocolos é obrigatório",
  "objects.services.modal.form.error.description":
    "O campo Descrição é obrigatório",
  "objects.services.delete.title": "Confirmar exclusão",
  "objects.services.delete.confirm":
    "Tem certeza de que deseja excluir o objeto de serviço?",
  "objects.services.delete.confirmMult":
    "Tem certeza de que deseja excluir os seguintes objetos de serviço?",

  "objects.times.datagrid.name": "Nome",
  "objects.times.datagrid.description": "Descrição",
  "objects.times.datagrid.type": "Tipo",
  "objects.times.datagrid.used": "Usado",
  "objects.times.datagrid.actions": "Ações",
  "objects.times.actions.create": "Criar Objeto",
  "objects.times.actions.delete": "Excluir Objeto",
  "objects.times.modal.title": "Criar objeto de tempo",
  "objects.times.modal.form.name": "Nome",
  "objects.times.modal.form.type": "Dia da semana",
  "objects.times.modal.form.item": "Hora de início / término",
  "objects.times.modal.form.start.time": "Hora de início",
  "objects.times.modal.form.start.datetime": "Data e hora de início",
  "objects.times.modal.form.end.time": "Fim do tempo",
  "objects.times.modal.form.end.datetime": "Data e hora de término",
  "objects.times.modal.form.list": "Lista",
  "objects.times.modal.form.description": "Descrição",
  "objects.times.modal.form.tcp": "TCP",
  "objects.times.modal.form.udp": "UDP",
  "objects.times.modal.form.ip": "IP",
  "objects.times.modal.form.icmp": "ICMP V4",
  "objects.times.modal.form.icmpv6": "ICMP V6",
  "objects.times.modal.form.sunday": "Domingo",
  "objects.times.modal.form.monday": "Segunda",
  "objects.times.modal.form.tuesday": "Terça",
  "objects.times.modal.form.wednesday": "Quarta",
  "objects.times.modal.form.thursday": "Quinta",
  "objects.times.modal.form.friday": "Sexta",
  "objects.times.modal.form.saturday": "Sábado",
  "objects.times.modal.form.invalid": "Campos inválidos",
  "objects.times.modal.form.name.exists": "Um objeto com esse nome já existe",
  "objects.times.modal.form.error.name": "O campo Nome é obrigatório",
  "objects.times.modal.form.error.type":
    "O campo Tipo de Protocolo é obrigatório",
  "objects.times.modal.form.error.list":
    "O campo Lista de Protocolos é obrigatório",
  "objects.times.modal.form.error.description":
    "O campo Descrição é obrigatório",
  "objects.times.modal.form.error.equal.period":
    "O período final deve ser maior que o período inicial",
  "objects.times.delete.title": "Confirmar exclusão?",
  "objects.times.delete.confirm":
    "Tem certeza de que deseja excluir o objeto de tempo?",
  "objects.times.delete.confirmMult":
    "Tem certeza de que deseja excluir os seguintes objetos de tempo?",

  "objects.schedules.datagrid.name": "Nome",
  "objects.schedules.datagrid.description": "Descrição",
  "objects.schedules.datagrid.type": "Tipo",
  "objects.schedules.datagrid.used": "Usado",
  "objects.schedules.datagrid.actions": "Ações",
  "objects.schedules.actions.create": "Criar Objeto",
  "objects.schedules.actions.delete": "Excluir Objeto",
  "objects.schedules.modal.title": "Criar objeto agendamento",
  "objects.schedules.modal.form.name": "Nome",
  "objects.schedules.modal.form.item": "Data de início / término",
  "objects.schedules.modal.form.list": "Lista",
  "objects.schedules.modal.form.description": "Descrição",
  "objects.schedules.modal.form.error.name": "Campo nome é obrigatório",
  "objects.schedules.modal.form.error.list":
    "O campo Lista de Protocolos é obrigatório",
  "objects.schedules.modal.form.error.description":
    "O campo Descrição é obrigatório",
  "objects.schedules.delete.title": "Confirmar exclusão",
  "objects.schedules.delete.confirm":
    "Tem certeza de que deseja excluir o objeto de agendamento?",
  "objects.schedules.delete.confirmMult":
    "Tem certeza de que deseja excluir os seguintes objetos de agendamento?",

  "objects.dictionaries.datagrid.name": "Nome",
  "objects.dictionaries.datagrid.description": "Descrição",
  "objects.dictionaries.datagrid.type": "Tipo",
  "objects.dictionaries.datagrid.used": "Usado",
  "objects.dictionaries.datagrid.actions": "Ações",
  "objects.dictionaries.actions.create": "Criar Objeto",
  "objects.dictionaries.actions.delete": "Excluir Objeto",
  "objects.dictionaries.modal.title": "Criar objetos de dicionário",
  "objects.dictionaries.modal.form.name": "Nome",
  "objects.dictionaries.modal.form.type": "Tipo de Protocolo",
  "objects.dictionaries.modal.form.list": "Lista",
  "objects.dictionaries.modal.form.expressions": "Expressões",
  "objects.dictionaries.modal.form.word": "Palavra",
  "objects.dictionaries.modal.form.description": "Descrição",
  "objects.dictionaries.modal.form.tcp": "TCP",
  "objects.dictionaries.modal.form.udp": "UDP",
  "objects.dictionaries.modal.form.ip": "IP",
  "objects.dictionaries.modal.form.icmp": "ICMP V4",
  "objects.dictionaries.modal.form.icmpv6": "ICMP V6",
  "objects.dictionaries.modal.form.invalid": "Campos inválidos",
  "objects.dictionaries.modal.form.error.name": "O campo nome é obrigatório",
  "objects.dictionaries.modal.form.error.type":
    "O campo Tipo de Protocolo é obrigatório",
  "objects.dictionaries.modal.form.error.list":
    "O campo Lista de Protocolo é obrigatório",
  "objects.dictionaries.modal.form.error.description":
    "O campo Descrição é obrigatório",
  "objects.dictionaries.modal.form.name.exists":
    "Um dicionário com esse nome já existe",
  "objects.dictionaries.delete.title": "Confirmar exclusão",
  "objects.dictionaries.delete.confirm":
    "Tem certeza de que deseja excluir o objeto do tipo dicionário",
  "objects.dictionaries.delete.confirmMult":
    "Tem certeza de que deseja excluir os seguintes objetos do tipo dicionário?",
  "objects.dictionaries.modal.import.success":
    "{number} item(s) importados com sucesso",
  "objects.dictionaries.modal.import.warning":
    "O arquivo de importação deve conter um item por linha",
  "objects.dictionaries.modal.import.error":
    "{number} item (ns) não foram importados com sucesso",
  "objects.dictionaries.modal.error.file.bigger":
    "O arquivo deve ter menos de 2 MB",
  "objects.dictionaries.modal.error.file.txt":
    "Você só pode fazer upload de arquivos TXT",

  "objects.contents.datagrid.name": "Nome",
  "objects.contents.datagrid.description": "Descrição",
  "objects.contents.datagrid.type": "Tipo",
  "objects.contents.datagrid.used": "Usado",
  "objects.contents.datagrid.actions": "Ações",
  "objects.contents.actions.create": "Criar Objeto",
  "objects.contents.actions.delete": "Excluir Objeto",
  "objects.contents.modal.title": "Criar objeto de agendamento",
  "objects.contents.modal.form.name": "Nome",
  "objects.contents.modal.form.type": "Tipo de protocolo",
  "objects.contents.modal.form.list": "Lista",
  "objects.contents.modal.form.listMime": "Lista de Mime-Types",
  "objects.contents.modal.form.listExt": "Lista de Extensões",
  "objects.contents.modal.form.description": "Descrição",
  "objects.contents.modal.form.tcp": "TCP",
  "objects.contents.modal.form.udp": "UDP",
  "objects.contents.modal.form.ip": "IP",
  "objects.contents.modal.form.icmp": "ICMP V4",
  "objects.contents.modal.form.icmpv6": "ICMP V6",
  "objects.contents.modal.form.error.name": "Campo nome é obrigatório",
  "objects.contents.modal.form.error.type":
    "O campo Tipo de Protocolo é obrigatório",
  "objects.contents.modal.form.error.list":
    "O campo Lista de Protocolos é obrigatório",
  "objects.contents.modal.form.error.description":
    "O campo Descrição é obrigatório",
  "objects.contents.modal.form.name.exists":
    "Um objeto com esse nome já existe",
  "objects.contents.modal.form.invalid": "Campos inválidos",
  "objects.contents.delete.title": "Confirmar exclusão",
  "objects.contents.delete.confirm":
    "Tem certeza de que deseja excluir o conteúdo do objeto?",
  "objects.contents.delete.confirmMult":
    "Tem certeza de que deseja excluir o conteúdo dos seguintes objetos?",

  "deploys.title": "Deploys",
  "deploys.task.information": "Informações da task",
  "deploys.task.view": "Visualizar task",
  "deploys.filter.status.success": "Sucesso",
  "deploys.filter.status.accept": "Aceitar",
  "deploys.filter.status.running": "Em execução",
  "deploys.filter.status.pending": "Pendente",
  "deploys.filter.status.error": "Erro",
  "deploys.filter.status.cancelled": "Cancelada",
  "deploys.filter.taskType.policyPack": "Pacote de política",
  "deploys.filter.taskType.deviceTemp": "Template de device",
  "deploys.filter.taskType.deviceComm": "Comunidade de devices",
  "deploys.datagrid.package": "Pacote",
  "deploys.datagrid.assignee": "Auditor",
  "deploys.datagrid.owner": "Proprietário",
  "deploys.datagrid.scheduled": "Agendado",
  "deploys.datagrid.device": "Device",
  "deploys.datagrid.progress": "Progresso",
  "deploys.datagrid.status": "Status",
  "deploys.datagrid.message": "Mensagem",
  "deploys.datagrid.profile.limit": "Limite de perfis alcançado",
  "deploys.datagrid.worker.limit": "Limite do processo atingido",
  "deploys.datagrid.invalid.user": "Usuário(s) Inválido(s)",
  "deploys.datagrid.invalid.group": "Grupos(s) Inválido(s)",
  "deploys.datagrid.invalid.interface": "Interface(s) Inválida(s)",
  "deploys.datagrid.invalid.zone": "Zona(s) Inválida(s)",
  "deploys.datagrid.invalid.package.empty":
    "Pacote de políticas inválido: vazio",
  "deploys.filter.scheduled": "Agendado",
  "deploys.filter.owner": "Proprietário",
  "deploys.filter.auditor": "Auditor",
  "deploys.filter.status": "Status",
  "deploys.filter.package": "Pacote",
  "deploys.delete.success": "Deploy excluído com sucesso",
  "deploys.create.success": "Deploy criado com sucesso!",
  "deploys.create.error": "Deploy não pode ser criado!",
  "deploys.modal.monitor.title": "Monitor de Device",
  "deploys.modal.activity.title": "Atividade da Task",
  "deploys.modal.justify.title": "Justificar ação",
  "deploys.modal.justify.comment": "Comentários",
  "deploys.modal.error.comment": "Processo de backup ativo.",

  // =========== ATP =========== //
  "profiles.atp.tab.application": "Aplicativos",
  "profiles.atp.tab.malware.scanning": "Verificação de malware",
  "profiles.atp.tab.threat.blocking": "Bloqueio de ameaças",

  "profiles.atp.tab.quarantine.query.editor": "Editor de Query",
  "profiles.atp.tab.quarantine.query.save": "Salvar a Query",
  "profiles.atp.tab.quarantine.action.remove": "Remover Itens",
  "profiles.atp.tab.quarantine.tabpane.create": "Criar Query",
  "profiles.atp.tab.quarantine.tabpane.load": "Carregar a Query",
  "profiles.atp.tab.quarantine.tabpane.create.new": "Nova Query",
  "profiles.atp.tab.quarantine.tabpane.create.edit": "Editar Query",
  "profiles.atp.tab.quarantine.tabpane.create.filter": "Filtro",
  "profiles.atp.tab.quarantine.tabpane.create.value": "Valor",
  "profiles.atp.tab.quarantine.tabpane.create.filterString": "String do Filtro",
  "profiles.atp.tab.quarantine.tabpane.create.filterString.result":
    "Resultados da String do Filtro",
  "profiles.atp.tab.quarantine.tabpane.create.name.exists":
    "Uma query com esse nome já existe.",
  "profiles.atp.tab.quarantine.action.remove.text":
    "Tem certeza de que deseja excluir",
  "profiles.atp.tab.quarantine.action.remove.success":
    "A exclusão foi bem sucedida.",
  "profiles.atp.tab.quarantine.action.remove.error": "Erro na exclusão.",

  "profiles.atp.tab.quarantine.action.download.success":
    "Download bem sucedido.",
  "profiles.atp.tab.quarantine.action.download.error": "Erro no download.",
  "profiles.atp.tab.quarantine.action.download.allow": "Download liberado.",
  "profiles.atp.tab.quarantine.action.download.denied": "Download bloqueado.",
  "profiles.atp.tab.quarantine.action.download.allow.tooltip":
    "Liberar download.",
  "profiles.atp.tab.quarantine.action.download.denied.tooltip":
    "Bloquear download.",
  "profiles.atp.tab.quarantine.action.download.error.sizelimit": "Não é possível realizar o download, limite excedido.",
  "profiles.atp.tab.quarantine.action.download.error.dontanalyze": "Não é possível realizar o download, arquivo não analisado.",

  "profiles.atp.tab.quarantine.queries.action.remove.success":
    "A query foi excluída com sucesso!",
  "profiles.atp.tab.quarantine.queries.action.remove.error":
    "Erro na exclusão da query!",
  "profiles.atp.tab.quarantine.queries.filter.user": "Usuário",
  "profiles.atp.tab.quarantine.queries.filter.src": "Origem",
  "profiles.atp.tab.quarantine.queries.filter.spt": "Porta de origem",
  "profiles.atp.tab.quarantine.queries.filter.dst": "Destino",
  "profiles.atp.tab.quarantine.queries.filter.dpt": "Porta de destino",
  "profiles.atp.tab.quarantine.queries.filter.file": "Arquivo",
  "profiles.atp.tab.quarantine.queries.filter.url": "Url",
  "profiles.atp.tab.quarantine.queries.filter.mime": "Mime-type",

  "profiles.atp.tab.quarantine.queries.filter.status": "Status",
  "profiles.atp.tab.quarantine.queries.filter.date": "Data",
  "profiles.atp.tab.quarantine.queries.filter.analyze": "Verificação",
  "profiles.atp.tab.quarantine.queries.filter.dontanalyze": "Não analisado",
  "profiles.atp.tab.quarantine.queries.filter.infected": "Infectado",
  "profiles.atp.tab.quarantine.queries.filter.clean": "Limpo",
  "profiles.atp.tab.quarantine.queries.filter.download": "Download",
  "profiles.atp.tab.quarantine.queries.filter.sizelimit": "Limite de tamanho",
  "profiles.atp.tab.quarantine.queries.filter.notfound": "Não localizado",
  "profiles.atp.tab.quarantine.tabpane.create.name":
    "Customizar nome da nova query",
  "profiles.atp.tab.quarantine.tabpane.create.select.field":
    "Selecione um campo",

  "atp.custom.error.in.using": "Não foi possível excluir a assinatura. A assinatura customizada está em uso!",

  "atp.custom.signature.input.regex": "Insira sua Regex",

  // =========== Dashboard ======== //

  "monitor.system-status": "Status do Sistema",
  "monitor.system-status.information": "Informações do Sistema",
  "monitor.system-status.resources": "Recursos do Sistema",
  "monitor.system-status.services": "Serviços do Sistema",
  "monitor.system-status.license": "Informações da Licença",
  "monitor.system-status.subscriptions": "Assinaturas",
  "monitor.system-status.subscriptions.last.modify": "Última Modificação",
  "monitor.system-status.last.update": "Última Atualização",
  "monitor.system-status.last.backup": "Último Backup",
  "monitor.system-status.high.availability": "Alta Disponibilidade",

  "monitor.system-status.service.running": "Serviço em execução.",
  "monitor.system-status.service.stopped": "Serviço interrompido.",
  "monitor.system-status.service.disabled": "Serviço desabilitado.",
  "monitor.system-status.service.action.start": "Iniciando serviço.",
  "monitor.system-status.service.action.stopped": "Interrompendo serviço.",

  "monitor.dashboard.lastMinute": "Últimos 5 minutos",
  "monitor.dashboard.lastHour": "Última hora",
  "monitor.dashboard.networkTraffic": "Tráfego de rede",
  "monitor.dashboard.liveUsers": "Usuários ativos",
  "monitor.dashboard.webActivity": "Atividade web",
  "monitor.dashboard.networkAttacks": "Ataques de rede",
  "monitor.dashboard.malwareDetections": "Detecções de malware",
  "monitor.dashboard.threatBlocking": "Bloqueio de Ameaças",
  "monitor.dashboard.conectionsMap": "Mapa de conexões",
  "monitor.dashboard.trafficMonitor": "Monitor de tráfego",
  "monitor.dashboard.topUsers": "Top Usuários",
  "monitor.dashboard.topSources": "Top Origens",
  "monitor.dashboard.topServices": "Top Serviços",
  "monitor.dashboard.topPolicies": "Top Politicas",
  "monitor.dashboard.topCategories": "Top Categorias",
  "monitor.dashboard.topApplications": "Top Aplicações",
  "monitor.dashboard.topAttacks": "Top Ataques",
  "monitor.dashboard.topThreats": "Top Ameaças",

  "monitor.trafficMonitor.interfaces.error":
    "Selecione pelo menos 1 interface e até 4",
  "monitor.trafficMonitor.in": "IN",
  "monitor.trafficMonitor.out": "OUT",
  "monitor.trafficMonitor.sdwan.error": "Selecione um perfil",
  "monitor.trafficMonitor.throughput": "Taxa de Transferência",
  "monitor.trafficMonitor.bandwidth": "Largura de Banda",

  "monitor.diagnostics.packetCapture": "Captura de Pacotes",
  "monitor.diagnostics.categoryLookup": "Pesquisa por Categoria",
  "monitor.diagnostics.categoryLookup.notFound": "Endereço não classificado.",
  "monitor.diagnostics.packetCapture.error":
    "Digite um endereço, porta ou protocolo.",
  "monitor.diagnostics.packetCapture.confirm.title":
    "Deseja remover o arquivo?",
  "monitor.diagnostics.packetCapture.cancel.title":
    "Deseja cancelar a captura?",
  "monitor.diagnostics.packetCapture.ok": "Prosseguir",
  "monitor.diagnostics.packetCapture.protocol": "Protocolo",
  "monitor.diagnostics.packetCapture.size": "Tamanho",
  "monitor.diagnostics.packetCapture.tooltip": "Configurar captura",
  "monitor.diagnostics.packetCapture.DraggableModal.title":
    "Configuração de captura",
  "monitor.diagnostics.packetCapture.form.minute": "minuto",
  "monitor.diagnostics.packetCapture.form.outhers": "Outros",
  "monitor.diagnostics.packetCapture.maxSize": "Tamanho máximo do arquivo",
  "monitor.diagnostics.packetCapture.bpf": "Filtro de Pacotes Berkeley (BPF)",

  "monitor.liveSession.confirm": "Deseja remover a sessão do usuário",
  "monitor.liveSession.vpn.network": "IP/Rede",
  "monitor.liveSession.vpn.tunnel": "Site-to-Site",
  "monitor.liveSession.vpn.ras": "Acesso Remoto",
  "monitor.liveSession.vpn.confirm": "Deseja interromper a conexão",
  "monitor.liveSession.vpn.success": "Conexão interrompida com sucesso",
  "monitor.liveSession.vpn.error": "Erro ao interromper a conexão",
  "monitor.liveSession.vpn.error.disabled.server": "Erro ao salvar. Favor verificar se a VPN NG está ativa e tente novamente.",
  "monitor.liveSession.vpn.connectionDate": "Data da Conexão",
  "monitor.liveSession.network.confirm": "Deseja excluir essa conexão?",
  "monitor.liveSession.network.success": "Conexão excluída com sucesso",
  "monitor.liveSession.network.error": "Erro ao excluir a conexão",
  "monitor.liveSession.network.connections.info":
    "Total de conexões estabelecidas",
  "monitor.liveSession.network.logsessions.disable":
    "O log de sessões foi desabilitado",
  "monitor.liveSession.waiting": "Aguarde enquanto a conexão é estabelecida",
  // =========== IPS =========== //

  "profiles.tab.ips.smart": "IPS inteligente (Habilitar automaticamente assinaturas)",
  "profiles.tab.ips.smart.enable": "IPS inteligente",
  "profiles.intrusionprevention.settings.riskLow": "Risco Baixo",
  "profiles.intrusionprevention.settings.riskMedium": "Risco Médio",
  "profiles.intrusionprevention.settings.riskHigh": "Risco Alto",
  "profiles.intrusionprevention.settings.info.devices": "As interfaces listadas, são aquelas que estão habilitadas e sem configuração de IP e Máscara.",

  "profiles.tab.ips.whitelist": "Endereços Liberados",
  "profiles.tab.ips.blacklist": "Endereços Bloqueados",
  "profiles.tab.ips.quarantine": "Quarentena",
  "profiles.tab.ips.whitelist.create": "Criar",
  "profiles.tab.ips.whitelist.delete": "Excluir",
  "profiles.tab.ips.whitelist.address": "Endereço",

  "profiles.tab.ips.whitelist.customization": "Assinaturas Customizadas",
  "profiles.tab.ips.action.add.customization":
    "Assinatura Customizada adicionada com sucesso",
  "profiles.tab.ips.error.duplicated-sid": "Assinatura Customizada duplicada",
  "profiles.tab.ips.action.remove.sucess.customization":
    "Assinatura Customizada removida com sucesso",

  "profiles.tab.ips.blacklist.create": "Criar",
  "profiles.tab.ips.blacklist.delete": "Excluir",
  "profiles.tab.ips.blacklist.address": "Endereço",
  "profiles.tab.ips.action.add.sucess": "Endereço adicionado com sucesso",
  "profiles.tab.ips.error.loading": "Erro ao carregar a página",
  "profiles.tab.ips.action.remove.sucess": "Endereço removido com sucesso",
  "profiles.tab.ips.action.remove.text": "Tem certeza de que deseja excluir",
  "profiles.tab.ips.quarantine.action.whitelist":
    "Mover para Endereços Liberados",
  "profiles.tab.ips.quarantine.action.blacklist":
    "Mover para Endereços Bloqueados",
  "profiles.tab.ips.quarantine.action.move.success":
    "Endereço movido com sucesso",
  "profiles.tab.ips.quarantine.action.move.error": "Erro ao mover o endereço",
  "profiles.tab.ips.quarantine.action.remove": "Remover",
  "profiles.tab.ips.quarantine.action.move.title.whitelist":
    "Endereços Liberados",
  "profiles.tab.ips.quarantine.action.move.title.blacklist":
    "Endereços Bloqueados",
  "profiles.tab.ips.quarantine.action.timeout": "Timeout",
  "profiles.tab.ips.quarantine.action.move.text.whitelist":
    "Realmente deseja mudar esses IPs para a Lista Branca",
  "profiles.tab.ips.quarantine.action.move.text.blacklist":
    "Realmente deseja mover esses IPs para a Lista Negra",
  "profiles.tab.ips.modal.form.error.time": "Campo Tempo é obrigatório",
  "profiles.tab.ips.modal.form.timeout.hour": "Hora",
  "profiles.tab.ips.modal.form.timeout.min": "Minutos",
  "profiles.tab.ips.modal.error.file.bigger":
    "O arquivo deve ter menos de 2 MB",
  "profiles.tab.ips.modal.error.file.txt":
    "Você só pode fazer upload de arquivos TXT",
  "profiles.tab.ips.modal.import.success":
    "{number} item(s) importado(s) com sucesso",
  "profiles.tab.ips.modal.form.ip": "Endereço IPv4",
  "profiles.tab.ips.modal.form.ipv6": "Endereço IPv6",
  "profiles.tab.ips.modal.form.item": "Endereço",
  "profiles.tab.ips.modal.form.mask": "Máscara",
  "profiles.tab.ips.modal.form.prefix": "Prefixo",

  "profiles.tab.ips.modal.form.column-rule": "Regra",
  "profiles.tab.ips.modal.form.column-reason": "Motivo",

  "profiles.tab.proxy.settings.invalid": "",

  "quarantine.actions.delete.success": "IP na quarentena excluído com sucesso!",
  "quarantine.actions.delete.error.total":
    "{number} item(ns) não foram excluídos. IP em uso.",
  "quarantine.delete.title": "Confirmar exclusão",
  "quarantine.delete.confirm":
    "Tem certeza de que deseja excluir da quarentena o endereço IP",
  "quarantine.delete.confirmMult":
    "Tem certeza de que deseja excluir o seguinte endereço de IP da quarentena?",

  // =========== Webfilter =========== //

  "profiles.tab.webfilter.settings": "Configurações",

  "profiles.webFilter.modal.form.error.name": "Campo nome é obrigatório",
  "profiles.webFilter.modal.form.error.name.exists":
    "Um perfil com esse nome já existe.",
  "profiles.webFilter.modal.form.error.type":
    "O campo Tipo de Endereço é obrigatório",
  "profiles.webFilter.modal.form.error.list":
    "O campo Lista de Endereços é obrigatório",
  "profiles.webFilter.modal.form.error.description":
    "O campo Descrição é obrigatório",
  "profiles.webFilter.surfingQuotas": "Surfing Quotas",
  "profiles.webFilter.error.filter": "Por favor selecione ao menos um filtro",
  "profiles.webFilter.error.category":
    "Por favor selecione ao menos uma categoria",

  "profiles.title": "Perfis",
  "profiles.title.webfilter": "Web Filter",
  "profiles.title.ips": "Intrusion Prevention",
  "profiles.title.atp": "Threat Protection",
  "profiles.title.sdwan": "SD-WAN",
  "profiles.title.ssl": "Proxy",
  "profiles.title.appControl": "Application Control",

  "profiles.tab": "Perfis",
  "profiles.tab.webfilter": "Web Filter",
  "profiles.tab.ips": "Intrusion Prevention",
  "profiles.tab.sdwan": "SD-WAN",
  "profiles.tab.ssl": "Inspeção SSL",
  "profiles.tab.appControl": "Application Control",

  "profiles.tab.atp.settings": "Configurações",
  "profiles.tab.atp.quarantine": "Quarentena",
  "profiles.tab.atp.sandbox": "Sandbox",
  "profiles.tab.atp.quarantine.threat": "Quarentena de ameaças",
  "profiles.tab.ssl.inspection": "Inspeção SSL",
  "profiles.tab.ssl.services": "Serviços do Proxy",
  "profiles.tab.sdwan.settings": "Configurações",
  "profiles.tab.appControl.settings": "Configurações",

  "profiles.tab.ssl.inspection.limit.reached": "Limite de perfis atingido!",
  "profiles.tab.ssl.workers.limit.reached": "Limite de workers atingido!",

  "profiles.webFilter.addCategory": "Categorias personalizadas",
  "profiles.webFilter.MaxUpSize": "Tamanho Máximo de Upload",
  "profiles.webFilter.MaxDownSize": "Tamanho Máximo de Download",
  "profiles.webFilter.MBPerDay": "MB por dia",
  "profiles.webFilter.MaxTrafic": "Tráfego Máximo",
  "profiles.webFilter.HoursPerDay": "Horas por dia",
  "profiles.webFilter.MinPerDay": "Minutos por dia",
  "profiles.webFilter.webCategories": "Categorias Web",
  "profiles.webFilter.modalTree.permitions.Allow": "Permitir",
  "profiles.webFilter.modalTree.permitions.Deny": "Negar",
  "profiles.webFilter.modalTree.permitions.Warning": "Atenção",
  "profiles.webFilter.FileFilter": "Filtro de arquivo",
  "profiles.webFilter.BlockFilter": "Bloqueio de arquivo",
  "profiles.webFilter.MaxTime": "Tempo Máximo",
  "profiles.webFilter.datagrid.profile": "Perfil",
  "profiles.webFilter.datagrid.actions": "Ações",
  "profiles.webFilter.actions.create": "Criar Perfil",
  "profiles.webFilter.actions.delete": "Excluir Perfil",
  "profiles.webFilter.actions.clone": "Clonar Perfil",
  "profiles.webfilter.action.remove.text": "Tem certeza de que deseja excluir",

  "profiles.webFilter.modal.category": "Categoria",
  "profiles.webFilter.modal.title": " Perfil",
  "profiles.webFilter.modal.name": "Nome",
  "profiles.webFilter.modal.devices": "Devices",
  "profiles.webFilter.modal.devicesGroups": "Grupos de Device",

  "profiles.webFilter.datagrid.name": "Nome",
  "profiles.webFilter.datagrid.description": "Descrição",
  "profiles.webFilter.datagrid.safeSearch": "Safe search",
  "profiles.webFilter.datagrid.safeSearch-detail":
    "Forçar o Safe Search para Google, Bing, Yahoo",
  "profiles.webFilter.datagrid.googleApps": "Google apps",
  "profiles.webFilter.datagrid.googleApps-detail":
    "Restringir domínios de login para o Google Apps",

  "profiles.webFilter.datagrid.used": "Usado",
  "profiles.webFilter.actions.delete.success": "Perfil excluído com sucesso!",
  "profiles.webFilter.actions.add.success": "Perfil adicionado com sucesso",
  "profiles.webFilter.actions.updated.success": "Perfil atualizado com sucesso",
  "profiles.webfilter.actions.add.error": "O perfil não foi salvo!",

  "profiles.actions.clone.success": "Perfil(s) clonado(s) com sucesso",
  "profiles.actions.clone.error": "O(s) perfil(s) não foi(ram) clonado(s)!",
  "profiles.actions.clone-partial.error":
    "Os perfis foram parcialmente clonados!",

  "profiles.webFilter.modal.form.name": "Nome",
  "profiles.webFilter.modal.form.item": "Endereço",
  "profiles.webFilter.modal.form.list": "Lista",
  "profiles.webFilter.modal.form.type": "Tipo",
  "profiles.webFilter.modal.form.description": "Descrição",
  "profiles.webFilter.modal.form.version": "Versão",
  "profiles.webFilter.modal.form.ip": "Endereço IPv4",
  "profiles.webFilter.modal.form.ipv6": "Endereço IPv6",
  "profiles.webFilter.modal.form.mac": "Endereço MAC",
  "profiles.webFilter.modal.form.fqdn": "Endereço FQDN",
  "profiles.webFilter.modal.save.success":
    "Configurações alteradas com sucesso!",
  "profiles.webFilter.modal.save.error": "As configurações não foram salvas!",
  "profiles.webFilter.delete.title": "Confirmar exclusão",
  "profiles.webFilter.delete.confirm":
    "Tem certeza de que deseja excluir o objeto de endereço?",
  "profiles.webFilter.delete.confirmMult":
    "Tem certeza de que deseja excluir os seguintes objetos de endereço?",

  "profiles.intrusionprevention.resetMotal.confirm":
    "Deseja realmente restaurar o perfil para o padrão?",
  "profiles.intrusionprevention.profile.create": "Criar perfil",
  "profiles.intrusionprevention.profile.create.success": "Perfil criado.",
  "profiles.intrusionprevention.profile.create.error": "Erro ao criar perfil.",
  "profiles.intrusionprevention.profile.delete": "Excluir Perfil",
  "profiles.intrusionprevention.profile.deleted.single":
    "Perfil excluído com sucesso.",
  "profiles.intrusionprevention.profile.deleted":
    "Perfis removidos com sucesso.",
  "profiles.intrusionprevention.profile.deleted.inUse":
    "Não foi possível excluir o perfil! Perfil em uso",
  "profiles.intrusionprevention.profile.delete.confirm.general":
    "Tem certeza de que deseja excluir:",
  "profiles.intrusionprevention.profile.delete.confirm":
    "Tem certeza de que deseja excluir os perfis:",
  "profiles.intrusionprevention.profile.delete.confirm.single":
    "Tem certeza de que deseja excluir o perfil:",
  "profiles.intrusionprevention.profile.restore.error":
    "Erro ao restaurar o perfil.",
  "profiles.intrusionprevention.profile.restore.success": "Perfil restaurado.",
  "profiles.intrusionprevention.error.profile.exists":
    "Um perfil com esse nome já existe.",
  "profiles.intrusionprevention.settings.device.same":
    "Os devices não podem ser os mesmos.",
  "profiles.intrusionprevention.settings.definitions": "Definições",
  "profiles.intrusionprevention.settings.clientRecommended":
    "Habilitar regras recomendadas pelo cliente",
  "profiles.intrusionprevention.settings.serverRecommended":
    "Habilitar regras recomendadas pelo servidor",
  "profiles.intrusionprevention.settings.inspect": "Inspecione todas as portas",
  "profiles.intrusionprevention.alert": "Você está ativando mais de 10 mil registros. Pode causar lentidão e reduzir a performance.",
  "profiles.intrusionprevention.risk.low": "Baixo",
  "profiles.intrusionprevention.risk.medium": "Médio",
  "profiles.intrusionprevention.risk.high": "Alto",
  "profiles.intrusionprevention.signatures": "Assinaturas",
  "profiles.intrusionprevention.threats": "Ameaças",
  "profiles.intrusionprevention.apps": "Aplicações",
  "profiles.intrusionprevention.reason-invalid-rule-duplicated_rule":
    "Regra duplicada",
  "profiles.intrusionprevention.reason-invalid-rule-not_match":
    "Regra Inválida",
  "profiles.intrusionprevention.reason-invalid-rule-invalid_rule":
    "Regra Inválida",

  "profiles.tab.threatProtection": "Threat Protection",
  "profile.threatProtection.name": "Nome",
  "profile.threatProtection.description": "Descrição",
  "profile.threatProtection.version": "Versão",
  "profile.threatProtection.actions.add.success":
    "Perfil adicionado com sucesso",
  "profile.threatProtection.actions.add.error": "O perfil não foi salvo",
  "profile.threatProtection.actions.delete.success":
    "Perfil removido com sucesso",
  "profile.threatProtection.actions.delete.error.inUse":
    "Não foi possível excluir o perfil! Perfil em uso",
  "profiles.threatProtection.error.profile.exists":
    "Um perfil com esse nome já existe.",
  "profiles.threatProtection.action.remove.text":
    "Tem certeza de que deseja excluir",
  "profile.threatProtection.malwareScanning": "Verificação de Malware",
  "profile.threatProtection.threatBlocking": "Bloqueio de ameaças",
  "profile.threatProtection.threatProtection": "Proteção contra ameaças",
  "profile.threatProtection.threatProtectionProfile":
    "Perfil de proteção contra ameaças",
  "profile.threatProtection.malwareScanning.required":
    "Por favor, selecione algum Malware Scanning.",
  "profile.threatProtection.threatBlocking.required":
    "Por favor, selecione algum Threat Blocking.",
  "profile.threatProtection.required.threatProtection":
    "Por favor, selecione algum Threat Protection.",

  "profile.appcontrol.createProfile": "Criar Perfil",
  "profile.appcontrol.deleteProfile": "Excluir Perfil",
  "profile.appcontrol.actions.clone": "Clonar Perfil",
  "profile.appcontrol.save.errorProfile": "O perfil não foi salvo",
  "profile.appcontrol.delete.sucess": "Perfil removido com sucesso",
  "profile.appcontrol.delete.error.inUse":
    "Não foi possível excluir o perfil! Perfil em uso",
  "profile.appcontrol.filter.invalid": "Filtro inválido",
  "profile.appcontrol.applications.required":
    "Por favor, selecione alguma aplicação!",
  "profile.appcontrol.item": "Item",
  "profile.appcontrol.form.applications": "Aplicações",
  "profile.appcontrol.form.error.name": "O campo nome é obrigatório",
  "profile.appcontrol.form.error.workers": "O campo workers é obrigatório",
  "profile.appcontrol.action.remove.text": "Tem certeza de que deseja excluir",
  "profile.appcontrol.form.profileid.undefined": "Necessário salvar o Perfil antes de criar grupos de categorias",
  "profile.appcontrol.form.name.exists": "Um perfil com esse nome já existe.",
  "profile.appcontrol.form.error.name.pattern": "Apenas letras, números, espaços, traços e underscore são permitidos.",

  "profiles.proxy.action.remove.text": "Tem certeza de que deseja excluir",
  "profiles.proxy.action.remove.profiles.text":
    "Tem certeza de que deseja excluir os perfis",

  "profiles.sdwan.action.remove.text": "Tem certeza de que deseja excluir",
  "profiles.sdwan.action.remove.profiles.text":
    "Tem certeza de que deseja excluir os perfis",
  "profiles.sdwan.deleteProfile": "Excluir Perfil",
  "profiles.sdwan.deleteService": "Excluir Serviço",
  "profiles.ssl.blockCert": "Bloquear certificados inválidos",

  "loggers.title": "Loggers",
  "loggers.actions.create": "Criar Logger",
  "loggers.actions.create.loggerDevice": "Criar Device de Logger",
  "loggers.actions.edit.loggerDevice": "Editar Device de Logger",
  "loggers.actions.delete": "Excluir Logger",
  "loggers.actions": "Ações",
  "loggers.name": "Nome",
  "loggers.mode": "Modo",
  "loggers.cpu.usage": "Uso do CPU",
  "loggers.memory.usage": "Uso de memória",
  "loggers.disk.usage": "Uso de disco",
  "loggers.storage.usage": "Uso do armazenamento",
  "loggers.address": "Endereço",
  "loggers.secretkey": "Chave secreta",
  "loggers.description": "Descrição",
  "loggers.devices": "Devices & Grupo de Devices",
  "loggers.save.success": "Os Loggers foram salvos com sucesso",
  "loggers.save.error": "Os Loggers não foram salvos",
  "loggers.save.error.ha.enabled.logger.integrated":
    "Não é possível criar uma Logger Integrada pois a Alta Disponibilidade está habilitada ",
  "loggers.delete.success": "Os Loggers foram excluídos com sucesso",
  "loggers.delete.error": "Erro ao excluir os loggers",
  "loggers.backups.retention.backup": "Número de backups retidos",
  "loggers.backups.retention.percent": "% Retenção de espaço em disco",
  "loggers.backups.delete.backups": "Deletar Backups",
  "loggers.backups.restore.backups": "Restaurar Backups",
  "loggers.backups.restore.last.date": "Ultima Modificação",
  "loggers.storage.logRotation": "Rotação de Log",
  "loggers.storage.logRotation.enable": "Habilitar Rotação de Log",
  "loggers.storage.logRotation.retention.byDisk":
    "% Retenção de Logs por Espaço em Disco",
  "loggers.storage.logRotation.retention.byPeriod":
    "Retenção de Logs por Período",
  "loggers.storage.logRotation.maintenance.interval": "Intervalo de Manutenção",
  "loggers.clusters.cluster": "Cluster",
  "loggers.clusters.create.cluster": "Criar Cluster",
  "loggers.clusters.delete.cluster": "Deletar Cluster",
  "loggers.clusters.active.primary": "Ativar Logger Primário",
  "loggers.clusters.active.replica": "Ativar Logger Réplica",
  "loggers.clusters.active.logger": "Ativar Logger",
  "loggers.clusters.sync.progress": "Progresso da sincronização",
  "loggers.clusters.sync.unavailable": "Indisponível",
  "loggers.clusters.primary": "Logger Primário",
  "loggers.clusters.secondary": "Logger Réplica",
  "loggers.clusters.primary.active": "Primário Ativo",
  "loggers.clusters.secondary.active": "Réplica Ativo",
  "loggers.clusters.virtual.ip": "IP Virtual",
  "loggers.clusters.secret.key": "Chave secreta",
  "loggers.clusters.netmask": "Máscara de rede",
  "loggers.clusters.heartbeat.interval": "Intervalo do Heartbeat (segundos)",
  "loggers.clusters.interface.info": "Interface utilizada no logger-config",
  "loggers.clusters.email.info":
    "Necessária configuração de SMTP em Configuraçãoes > Network > E-mail",
  "loggers.clusters.ip.info": "IP utilizado no logger-config",
  "loggers.clusters.failover.threshold": "Limite de Failover",
  "loggers.clusters.auto.activation": "Ativação Automática da Réplica",
  "loggers.clusters.notifications.email": "Notificações por e-mail",
  "loggers.clusters.action.duplicate.error": "Campo duplicado",
  "loggers.clusters.action.already.exists": "Nome de cluster já existente",
  "loggers.clusters.action.primary.activated":
    "Tem certeza que deseja ativar a logger primária? A logger réplica entrará em standby.",
  "loggers.clusters.action.replica.activated":
    "Tem certeza que deseja ativar a logger réplica? A logger primária entrará em standby.",
  "loggers.clusters.action.activated.success":
    "Logger ativado com sucesso. Aguarde a finalização da sincronização em alguns minutos.",
  "loggers.clusters.action.activated.error": "Erro ao ativar logger",
  "loggers.clusters.action.save.success": "Cluster salvo com sucesso",
  "loggers.clusters.action.delete.success":
    "Cluster(s) excluído(s) com sucesso",
  "loggers.clusters.action.delete.error": "Erro ao excluir cluster",
  "loggers.clusters.error.equal": "{name1} é igual ao {name2}",
  "loggers.clusters.error.limit": "É permitido adicionar somente 125 clusters.",
  "loggers.clusters.heartbeat.ip.verify":
    "Heartbeat IP configurado em outro cluster",
  "loggers.clusters.virtual.ip.verify":
    "IP Virtual configurado em outro cluster",
  "loggers.cluster.verify":
    "Não é possível excluir uma (ou mais) Logger(s) configurada em Cluster.",
  "events.authentication.reason.src": "Endereço Remoto",
  "events.authentication.reason.time": "Horário",
  "events.authentication.reason.date": "Período",
  "events.authentication.reason.user_agent": "Plataforma",
  "events.authentication.reason.zone": "Zona de Rede",
  "events.authentication.reason.no_policy": "Nenhuma política encontrada",
  "events.authentication.reason.user_blocked": "Usuário bloqueado",
  "events.authentication.reason.timeout": "Tempo de sessão",
  "events.authentication.reason.policy": "Política",
  "events.authentication.reason.auth": "Autenticação",
  "events.authentication.reason.user": "Usuário/Grupo",
  "events.authentication.reason.internal_error": "Erro interno",
  "events.authentication.reason.max_session": "Número de sessões excedido",
  "events.authentication.reason.session override": "Substituição de sessão",
  "events.authentication.reason.updated": "Sessão atualizada",

  "events.title": "Eventos",
  "events.new.query": "Nova Query",
  "events.edit.query": "Editar Query",
  "events.save.query": "Salvar Query",
  "events.create.query": "Criar Query",
  "events.custom.query": "Criar nova nome de query",
  "events.load.query": "Carregar Query",
  "events.date.range": "Período de data",
  "events.filter": "Filtro",
  "events.contain": "Contém",
  "events.not.contain": "Não contém",
  "events.not.equals": "Diferente",
  "events.equals": "Igual",
  "events.value": "Valor",
  "events.filter.string": "Filtro por palavra",
  "events.filter.string.results": "Resultado de filtro por palavra",
  "events.query.editor": "Editor de Consultas",
  "events.information": "Informações do evento",
  "events.view": "Visualização do evento",
  "events.select.field": "Selecione um campo",
  "events.log.analysis": "Análise de Log",
  "events.history": "Histórico de Hits",
  "events.error.filter.string": "Por favor, entre com um filtro por palavra",
  "events.error.name": "Por favor, entre com um nome",
  "events.delete.all.selected": "Deletar todos os selecionados",
  "events.search": "Buscar",
  "events.today": "Hoje",
  "events.yesterday": "Ontem",
  "events.last_10m": "Últimos 10 minutos",
  "events.last_6h": "Últimas 6 horas",
  "events.last_12h": "Últimas 12 horas",
  "events.last_18h": "Últimas 18 horas",
  "events.last_7": "Últimos 7 dias",
  "events.last_30": "Últimos 30 dias",
  "events.this_month": "Este mês",
  "events.last_month": "Último mês",
  "events.date": "Por data",
  "events.range": "Por período",
  "events.start.date": "Data inicial",
  "events.end.date": "Data final",
  "events.select.date": "Selecione a data",
  "events.records": "registros",
  "events.record": "registro",
  "analyzer.title": "Analyzer",
  "analyzer.reports.NetworkTraffic": "Tráfego de Rede",
  "analyzer.reports.WebFilter": "Web Filter",
  "analyzer.reports.ApplicationControl": "Application Control",
  "analyzer.reports.IntrusionPrevention": "Intrusion Prevention",
  "analyzer.reports.ThreatProtection": "Threat Protection",
  "analyzer.reports.UserBehaviour": "User Behaviour",
  "analyzer.reports.Hits": "Hits",
  "analyzer.reports.Traffic": "Tráfego",
  "analyzer.reports.AllowedApplication": "Aplicações Permitidas",
  "analyzer.reports.DeniedApplication": "Aplicações Negadas",
  "analyzer.reports.History": "Histórico",
  "analyzer.reports.TotalTraffic": "Tráfego Total",
  "analyzer.reports.TopAllowedCategories": "Top Categorias Permitidas",
  "analyzer.reports.TopDeniedCategories": "Top Categorias Negadas",
  "analyzer.reports.TopAllowedApplications": "Top Aplicações Permitidas",
  "analyzer.reports.TopDeniedApplications": "Top Aplicações Negadas",
  "analyzer.reports.ThreatBlocking": "Ameaças",
  "analyzer.reports.MalwareScanning": "Malware",
  "analyzer.reports.Geolocation": "Geolocalização",
  "analyzer.reports.ZoneTraffic": "Zona de Tráfego",
  "analyzer.reports.UsageTraffic": "Uso de Tráfego",
  "analyzer.reports.TopUsers": "Top Usuários",
  "analyzer.reports.Top.SiteToSite": "Top Conexões Site-To-Site",
  "analyzer.reports.Top.RemoteUsers": "Top Usuários Remotos",
  "analyzer.reports.RemoteUsers": "Usuários Remotos",
  "analyzer.reports.TopServices": "Top Serviços",
  "analyzer.reports.TopSources": "Top Origens",
  "analyzer.reports.TopPolicies": "Top Políticas",
  "analyzer.reports.TopProfiles": "Top Perfis",
  "analyzer.reports.TopDestinations": "Top Destinos",
  "analyzer.reports.TopCategories": "Top Categorias",
  "analyzer.reports.TopSites": "Top Domínios",
  "analyzer.reports.TopSitesByTime": "Top Domínios - Tempo",
  "analyzer.reports.TopContentType": "Top Tipos de Conteúdo",
  "analyzer.reports.TopClasstypes": "Top Tipos de Classes",
  "analyzer.reports.TopMalwares": "Top Malwares",
  "analyzer.reports.StartDownload": "O download começará em instantes",
  "analyzer.reports.TopInfectedDomains": "Top Domínios Infectados",
  "analyzer.reports.TopThreatsByAddress": "Top Ameaças por Endereço",
  "analyzer.reports.TopThreatsByUsers": "Top Ameaças por Usuários",
  "analyzer.reports.TopAttacks": "Top Ataques",
  "analyzer.reports.TopThreats": "Top Ameaças",
  "analyzer.reports.TopApplications": "Top Aplicações",
  "analyzer.reports.SelectDevice": "Selecione um Device/Grupo",
  "analyzer.reports.SelectUser": "Selecione um Usuário",
  "analyzer.reports.HistoryTotalTraffic": "Histórico de Tráfego Total",
  "analyzer.reports.DeniedDomains": "Domínios Negados",
  "analyzer.reports.AllowedDomains": "Domínios Permitidos",
  "analyzer.reports.HistoryDeniedDomains": "Histórico de Domínios Negados",
  "analyzer.reports.HistoryAllowedDomains": "Histórico de Domínios Permitidos",
  "analyzer.reports.HistoryUsers": "Histórico de Usuários",
  "analyzer.reports.HistoryPolicies": "Histórico de Perfis",
  "analyzer.reports.HistoryCategories": "Histórico de Categorias",
  "analyzer.reports.HistorySites": "Histórico de Domínios",
  "analyzer.reports.HistoryContentType": "Histórico de Tipo de Conteúdo",
  "analyzer.reports.User": "Usuário",
  "analyzer.reports.Service": "Serviço",
  "analyzer.reports.Source": "Origem",
  "analyzer.reports.Destination": "Destino",
  "analyzer.reports.Policy": "Política",
  "analyzer.reports.Profile": "Perfil",
  "analyzer.reports.Domain": "Domínio",
  "analyzer.reports.Application": "Aplicação",
  "analyzer.reports.ContentType": "Tipo de Conteúdo",
  "analyzer.reports.Category": "Categoria",
  "analyzer.reports.Classtype": "Tipo de Classe",
  "analyzer.reports.Malware": "Malware",
  "analyzer.reports.Address": "Ip",
  "analyzer.reports.Attack": "Ataque",
  "analyzer.reports.Threat": "Ameaça",
  "analyzer.reports.Alerted": "Alertado",
  "analyzer.reports.Blocked": "Bloqueado",
  "analyzer.reports.Low": "Baixo",
  "analyzer.reports.Medium": "Médio",
  "analyzer.reports.High": "Alto",
  "analyzer.reports.RiskHigh": "Risco - Alto",
  "analyzer.reports.RiskMedium": "Risco - Médio",
  "analyzer.reports.RiskLow": "Risco - Baixo",
  "analyzer.reports.totalApplication": "Aplicações",

  "analyzer.reports.common.selectDevice": "Selecione um Device",
  "analyzer.reports.policy.globalTags": "Tags Globais",
  "analyzer.reports.user.applications": "Aplicações",
  "analyzer.reports.user.panel": "Painel de Análise",
  "analyzer.reports.component.footer.totalTraffic": "Tráfego Total",
  "analyzer.reports.component.footer.totalHits": "Hits Totais",

  "report.actions.add.success": "Relatório adicionado com sucesso",

  "analytics.reports.schedule.unique": "Única",
  "analytics.reports.schedule.daily": "Diariamente",
  "analytics.reports.schedule.weekly": "Semanalmente",
  "analytics.reports.schedule.monthly": "Mensalmente",
  "analytics.reports.scheduled": "Agendado",
  "analytics.reports.owner": "Proprietário",
  "analytics.reports.period": "Período",
  "analytics.reports.status": "Status",
  "analytics.reports.reports": "Relatórios",
  "analytics.reports.download": "Download",
  "analytics.reports.visualize": "Visualizar",
  "analytics.reports.pending": "Pendente",
  "analytics.reports.running": "Em execução",
  "analytics.reports.modal.title": "Relatório",
  "analytics.reports.modal.type": "Tipo",
  "analytics.reports.modal.recurrence": "Recorrência",
  "analytics.reports.modal.analysis": "Análise",
  "analytics.reports.modal.customQueries": "Queries Customizadas",
  "analytics.reports.modal.footerText": "Texto de rodapé",
  "analytics.reports.modal.customizeLogo": "Customizar o Logo",
  "analytics.reports.changeSchedule": "Alterar o agendamento",
  "analytics.reports.changeSchedule.dateAndTime": "Data e hora",
  "analytics.reports.changeSchedule.sucess":
    "Agendamento atualizado com sucesso",
  "analytics.reports.changeSchedule.error": "O agendamento não foi salvo!",
  "analytics.reports.upload.errorSize": "Arquivo precisa ser menor do que 2MB!",
  "analytics.reports.upload.errorType": "Formato de imagem inválido!",
  "analytics.reports.actions.delete.success":
    "Relatórios excluídos com sucesso!",
  "analytics.reports.actions.add.error": "O relatório não foi salvo!",
  "analytics.reports.logo.extension": "Extensão inválida!",
  "analytics.reports.logo.size.archive":
    "Tamanho do arquivo superior ao esperado!",
  "analytics.reports.logo.size.image":
    "Tamanho da imagem superior ao esperado!",
  "webCategory.uncategorized": "Sites não classificados",
  "webCategory.abortion": "Ativismo relacionado a direitos reprodutivos",
  "webCategory.pro-life": "Sites pró-vida",
  "webCategory.pro-choice": "Sites a favor da liberdade de escolha",
  "webCategory.activism-groups": "Grupos de ativismo",
  "webCategory.adult-material": "Sites para maiores de idade",
  "webCategory.adult-content": "Conteúdo para maiores",
  "webCategory.nudity": "Nudez",
  "webCategory.sex": "Sexo",
  "webCategory.sex-education": "Educação Sexual",
  "webCategory.lingerie-and-swimsuit": "Lingerie e Maiôs",
  "webCategory.business-and-economy": "Negócios e Economia",
  "webCategory.financial-data-and-services": "Serviços e dados financeiros",
  "webCategory.drugs":
    "Medicamentos ou drogas (conforme definidos pela lei dos E.U.A.)",
  "webCategory.abused-drugs": "Abuso de Drogas",
  "webCategory.prescribed-medications": "Medicamentos sob receita médica",
  "webCategory.supplements-and-unregulated-compounds":
    "Suplementos/compostos não-regulamentados",
  "webCategory.marijuana": "Maconha",
  "webCategory.education": "Educação",
  "webCategory.educational-institutions": "Instituições educacionais",
  "webCategory.cultural-institutions": "Instituições culturais",
  "webCategory.educational-materials": "Materiais educativos",
  "webCategory.reference-materials": "Materiais de Referência",
  "webCategory.entertainment": "Entretenimento",
  "webCategory.mp3-and-audio-download-services": "MP3",
  "webCategory.gambling": "Jogos de azar e apostas",
  "webCategory.games": "Jogos / Games",
  "webCategory.government": "Governo",
  "webCategory.military": "Órgãos militares",
  "webCategory.political-organizations": "Grupos políticos",
  "webCategory.health": "Saúde",
  "webCategory.illegal-or-questionable": "Conteúdo ilegal/questionável",
  "webCategory.pedophilia": "Pedofilia",
  "webCategory.information-technology": "Tecnologia da informação",
  "webCategory.hacking": "Hacking",
  "webCategory.proxy-avoidance": "Sistemas de evitação de proxy",
  "webCategory.search-engines-and-portals": "Mecanismos de busca e portais",
  "webCategory.web-hosting": "Hospedagem de Web",
  "webCategory.url-translation-sites": "Sites de tradução de URL",
  "webCategory.computer-security":
    "Informações sobre Segurança de Computadores",
  "webCategory.internet-communication": "Comunicações pela Internet",
  "webCategory.web-chat": "Chat na Web",
  "webCategory.web-mail": "E-mail pela Web",
  "webCategory.job-search": "Buscas de emprego",
  "webCategory.militancy-and-extremist": "Sites de militância/extremismo",
  "webCategory.news-and-media": "Noticiários e mídia",
  "webCategory.alternative-journals": "Publicações alternativas",
  "webCategory.productivity-categories": "Gestão de produtividade",
  "webCategory.advertisements": "Anúncios publicitários",
  "webCategory.freeware-and-software-download": "Download de freeware/software",
  "webCategory.instant-messaging": "Sistemas de troca instantânea de mensagens",
  "webCategory.message-boards-and-forums": "Quadros de mensagens e clubes",
  "webCategory.online brokerage and trading":
    "Corretagem e negociações on-line",
  "webCategory.pay-to-surf": "Sites que pagam para surfar (pay-to-surf)",
  "webCategory.bandwidth-categories": "Gestão de largura de banda",
  "webCategory.internet-radio-and-tv": "Rádio e TV na Internet",
  "webCategory.streaming-media": "Streaming mídia",
  "webCategory.peer-to-peer-file-sharing":
    "Compartilhamento de arquivos peer-to-peer",
  "webCategory.personal-network-storage-and-backup":
    "Armazenamento/Backup pessoal em rede",
  "webCategory.internet-telephony": "Telefonia via Internet",
  "webCategory.potentially-unwanted-software":
    "Monitoramento indevido e invasão de privacidade",
  "webCategory.malicious-web-sites": "Sites Maliciosos",
  "webCategory.spyware": "Spyware",
  "webCategory.racism-and-hate": "Racismo/ódio",
  "webCategory.religion": "Religião",
  "webCategory.non-traditional-religions-and-occult-and-folklore":
    "Religiões não-tradicionais",
  "webCategory.traditional-religions": "Religiões tradicionais",
  "webCategory.shopping": "Compras",
  "webCategory.internet-auctions": "Leilões na Internet",
  "webCategory.real-estate": "Imóveis",
  "webCategory.social-organizations": "Organizações Sociais",
  "webCategory.professional-and-worker-organizations":
    "Organizações de Trabalho e Profissionais",
  "webCategory.service-and-philanthropic-organizations":
    "Organizações de Serviços e Filantrópicas",
  "webCategory.social-and-affiliation-organizations":
    "Organizações Sociais e Afiliações",
  "webCategory.society-and-lifestyles": "Anúncios pessoais e namoros",
  "webCategory.alcohol-and-tobacco": "Álcool e tabaco",
  "webCategory.gay-or-lesbian-or-bisexual-interest": "Gays e lésbicas",
  "webCategory.personals-and-dating": "Anúncios pessoais e namoros",
  "webCategory.restaurants-and-dining": "Restaurantes e gastronomia",
  "webCategory.hobbies": "Hobbies",
  "webCategory.social-networking-and-personal-sites": "Sites pessoais na Web",
  "webCategory.special-events": "Eventos especiais",
  "webCategory.sports": "Esportes",
  "webCategory.sport-hunting-and-gun-clubs": "Caça esportiva / Clubes de armas",
  "webCategory.tasteless": "Mau-gosto",
  "webCategory.travel": "Turismo",
  "webCategory.vehicles": "Veículos",
  "webCategory.violence": "Violência",
  "webCategory.weapons": "Armas",

  "webCategoryDescription.uncategorized": "",
  "webCategoryDescription.abortion":
    "Sites com apresentação neutra ou equilibrada do assunto.",
  "webCategoryDescription.pro-life":
    "Sites que fornecem informações sobre ou são patrocinados por organizações que apóiam o aborto legal, que oferecem apoio ou incentivo para quem procura o procedimento.",
  "webCategoryDescription.pro-choice":
    "Sites que fornecem informações sobre ou são patrocinados por organizações que se opõem ao aborto legal ou que buscam maior restrição ao aborto.",
  "webCategoryDescription.activism-groups": "",
  "webCategoryDescription.adult-material": "",
  "webCategoryDescription.adult-content":
    "Sites que exibem nudez total ou parcial em um contexto sexual, mas não atividade sexual; conteúdo erótico; parafernália sexual; negócios orientados para o sexo, como clubes, boates, serviços de acompanhantes; e sites de suporte à compra on-line desses bens e serviços.",
  "webCategoryDescription.nudity":
    "Sites que oferecem representações de formas humanas nuas ou seminuas, individualmente ou em grupos, não sendo abertamente sexuais em intenção ou efeito.",
  "webCategoryDescription.sex":
    "Sites que exibem ou descrevem graficamente atos ou atividades sexuais, incluindo exibicionismo; Além disso, sites que oferecem links diretos para esses sites.",
  "webCategoryDescription.sex-education":
    "Sites que oferecem informações sobre sexo e sexualidade, sem intenção pornográfica.",
  "webCategoryDescription.lingerie-and-swimsuit":
    "Sites que oferecem imagens de modelos em trajes sugestivos, mas não obscenos, com semi-nudez permitida. Inclui 'cheese-cake photo', calendário, arte e fotografia pin-up. Inclui também sites que oferecem lingerie ou moda praia para venda.",
  "webCategoryDescription.business-and-economy":
    "Sites patrocinados ou dedicados a empresas, associações de empresas, grupos do setor ou negócios em geral.",
  "webCategoryDescription.financial-data-and-services":
    "Sites que oferecem notícias e cotações de ações, títulos e outros veículos de investimento, conselhos de investimento, mas não comércio on-line. Inclui bancos, cooperativas de crédito, cartões de crédito e seguros.",
  "webCategoryDescription.drugs": "",
  "webCategoryDescription.abused-drugs":
    "Sites que promovem ou fornecem informações sobre o uso de drogas proibidas, exceto maconha, abuso ou uso não autorizado de drogas controladas ou regulamentadas; além disso, parafernália associada a esse uso ou abuso.",
  "webCategoryDescription.prescribed-medications":
    "Sites que fornecem informações sobre medicamentos aprovados e seu uso médico.",
  "webCategoryDescription.supplements-and-unregulated-compounds":
    "Sites que fornecem informações ou promovem a venda ou o uso de produtos químicos não regulamentados pelo FDA (como compostos que ocorrem naturalmente).",
  "webCategoryDescription.marijuana":
    "Sites que fornecem informações sobre ou promovem o cultivo, preparação ou uso de maconha.",
  "webCategoryDescription.education": "",
  "webCategoryDescription.educational-institutions":
    "Sites patrocinados por escolas e outras instalações educacionais, por instituições de pesquisa não acadêmicas ou relacionados a eventos e atividades educacionais.",
  "webCategoryDescription.cultural-institutions":
    "Sites patrocinados por museus, galerias, teatros (mas não cinemas), bibliotecas e instituições similares; Além disso, sites cujo objetivo é a exibição de obras de arte.",
  "webCategoryDescription.educational-materials":
    "Sites que fornecem informações sobre ou que vendem, fornecem materiais curriculares ou instruções diretas; também, periódicos de aprendizado e publicações semelhantes.",
  "webCategoryDescription.reference-materials":
    "Sites que oferecem conteúdo de referência, como atlas, dicionários, enciclopédias, formulários, páginas brancas, amarelas e dados estatísticos públicos.",
  "webCategoryDescription.entertainment":
    "Sites que fornecem informações sobre ou promovem filmes, rádio e televisão não noticiosos, livros, humor e revistas.",
  "webCategoryDescription.mp3-and-audio-download-services":
    "Sites que oferecem suporte ao download de MP3, outros arquivos de som ou que servem como diretórios desses sites.",
  "webCategoryDescription.gambling":
    "Sites que fornecem informações ou promovem jogos de azar ou oferecem suporte a jogos de azar on-line, envolvendo o risco de perder dinheiro.",
  "webCategoryDescription.games":
    "Sites que fornecem informações sobre ou promovem jogos eletrônicos, videogames, jogos de computador, role-playing games ou jogos online. Inclui sorteios e brindes.",
  "webCategoryDescription.government":
    "Sites patrocinados por filiais, escritórios ou agências de qualquer nível do governo, exceto as forças armadas.",
  "webCategoryDescription.military":
    "Sites patrocinados por filiais ou agências das Forças Armadas.",
  "webCategoryDescription.political-organizations":
    "Sites patrocinados por ou fornecendo informações sobre partidos políticos e grupos de interesse focados em eleições ou legislação.",
  "webCategoryDescription.health":
    "Sites que fornecem informações ou conselhos sobre saúde pessoal ou serviços, procedimentos ou dispositivos médicos, mas não drogas. Inclui grupos de auto-ajuda.",
  "webCategoryDescription.illegal-or-questionable":
    "Sites que fornecem instruções ou promovem crimes não-violentos, comportamentos antiéticos ou desonestos ou a prevenção de prossecução.",
  "webCategoryDescription.pedophilia":
    "Sites que incentivam a pedofilia ou que fornecem imagens ou textos com conteúdo de pedofilia.",
  "webCategoryDescription.information-technology":
    "Sites patrocinados por ou fornecendo informações sobre computadores, software, Internet e empresas relacionadas, incluindo sites que oferecem suporte à venda de hardware, software, periféricos e serviços.",
  "webCategoryDescription.hacking":
    "Sites que contêm informações ou que promovem o acesso ou uso ilegal, ou de caráter questionável, de equipamentos de comunicação, software ou bancos de dados.",
  "webCategoryDescription.proxy-avoidance":
    "Sites que fornecem informações sobre como ignorar os recursos do servidor proxy ou obter acesso a URLs de qualquer maneira que contorne o servidor proxy.",
  "webCategoryDescription.search-engines-and-portals":
    "Sites que oferecem suporte à pesquisa na Web, grupos de notícias ou índices ou diretórios dos mesmos.",
  "webCategoryDescription.web-hosting":
    "Sites de organizações que fornecem serviços de hospedagem ou páginas de domínio de nível superior de comunidades da Web.",
  "webCategoryDescription.url-translation-sites":
    "Sites que oferecem tradução online de URLs. Esses sites acessam o URL a ser traduzido de maneira a ignorar o servidor proxy, potencialmente permitindo acesso não autorizado.",
  "webCategoryDescription.computer-security":
    "Sites que fornecem informações ou ferramentas para download gratuitas para segurança de computadores.",
  "webCategoryDescription.internet-communication": "",
  "webCategoryDescription.web-chat":
    "Sites que hospedam serviços de bate-papo na Web ou que oferecem suporte ou fornecem informações sobre bate-papo via HTTP ou IRC.",
  "webCategoryDescription.web-mail":
    "Sites que fornecem serviços de email abertos para uso geral.",
  "webCategoryDescription.job-search":
    "Sites que oferecem informações ou apóiam a busca de emprego ou funcionários.",
  "webCategoryDescription.militancy-and-extremist":
    "Sites que oferecem informações, promovem ou são patrocinados por grupos que defendem crenças ou ações antigovernamentais.",
  "webCategoryDescription.news-and-media":
    "Sites que oferecem notícias e opiniões atuais, incluindo os patrocinados por jornais, revistas de circulação geral ou outras mídias.",
  "webCategoryDescription.alternative-journals":
    "Serviço online equivalente a tablóides de supermercados e publicações adicionais.",
  "webCategoryDescription.productivity-categories": "",
  "webCategoryDescription.advertisements":
    "Sites que fornecem gráficos de publicidade ou outros arquivos de conteúdo de anúncio.",
  "webCategoryDescription.freeware-and-software-download":
    "Sites cuja função principal é fornecer downloads de freeware e software.",
  "webCategoryDescription.instant-messaging":
    "Sites que permitem mensagens instantâneas.",
  "webCategoryDescription.message-boards-and-forums":
    "Sites que hospedam quadros de mensagens, grupos de discussão e outros fóruns de discussão que não exigem filiação.",
  "webCategoryDescription.online brokerage and trading":
    "Sites que oferecem suporte à negociação ativa de títulos e gerenciamento de investimentos.",
  "webCategoryDescription.pay-to-surf":
    "Sites que recompensam os usuários por atividades na Internet, como exibir sites, anúncios ou email.",
  "webCategoryDescription.bandwidth-categories": "",
  "webCategoryDescription.internet-radio-and-tv":
    "Sites cujo objetivo principal é fornecer programação de rádio ou TV na Internet.",
  "webCategoryDescription.streaming-media":
    "Sites que fornecem principalmente conteúdo de mídia de streaming, como trailers de filmes.",
  "webCategoryDescription.peer-to-peer-file-sharing":
    "Sites que fornecem software de client para permitir o compartilhamento e transferência de arquivos ponto a ponto.",
  "webCategoryDescription.personal-network-storage-and-backup":
    "Sites que armazenam arquivos pessoais em servidores da Internet para backup ou compartilhamento.",
  "webCategoryDescription.internet-telephony":
    "Sites que permitem aos usuários fazer chamadas telefônicas pela Internet ou obter informações ou software para esse fim.",
  "webCategoryDescription.potentially-unwanted-software":
    "Sites que usam tecnologias que alteram a operação do hardware, software ou rede do usuário de maneira a diminuir o controle sobre a experiência do usuário, a privacidade ou a coleta e distribuição de informações pessoais.",
  "webCategoryDescription.malicious-web-sites":
    "Sites que contêm código que pode intencionalmente modificar os sistemas do usuário final sem o seu consentimento e causar danos.",
  "webCategoryDescription.spyware":
    "Sites ou páginas que baixam software que, sem o conhecimento do usuário, geram tráfego HTTP (além da simples identificação e validação do usuário).",
  "webCategoryDescription.racism-and-hate":
    "Sites que promovem a identificação de grupos raciais, a difamação ou submissão de grupos ou a superioridade de qualquer grupo.",
  "webCategoryDescription.religion": "",
  "webCategoryDescription.non-traditional-religions-and-occult-and-folklore":
    "Sites que fornecem informações sobre ou promovem religiões não especificadas em Religiões Tradicionais ou outras crenças e práticas não convencionais, cultuais ou folclóricas.",
  "webCategoryDescription.traditional-religions":
    "Sites que fornecem informações sobre ou promovem Bahai, Budismo, Ciência Cristã, Cristianismo, Hinduísmo, Islã, Judaísmo, Mormonismo, Xintoísmo e Sikhismo, além de ateísmo.",
  "webCategoryDescription.shopping":
    "Sites que oferecem suporte à compra on-line de bens e serviços de consumo, exceto: materiais sexuais, lingerie, roupas de banho, investimentos, medicamentos, materiais educacionais, software ou hardware de computador, álcool, tabaco, viagens, veículos e peças, armas.",
  "webCategoryDescription.internet-auctions":
    "Sites que oferecem suporte à oferta e compra de mercadorias entre indivíduos.",
  "webCategoryDescription.real-estate":
    "Sites que fornecem informações sobre aluguel, compra, venda ou financiamento de imóveis residenciais.",
  "webCategoryDescription.social-organizations": "",
  "webCategoryDescription.professional-and-worker-organizations":
    "Sites patrocinados por ou que apóiam ou oferecem informações sobre organizações dedicadas ao avanço profissional ou aos interesses dos trabalhadores.",
  "webCategoryDescription.service-and-philanthropic-organizations":
    "Sites patrocinados por ou que apóiam ou oferecem informações sobre organizações dedicadas a fazer o bem como sua atividade principal.",
  "webCategoryDescription.social-and-affiliation-organizations":
    "Sites patrocinados por ou que apóiam ou oferecem informações sobre organizações dedicadas principalmente à socialização ou a interesses comuns que não sejam filantropia ou promoção profissional.",
  "webCategoryDescription.society-and-lifestyles":
    "Sites que fornecem informações sobre assuntos da vida cotidiana, excluindo entretenimento, saúde, hobbies, empregos, sexo e esportes.",
  "webCategoryDescription.alcohol-and-tobacco":
    "Sites que fornecem informações, promovem ou apóiam a venda de bebidas alcoólicas ou produtos de tabaco ou parafernália associada.",
  "webCategoryDescription.gay-or-lesbian-or-bisexual-interest":
    "Sites que fornecem informações ou atendem a estilos de vida de gays, lésbicas ou bissexuais, incluindo aqueles que apóiam as compras on-line, mas excluem aqueles que são sexuais ou orientados a problemas.",
  "webCategoryDescription.personals-and-dating":
    "Sites que ajudam os usuários a estabelecer relacionamentos interpessoais, excluindo aqueles destinados a organizar encontros sexuais e excluindo aqueles de interesse exclusivamente gay, lésbico ou bissexual.",
  "webCategoryDescription.restaurants-and-dining":
    "Sites que listam, revisam, anunciam ou promovem serviços de alimentação, refeições ou fornecimento de produtos de gênero alimentício.",
  "webCategoryDescription.hobbies":
    "Sites que fornecem informações sobre ou promovem passatempos privados e amplamente sedentários, mas não jogos eletrônicos, de vídeo ou online.",
  "webCategoryDescription.social-networking-and-personal-sites":
    "Sites dedicados principalmente à expressão pessoal de indivíduos (como diários ou blogs pessoais) ou pequenos grupos, frequentemente, mas não necessariamente, envolvendo vários links para sites semelhantes.",
  "webCategoryDescription.special-events":
    "Sites dedicados a um evento atual que requer categorização separada.",
  "webCategoryDescription.sports":
    "Sites que fornecem informações sobre ou promovem esportes, jogos ativos e recreação.",
  "webCategoryDescription.sport-hunting-and-gun-clubs":
    "Sites que fornecem informações ou diretórios de clubes de armas e grupos similares, incluindo instalações de jogos de guerra e paintball.",
  "webCategoryDescription.tasteless":
    "Sites com conteúdo gratuitamente ofensivo ou chocante, mas não violento ou assustador. Inclui sites dedicados parcial ou totalmente a escatologia e tópicos semelhantes ou a linguagem, humor ou comportamento inadequado.",
  "webCategoryDescription.travel":
    "Sites que fornecem informações sobre ou promovem serviços e destinos relacionados a viagens.",
  "webCategoryDescription.vehicles":
    "Sites que fornecem informações sobre ou promovem veículos, incluindo aqueles que oferecem suporte à compra on-line de veículos ou peças.",
  "webCategoryDescription.violence":
    "Sites que apresentam ou promovem violência ou danos corporais, incluindo danos autoinfligidos; ou que exibam gratuitamente imagens de morte, sangue ou ferimento; ou que apresentem imagens ou descrições grotescas ou assustadoras sem nada de valor que o redima.",
  "webCategoryDescription.weapons":
    "Sites que fornecem informações sobre, promovem ou apóiam a venda de armas e itens relacionados.",

  "sidebar.management": "Administração",
  "sidebar.manager": "Gerenciar",
  "sidebar.management.devices": "Devices",
  "sidebar.management.devices.inventory": "Inventário",
  "sidebar.management.devices.community": "Comunidades",
  "sidebar.management.devices.templates": "Templates",
  "sidebar.management.devices.provisioning": "Provisionamento",
  "sidebar.management.devices.backups": "Backups",
  "sidebar.management.policies": "Políticas",
  "sidebar.management.policies.packages": "Pacotes",
  "sidebar.management.policies.templates": "Templates",
  "sidebar.management.profiles": "Perfis",
  "sidebar.management.profiles.webfilter": "Web Filter",
  "sidebar.management.profiles.threat.protection": "Threat Protection",
  "sidebar.management.profiles.application.control": "Application Control",
  "sidebar.management.profiles.intrusion.prevention": "Intrusion Protection",
  "sidebar.management.profiles.ssl.inspection": "Inspeção SSL",
  "sidebar.management.profiles.sdwan": "SD-WAN",
  "sidebar.management.objects": "Objetos",
  "sidebar.management.objects.address": "Endereços",
  "sidebar.management.objects.services": "Serviços",
  "sidebar.management.objects.times": "Horários",
  "sidebar.management.objects.schedules": "Agendamentos",
  "sidebar.management.objects.dictionaries": "Dicionários",
  "sidebar.management.objects.contents": "Conteúdos",
  "sidebar.management.users": "Usuários",
  "sidebar.management.groups": "Grupos",

  "sidebar.analytics": "Analytics",
  "sidebar.analytics.dashboard": "Dashboard",
  "sidebar.analytics.analyzer": "Analyzer",
  "sidebar.analytics.firewall": "Firewall",
  "sidebar.analytics.networkTraffic": "Network Traffic",
  "sidebar.analytics.policyUsage": "Uso de Políticas",
  "sidebar.analytics.webFilter": "Web Filter",
  "sidebar.analytics.applicationControl": "Application Control",
  "sidebar.analytics.intrusionPrevention": "Intrusion Prevention",
  "sidebar.analytics.threatProtection": "Threat Protection",
  "sidebar.analytics.userBehavior": "User Behavior",
  "sidebar.analytics.reports": "Relatórios",
  "sidebar.analytics.events": "Eventos",
  "sidebar.analytics.alerts": "Alertas",
  "sidebar.analytics.loggers": "Loggers",
  "sidebar.analytics.kibana": "Relatórios Personalizados",
  "sidebar.settings": "Configurações",
  "sidebar.settings.system": "Sistema",
  "sidebar.settings.system.general": "Geral",
  "sidebar.settings.system.license": "Licença",
  "sidebar.settings.system.update": "Update",
  "sidebar.settings.system.storage": "Armazenamento",
  "sidebar.settings.system.backups": "Backups",
  "sidebar.settings.system.sessions": "Sessões",
  "sidebar.settings.system.services": "Serviços",
  "sidebar.settings.system.ha": "Alta Disponibilidade (Ativo-Passivo)",
  "sidebar.settings.system.ha_sync": "Alta Disponibilidade (Ativo-Ativo)",
  "sidebar.settings.system.certificate": "Certificados",
  "sidebar.settings.system.custom.branding": "Custom Branding",
  "sidebar.settings.network": "Rede",
  "sidebar.settings.network.general": "Geral",
  "sidebar.settings.network.interfaces": "Interfaces",
  "sidebar.settings.network.email": "E-mail",
  "sidebar.settings.administration": "Administração",
  "sidebar.settings.administration.users": "Users",
  "sidebar.settings.administration.profiles": "Perfis",
  "sidebar.settings.administration.audit": "Auditar",
  "sidebar.settings.administration.servers": "Servidores",
  "sidebar.settings.administration.provider": "Provedor de Identidade",
  "sidebar.settings.administration.control": "Controle de Acesso",
  "sidebar.settings.deploys": "Deploys",
  "sidebar.settings.deploys.panel": "Painel de Deploy",

  "sidebar.networkTraffic": "Tráfego de Rede",
  "sidebar.contentFiltering": "Content Filtering",
  "sidebar.applicationControl": "Application Control",
  "sidebar.intrusionPrevetion": "Intrusion Prevention",
  "sidebar.threatProtection": "Threat Protection",
  "sidebar.emailProtection": "E-mail Protection",
  "sidebar.userBehavior": "User Behavior",

  "policy.title": "Políticas",
  "policy.manager.group.delete.error":
    "Não é possível excluir um grupo que contém regras.",
  "policy.manager.group.delete.title": "Confirmar exclusão do grupo",
  "policy.manager.group.header.user": "usuário",
  "policy.manager.group.header.group": "grupo",
  "policy.form.title": "Formulário de Política",
  "policy.form.tabs.properties": "Propriedades",
  "policy.form.tabs.conditions": "Condições",
  "policy.form.tabs.inspection": "Inspeção",
  "policy.form.tabs.routing": "Roteamento",
  "policy.form.properties.policyGroup": "Grupo de Política",
  "policy.form.properties.loggingOptions": "Registro de Tráfego",

  "policy.form.connection.geolocation": "País",
  "policy.form.connection.destination.mac.address": "MAC Address",
  "policy.form.inspection.sslInspection": "Inspeção SSL",
  "policy.form.inspection.proxyServices": "Serviços de Proxy",
  "policy.form.inspection.intrusionPrevention": "Intrusion Prevention",
  "policy.form.inspection.threatProtection": "Threat Protection",
  "policy.form.inspection.applicationControl": "Application Control",
  "policy.form.inspection.webFilter": "Web Filter",

  "settings.auth.platform": "Plataforma",
  "settings.auth.remoteAddr": "Endereço Remoto",
  "settings.auth.concurrentSessions": "Sessões Concorrentes",
  "settings.auth.loginAttempts": "Tentativas de Login",
  "settings.auth.lockoutTimeout": "Timeout de Bloqueio (min)",
  "settings.auth.sessionTimeout": "Tempo de Sessão (min)",
  "settings.auth.minutes": "minutos",
  "settings.auth.conditions.error": "Por favor, selecione ao menos um item.",

  "settings.auth.keySsh": "Chave SSH",
  "settings.auth.keySsh.copySuccess": "Chave SSH copiada com sucesso!",
  "settings.auth.keySsh.copy": "Copiar chave SSH",
  "settings.auth.filial.settings": "Configurações da Filial",
  "settings.auth.master.ip": "IP da Master",
  "settings.auth.filial.tymeSync": "Tempo de sincronização (segundos)",
  "settings.auth.action.import": "Importar Filiais",
  "settings.auth.name.import": "Arquivo de Filiais",
  "settings.auth.action.copySSH": "Copiar chave SSH",
  "settings.auth.action.enabledFilial": "Habilitar filial",

  "settings.auth.keySsh.disable.confirm":
    "Você tem certeza que deseja desabilitar as seguintes filiais?",
  "settings.auth.change.confirm":
    "Você tem certeza que deseja alterar o modo de sincronismo de sesssão ?",

  "settings.system.logging.logRotationBySize": "Rotação de log por tamanho",
  "settings.system.logging.logRotationBySize.error":
    "Rotação de log por tamanho é de no máximo 90% e mínimo 20%.",
  "settings.system.logging.logRotationByAge": "Rotação de log por tempo",
  "settings.system.logging.logRotationBySession": "Limite de log por sessão",
  "settings.system.logging.rotation": "Rotação",
  "settings.system.logging.persistency": "Persistência",
  "settings.system.logging.logForwarding": "Encaminhamento",
  "settings.system.logging.remoteSyslog": "Syslog",
  "settings.system.logging.warning":
    "Deseja alterar as configurações?\nOs serviços do Firewall serão reinicializados.",
  "settings.system.logging.netflow.serverIP": "IP Servidor Netflow",
  "settings.system.logging.netflow.serverPort": "Porta Servidor Netflow",
  "settings.system.logging.netflow.server.exists": "Essa combinação já existe.",

  "settings.system.logging.syslog.mode.auth": "Modo de Autenticação",
  "settings.system.logging.syslog.cert.service": "Certificado de Serviço",
  "settings.system.logging.syslog.certificate": "CA Remota",
  "settings.system.logging.syslog.cert.invalid": "CA remota inválida!",

  "settings.system.highAvailability.limitHA": "Limite de Heartbeat",
  "settings.system.highAvailability.removeAll":
    "Remover todas as configurações",
  "settings.system.highAvailability.idKey": "Chave de identificação",
  "settings.system.highAvailability.monitoredInterfaces":
    "Interfaces Monitorados",
  "settings.system.highAvailability.secondaryDevice": "Dispositivo secundário",
  "settings.system.highAvailability.networkInterface": "Interface de Rede",
  "settings.system.highAvailability.lastSyncDate": "Data do último sincronismo",
  "settings.system.highAvailability.secondaryServerAddr":
    "Endereço do servidor secundário",
  "settings.system.highAvailability.filesTransferred": "Arquivos transferidos",
  "settings.system.highAvailability.primaryServerStatus":
    "Status do servidor primário",
  "settings.system.highAvailability.errors": "erros",
  "settings.system.highAvailability.editSecondaryServer":
    "Editar servidor secundário",
  "settings.system.highAvailability.slaveWarning":
    "Device secundário ativo, salvar esta interface irá torna-lo device primário.",
  "settings.system.highAvailability.waiting":
    "Aguarde, os servidores estão sendo sincronizados.",
  "settings.system.highAvailability.error.logger.integrated":
    "Não é possível configurar a Alta disponibilidade pois a Logger integrada esta habilitada",

  "wizard.title": "Wizard de Instalação",
  "wizard.tabs.license": "Aceitar Licença",
  "wizard.tabs.system": "Configurações do Sistema",
  "wizard.tabs.network": "Configurações da Rede",
  "wizard.tabs.admin": "Administração",
  "wizard.license.accepted": "Aceitar termos de uso",
  "wizard.system.hostname": "Nome do Host",
  "wizard.system.domain": "Domínio",
  "wizard.system.timezone": "Fuso Horário",
  "wizard.system.language": "Idioma",
  "wizard.network.deviceKey": "Interface",
  "wizard.network.ip": "Endereço IP",
  "wizard.network.mask": "Máscara de Rede",
  "wizard.network.gateway": "Gateway",
  "wizard.network.dns": "Servidor DNS",
  "wizard.network.ntp": "Servidor NTP",
  "wizard.admin.name": "Nome",
  "wizard.admin.email": "E-mail",
  "wizard.admin.pass": "Senha",
  "wizard.admin.repass": "Confirmar a Senha",
  "wizard.license.accepted.error": "Para continuar, os termos de uso devem ser aceitos",
  "wizard.system.hostname.error": "Nome do Host é obrigatório",
  "wizard.system.domain.error": "Domínio é obrigatório",
  "wizard.system.timezone.error": "Fuso horário é obrigatório",
  "wizard.system.language.error": "Idioma é obrigatório",
  "wizard.network.deviceKey.error": "Interface é obrigatória",
  "wizard.network.ip.error": "Endereço IP é obrigatório",
  "wizard.network.mask.error": "Máscara de rede é obrigatória",
  "wizard.network.gateway.error": "Gateway é obrigatório",
  "wizard.network.dns.error": "Servidor DNS é obrigatório",
  "wizard.network.ntp.error": "Servidor NTP é obrigatório",
  "wizard.admin.name.error": "Nome é obrigatório",
  "wizard.admin.email.error": "E-mail é obrigatório",
  "wizard.admin.email.invalid": "Endereço de E-mail Inválido",
  "wizard.admin.pass.error": "Senha é obrigatória",
  "wizard.admin.repass.error": "A confirmação da senha é obrigatória",
  "wizard.admin.repass.mismatch": "A senha do campo de confirmação não corresponde à senha digitada no campo anterior",
  "wizard.progress.step1": "Criar Banco de Dados",
  "wizard.agreement": `BLOCKBIT

CONTRATO DE LICENÇA DE USUÁRIO FINAL

AO CLICAR EM "CONTINUAR", VOCÊ OU A ENTIDADE QUE REPRESENTA ("LICENCIADO") CONSIDERA INCONDICIONALMENTE QUE SEJA LIMITADO E TORNA-SE PARTE DESTE CONTRATO DE LICENÇA DE USUÁRIO FINAL ("CONTRATO") COM A BLOCKBIT TECNOLOGIA LTDA. ("BLOCKBIT"). SE ESSES TERMOS SÃO CONSIDERADOS UMA OFERTA, A ACEITAÇÃO É EXPRESSAMENTE LIMITADA A ESSES TERMOS. SE O LICENCIADO NÃO CONCORDAR INCONDICIONALMENTE COM O ACIMA EXPOSTO, CLIQUE NO BOTÃO "CANCELAR" E O PROCESSO DE INSTALAÇÃO NÃO CONTINUARÁ. SE CLICAR NO BOTÃO “ACEITAR” PARA CONTINUAR COM A INSTALAÇÃO, VOCÊ ESTÁ REPRESENTANDO E GARANTIDO QUE VOCÊ ESTÁ AUTORIZADO A LIGAR O LICENCIADO.


1. Concessão de Licença e Restrições. Sujeito aos termos deste contrato, pagamento de todas as taxas e quaisquer limitações aplicáveis de usuário/uso, o BLOCKBIT concede ao Licenciado um direito pessoal, não sublicenciável e não exclusivo, de usar o software que é diretamente acessível por esse processo de instalação, mas apenas: (i) apenas no formato de código do objeto (“Software”); (ii) em uma máquina especificamente autorizada, localizada em um local de Licenciado autorizado pela BLOCKBIT; e (iii) de acordo com a lista de preços da BLOCKBIT. A BLOCKBIT mantém a propriedade do Software e o Licenciado manterá o aviso de direitos autorais e quaisquer outros avisos que apareçam no Software ou em qualquer mídia que contenha o Software.
2. Atualizações, conteúdo e serviços de suporte. Atualizações, conteúdo e / ou serviços de suporte não são necessariamente fornecidos com o Software e podem exigir pagamento adicional ou incluir termos e condições adicionais. No entanto, na medida em que for fornecida uma atualização para o Software e/ou conteúdo, essa atualização/conteúdo será considerada “Software” fornecido sujeito a este Contrato e deverá ser licenciada para uso somente na máquina específica para a qual foi licenciada. Se serviços de conteúdo/suporte forem fornecidos, a BLOCKBIT se reserva o direito de alterar o escopo ou a duração de tais serviços a qualquer momento e de acessar, usar e distribuir livremente os dados coletados do Licenciado através desses serviços. Se tais serviços forem disponibilizados, o Licenciado poderá ser obrigado a pagar taxas ou outros encargos pelo uso ou acesso a alguns ou todos esses serviços, taxas e termos especificados na fatura ou no formulário de pedido para tal serviço.
3. Restrições. O Licenciado não (e não permitirá que terceiros): (i) fazer engenharia reversa, tentar descobrir qualquer código fonte, ideias ou algoritmos subjacentes do Software; (ii) fornecer, arrendar, emprestar, divulgar, usar para fins de compartilhamento de tempo, agência de serviços ou de outra forma usar ou permitir que outros usem para o benefício de terceiros, o Software (exceto conforme expressamente e especificamente autorizado pela BLOCKBIT); (iii) sem o consentimento prévio e expresso por escrito da BLOCKBIT, realizar qualquer estudo, avaliação comparativa ou análise envolvendo o Software (“Benchmarking”) por qualquer motivo ou finalidade, exceto, na extensão limitada absolutamente necessária, para determinar a adequação do Software para interoperar com os sistemas informáticos internos do Licenciado; (iv) divulgar a terceiros qualquer Benchmarking ou qualquer outra informação relacionada a estes; (v) usar o Software ou qualquer Benchmarking em conexão com o desenvolvimento de produtos que competem com o Software; ou (vi) reproduzir, alterar ou modificar o Software. Antes de descartar qualquer mídia ou aparelho que contenha qualquer parte do Software, o Licenciado deve destruir completamente o Software nele contido. Todas as limitações e restrições do Software neste Contrato também se aplicam à documentação, relatórios e telas. Além disso, o Software licenciado sem encargos ou por um encargo nominal será considerado uma licença de avaliação gratuita e só poderá ser usado para fins de avaliação da obtenção de uma licença paga e não para qualquer uso produtivo. O LICENCIADO RECONHECE QUE O SOFTWARE PODE INCLUIR RECURSOS PARA IMPEDIR O USO APÓS O PERÍODO DE LICENÇA APLICÁVEL E/OU USOS INCONSISTENTES DESTE. O Licenciado reconhece que o Software pode ser distribuído juntamente, conter ou usar determinado software de código aberto ou outro software de terceiros (“Third Party Software”). O SOFTWARE DE TERCEIROS ESTÁ (ALÉM DOS TERMOS E CONDIÇÕES DESTE CONTRATO), SUJEITO E GOVERNADO PELO (E O LICENCIADO CONCORDA E INDENIZARÁ BLOCKBIT POR NÃO CUMPRIMENTO) AS LICENÇAS RESPECTIVAS PARA SOFTWARE DE TERCEIROS. Não são concedidos direitos ou licenças que não sejam expressamente e sem ambiguidade estabelecidos aqui.
4. Confidencialidade. O Software na forma de código-fonte permanece um segredo comercial confidencial da BLOCKBIT e/ou de seus fornecedores. O Software está protegido pelas leis de direitos autorais e outras leis de propriedade intelectual dos Estados Unidos e tratados internacionais. O Licenciado reconhece que, durante o uso do Software, o Licenciado pode obter ou aprender informações relacionadas ao Software, as quais podem incluir, sem limitação, informações relacionadas ao desempenho, confiabilidade ou estabilidade do Software, operação do Software, know-how, técnicas, processos, ideias, algoritmos, design e arquitetura de software (“Informações proprietárias”). Entre as partes, essas informações proprietárias pertencerão exclusivamente à BLOCKBIT. Durante e após a vigência deste Contrato, o Licenciado deve manter a confiança e proteger, e não deve usar (exceto conforme expressamente autorizado por este Contrato) ou divulgar Informações de Propriedade a terceiros.
5. Rescisão. Este Contrato estará em vigor até sua rescisão. O Licenciado pode rescindir este Contrato a qualquer momento, destruindo todas as cópias do Software e documentação relacionada. Este Contrato será rescindido automaticamente se o Licenciado deixar de pagar o valor total faturado pelo Software quando devido ou não cumprir com qualquer termo ou condição deste Contrato, incluindo qualquer tentativa de transferir uma cópia do Software para outra parte, exceto conforme previsto neste contrato. O Licenciado concorda que, com esse término, o Licenciado destruirá todas as cópias do Software e documentação relacionada. Exceto quando expressamente disposto aqui, os termos deste instrumento se manterão independente de qualquer rescisão. A rescisão não é um recurso exclusivo e todas as outras soluções estarão disponíveis, independentemente da rescisão ocorrer ou não.
6. Garantia Limitada e Isenção de Responsabilidade. O LICENCIADO RECONHECE E COMPREENDE QUE O SOFTWARE LICENCIADO DE ACORDO COM ESTE CONTRATO É FORNECIDO 'TAL COMO ESTÁ' SEM QUALQUER GARANTIA QUALQUER RELATIVA À INSTALAÇÃO, USO OU DESEMPENHO DO SOFTWARE.	A BLOCKBIT EXPRESSAMENTE ISENTA E O LICENCIADO CONCEDE EXPRESSAMENTE TODAS AS OUTRAS GARANTIAS, EXPRESSAS OU IMPLÍCITAS, INCLUINDO GARANTIAS DE COMERCIALIZAÇÃO, ADEQUAÇÃO A UMA FINALIDADE ESPECÍFICA, NÃO INFRAÇÃO, INTEGRAÇÃO DO SISTEMA, NÃO INTERFERÊNCIA, PRECISÃO, CONFIABILIDADE E QUALIDADE DO SOFTWARE, INCLUINDO E SEM DERROGAR DO ACIMA, QUAISQUER GARANTIAS E DIREITOS IMPLÍCITOS AO ABRIGO DO CÓDIGO COMERCIAL UNIFORME DOS EUA, UCITA (UNIFORM COMPUTER INFORMATION TRANSACTIONS ACT) E LEI COMUM. A BLOCKBIT E SEUS FORNECEDORES NÃO GARANTEM QUE O SOFTWARE ATENDE AOS REQUISITOS DO LICENCIADO OU QUE A OPERAÇÃO DO SOFTWARE SERÁ ININTERRUPTA OU SEM ERROS. A BLOCKBIT ISENTA-SE AINDA DE RESPONSABILIDADE E O LICENCIADO CONCEDE EXPRESSAMENTE TODAS AS GARANTIAS RELATIVAS AOS RESULTADOS, INFORMAÇÕES, DADOS E QUALQUER CONSELHO FORNECIDO PELO SOFTWARE. ALGUMAS JURISDIÇÕES NÃO PERMITEM A EXCLUSÃO DE GARANTIAS IMPLÍCITAS, POR ISSO A EXCLUSÃO ACIMA PODE NÃO SE APLICAR A ESTAS. A BLOCKBIT não terá nenhuma responsabilidade em substituir a mídia se a falha da mídia resultar de acidente, abuso ou mau uso da mídia. O SOFTWARE É FORNECIDO AO LICENCIADO SEM GARANTIA DE QUALQUER TIPO, EXPRESSA OU IMPLÍCITA, INCLUINDO SEM LIMITAÇÃO, QUALQUER GARANTIA IMPLÍCITA DE COMERCIALIZAÇÃO, ADEQUAÇÃO A UMA FINALIDADE ESPECÍFICA E NÃO INFRACÇÃO.
7. Limitação de responsabilidade. EM NENHUM CASO, BLOCKBIT OU QUALQUER OUTRA PARTE ENVOLVIDA NA CRIAÇÃO, PRODUÇÃO OU ENTREGA DO SOFTWARE SERÃO RESPONSÁVEIS POR QUALQUER DANO INDIRETO, INCIDENTAL OU CONSEQUENCIAL, INCLUINDO SEM LIMITAÇÃO, LUCROS OU DADOS PERDIDOS, MESMO QUE TENHAM SIDO AVISADOS DA POSSIBILIDADE DE TAIS DANOS.
8. Leis anticorrupção. O Licenciado reconhece que está familiarizado e entende as disposições da Lei Anticorrupção do Brasil nº 12.846/2013, Lei contra Práticas de Corrupção no Exterior dos EUA ("FCPA") e da Lei contra Suborno do Reino Unido de 2010 (“UKBA”) e concorda em cumprir seus termos, bem como quaisquer disposições da lei local ou das políticas e procedimentos corporativos da BLOCKBIT relacionados a estes. O Licenciado compreende ainda as disposições relacionadas às proibições da Lei Anticorrupção do Brasil, FCPA e UKBA em relação ao pagamento ou doação de qualquer coisa de valor, incluindo, entre outros, pagamentos, presentes, viagens, entretenimento e refeições, direta ou indiretamente, a um funcionário de um governo estrangeiro ou partido político com o objetivo de influenciar um ato ou decisão em sua capacidade oficial ou induzir o funcionário a usar a influência de seu partido com esse governo, para obter ou manter negócios envolvendo o Software. O Licenciado concorda em não violar ou conscientemente permitir que alguém viole a Lei Anticorrupção do Brasil, FCPA ou UKBA, e o Licenciado concorda que nenhum pagamento feito constituirá suborno, influenciar o pagamento, propina, reembolso ou outro pagamento que viole a Lei Anticorrupção do Brasil, FCPA, o UKBA ou qualquer outra lei aplicável anticorrupção ou anti suborno.
9. Avaliação. Não obstante qualquer coisa contrária a este documento, se o Licenciado estiver usando o Software para fins de avaliação, esse uso estará sujeito aos termos e condições de avaliação atuais da BLOCKBIT ou a outros termos mutuamente acordados para governar essa avaliação.
10. Diversos. Nem este acordo nem as licenças concedidas neste documento são atribuíveis ou transferíveis pelo Licenciado (e qualquer tentativa de fazê-lo será anulada). A BLOCKBIT pode ceder, delegar, licenciar e/ou transferir livremente este Contrato, no todo ou em parte, sem consentimento. Este Contrato será considerado como tendo sido feito e deve ser interpretado de acordo com as leis brasileiras, sem levar em consideração conflitos de disposições legais e sem considerar a Convenção das Nações Unidas sobre a Venda Internacional de Bens ou a Lei Uniforme de Transações de Informações sobre Computadores. Sujeito ao acima exposto, as disposições deste instrumento são apenas para benefício das partes e não para qualquer outra pessoa ou entidade. Qualquer notificação, relatório, aprovação, autorização, acordo ou consentimento exigido ou permitido nos termos deste documento deve ser feito por escrito; as notificações devem ser enviadas para o endereço que a parte aplicável tenha ou possa fornecer mediante notificação por escrito ou, se não houver, o endereço mais recente que a parte que enviar a notificação puder localizar usando esforços razoáveis. Nenhuma falha ou atraso no exercício de qualquer direito deste instrumento operará como uma renúncia, nem qualquer exercício parcial de qualquer direito ou poder deste instrumento impedirá o exercício adicional. Se qualquer disposição for julgada por qualquer tribunal de jurisdição competente como inexequível ou inválida, essa disposição será limitada ou eliminada na extensão mínima necessária para que este acordo permaneça em pleno vigor, efeito e força executória. Esta é a declaração completa e exclusiva do entendimento mútuo das partes com relação à licença aqui concedida e substitui e cancela todos os acordos e comunicações escritos e orais anteriores relacionados a essa licença e quaisquer renúncias ou alterações serão efetivas somente se executadas por escrito pela BLOCKBIT; no entanto, quaisquer termos pré-impressos ou padrão de qualquer pedido de compra, confirmação ou formulário similar, a menos que sejam assinados pela BLOCKBIT após a vigência deste instrumento, não terão força ou efeito. A parte substancialmente predominante em qualquer ação para fazer cumprir este contrato terá o direito de recuperar os honorários e custos de seus advogados relacionados a essa ação.`,

  "settings.license": "Licença",
  "settings.license.save": "Editar Licença",
  "settings.license.data": "Dados da licença",
  "settings.license.signatures": "Assinaturas",
  "settings.license.serial.number": "Número de série",
  "settings.license.update": "Atualizar licença",
  "settings.license.number": "Número da licença",
  "settings.license.status": "Status da licença",
  "settings.license.registration.date": "Data do registro",
  "settings.license.expiration.date": "Data de validade",
  "settings.license.start.date": "Data inicial",
  "settings.license.end.date": "Data final",
  "settings.license.terms": "Termos",

  "settings.backups.settings": "Configurações",
  "settings.backups.execute": "Executar Backup",
  "settings.backups.save.settings": "Salvar Configurações",
  "settings.backups.system.now": "Criar arquivo de backup",
  "settings.backups.device.backups": "Backups do Dispositivo",
  "settings.backups.storage": "Armazenamento",
  "settings.backups.system.backup": "Backup do sistema",
  "settings.backups.period": "Período",
  "settings.backups.period.weekly": "Semanal",
  "settings.backups.period.daily": "Diário",
  "settings.backups.weekday": "Dia da semana",
  "settings.backups.hour": "Hora",
  "settings.backups.automatic.cleanup": "Manutenção automática",
  "settings.backups.automatic.cleanup.info": "Número de backups no storage",
  "settings.backups.snapshot": "Snapshot",
  "settings.backups.log.export": "Exportação de Logs",
  "settings.backups.error.storage":
    "Configure o Armazenamento para execução do Backup",
  "settings.backups.remove": "Remover Backup",
  "settings.backups.remove.snapshot": "Remover Snapshot",
  "settings.backups.remove.confirm": "Tem certeza de que deseja remover?",
  "settings.backups.remove.success": "Backup removido com sucesso",
  "settings.backups.view.size": "Exibir tamanho do backup",
  "settings.backups.view.size.snapshot": "Exibir tamanho do Snapshot",
  "settings.backups.restore": "Restaurar Backup",
  "settings.backups.restore.snapshot": "Restaurar Snapshot",
  "settings.backups.restore.success": "Backup restaurado com sucesso",
  "settings.backups.restore.snapshot.success": "Snapshot restaurado com sucesso",
  "settings.backups.restore.error": "Erro ao restaurar Backup.",
  "settings.backups.restore.error.server": "Servidor Inválido!",
  "settings.backups.restore.error.backup": "Backup Inválido!",
  "settings.backups.restore.snapshot.error": "Erro ao restaurar Snapshot!",
  "settings.backups.restore.sys.warning": `O dispositivo entrará em estado de recuperação, todos os serviços serão finalizados.
  Após a restauração o dispositivo será reiniciado. É recomendado que o Backup de Sistema seja aplicado apenas em ambientes idênticos ou similares.`,
  "settings.backups.restore.device.warning": "O dispositivo entrará em estado de recuperação. Após a restauração o sistema será reiniciado.",
  "settings.backups.restore.snapshot.warning":
    "Tem certeza de que deseja restaurar o Snapshot?",
  "settings.backups.restore.log.warning":
    "Tem certeza de que deseja restaurar o backup de Log?",
  "settings.backups.restore.snapshot.invalid": "Snapshot inválido!",
  "settings.backups.restore.snapshot.invalid.version":
    "Versão do Snapshot inválida!",
  "settings.backups.import": "Importar",
  "settings.backups.import.configuration": "Importar configuração",
  "settings.backups.import.success": "Importado com sucesso",
  "settings.backups.import.error": "Erro ao importar",
  "settings.notifications.vpn.monitor": "Monitor de VPN",
  "settings.backups.import.error-duplicated-sids":
    "Erro ao importar, SIDS duplicados: ",
  "settings.backups.import.error-invalid-rules":
    "Erro ao importar, regras inválidas",
  "settings.backups.import.error-rules-not-found":
    "Erro ao importar, regras não encontradas",
  "settings.backups.import.error-file-not-found":
    "Erro ao importar, arquivo não encontrado",
  "settings.backups.import.upload": "Clique para upload",
  "settings.backups.import.loading": "Carregando...",
  "settings.backups.import.in.progress": "Importando configurações",
  "settings.backups.import.wait":
    "Espere enquanto as configurações são aplicadas",
  "settings.backups.file.configuration": "Arquivo de configuração",
  "settings.backups.run": "Executar Backup",
  "settings.backups.run.execute": "Executar",
  "settings.backups.run.confirm": "Deseja fazer o backup agora?",
  "settings.backups.run.confirm.backup":
    "Deseja fazer o backup de sistema agora?",
  "settings.backups.run.confirm.snapshot": "Deseja fazer o Snapshot agora?",
  "settings.backups.run.confirm.logs":
    "Deseja fazer a exportação de logs agora?",
  "settings.backups.run.success": "Execução feita com sucesso",
  "settings.backups.select.time": "Selecione a hora",
  "settings.backups.confirm.delete":
    "Você confirma deletar o(s) backup(s) agora?",
  "settings.backups.confirm.stop": "Você confirma parar o backup agora?",
  "settings.backups.confirm.restore":
    "Você confirma restaurar o(s) backup(s) agora?",

  "settings.notifications": "Notificações",
  "settings.notifications.system.notifications": "Notificações de sistema",
  "settings.notifications.security.notifications": "Notificações de segurança",
  "settings.notifications.notifications.email": "Notificações via Email",
  "settings.notifications.notifications.snmp": "Notificações via SNMP",
  "settings.notifications.synchronism": "Sincronismo",
  "settings.notifications.gsm.analyzer": "GSM Analyzer",
  "settings.notifications.activities.policy": "Atividades em Políticas",
  "settings.notifications.activities.intrusion":
    "Atividades em Detecção de Intrusos",
  "settings.notifications.activities.application": "Atividades de Aplicativos",
  "settings.notifications.activities.webcategories":
    "Atividades de Categorias Web",
  "settings.notifications.activities.malware": "Atividades de Vírus",
  "settings.notifications.secure.connection": "Conexão segura",
  "settings.notifications.dont.use": "Não usar",
  "settings.notifications.from.email": "Remetente",
  "settings.notifications.recipient": "Destinatário",
  "settings.notifications.communities": "Comunidades",
  "settings.notifications.authentication.protocol": "Protocolo de Autenticação",
  "settings.notifications.engine.id": "Engine ID",
  "settings.notifications.level.security": "Nível de Segurança",
  "settings.notifications.encryption.algorithm": "Algoritmo de Criptografia",
  "settings.notifications.private.password": "Senha Privada",

  "services.firewall.generalSettings": "Configurações Gerais",
  "services.firewall.generalSettings.security.settings":
    "Configurações de Segurança",
  "services.firewall.generalSettings.timeout": "Timeout",
  "services.firewall.generalSettings.dos.protection": "Proteção DoS",
  "services.firewall.generalSettings.ipSpoofing.protection":
    "Proteção IP Spoofing",
  "services.firewall.generalSettings.portScan.protection": "Proteção PortScan ",
  "services.firewall.generalSettings.invalidPacket.protection":
    "Proteção de pacotes inválidos",
  "services.firewall.generalSettings.allow.ping": "Permitir Ping",
  "services.firewall.generalSettings.allow.imcpRedirect":
    "Permitir Redirecionamento de ICMP",
  "services.firewall.generalSettings.ignore.icmp.broadcast":
    "Ignorar broadcast de ICMP",
  "services.firewall.generalSettings.source.routing": "Roteamento de Origem",
  "services.firewall.generalSettings.checksum": "Checksum",
  "services.firewall.generalSettings.fec": "Correção de Erro",
  "services.firewall.generalSettings.invalid.log": "Log Inválido",
  "services.firewall.generalSettings.generic.timeout": "Tempo limite Genérico",
  "services.firewall.generalSettings.icmp.timeout": "Tempo limite ICMP",
  "services.firewall.generalSettings.tcp.loose": "TCP solto",
  "services.firewall.generalSettings.tcp.max.retrans": "TCP Max Retrans",
  "services.firewall.generalSettings.tcp.timeout.close":
    "Tempo limite de fechamento TCP",
  "services.firewall.generalSettings.tcp.timeout.close.wait":
    "Tempo limite de espera de fechamento TCP",
  "services.firewall.generalSettings.tcp.timeout.established":
    "Tempo limite de TCP estabelecido",
  "services.firewall.generalSettings.timeout.tcp.fin.wait":
    "Tempo limite de espera TCP FIN",
  "services.firewall.generalSettings.tcp.timeout.last.ack":
    "Tempo Limite do último TCP ACK",
  "services.firewall.generalSettings.timeout.max.retrans":
    "Tempo limite TCP Max Retrans",
  "services.firewall.generalSettings.timeout.tcp.syn.recv":
    "Tempo limite TCP SYN Recebido",
  "services.firewall.generalSettings.timeout.tcp.syn.sent":
    "Tempo limite TCP SYN Enviado",
  "services.firewall.generalSettings.timeout.tcp.time.wait":
    "Tempo limite TCP do tempo de espera",
  "services.firewall.generalSettings.udp.timeout": "Tempo limite UDP",
  "services.firewall.generalSettings.udp.timeout.stream":
    "Tempo limite UDP corrente",
  "services.firewall.generalSettings.confirm.message":
    "Não será possível utilizar o serviço SD-WAN nas zonas de rede selecionadas. Deseja continuar? ",
  "services.firewall.generalSettings.success.message":
    "Configurações gerais do Firewall atualizadas com sucesso",

  "services.firewall.zoneProtection.delete": "Excluir Zone Protection",
  "services.firewall.zoneProtection.delete.success": "Removido com sucesso",
  "services.firewall.zoneProtection.delete.confirm": "Você tem certeza que quer excluir os seguintes itens?",
  "services.firewall.zoneProtection.delete.selected": "Remover Selecionados",
  "services.firewall.zoneProtection.clone": "Clonar Zone Protection",
  "services.firewall.zoneProtection.clone.confirm": "Você tem certeza que quer clonar os seguintes itens?",
  "services.firewall.zoneProtection.clone.selected": "Clonar Selecionados",
  "services.firewall.zoneProtection.clone.success": "Política de Zone Protection clonada com sucesso",
  "services.firewall.zoneProtection.clone.error": "Erro ao clonar política de Zone Protection",
  "services.firewall.zoneProtection.create": "Criar Zone Protection",
  "services.firewall.zoneProtection.ipAddress": "Endereço IP{version}",
  "services.firewall.zoneProtection.warning": "Você está desabilitando uma regra de Zone Protection que contém um serviço que é utilizado na configuração de funcionamento do Proxy Explícito. Para que o mesmo funcione corretamente, está regra deve estar habilitada.",
  "services.firewall.portForwarding": "Port Forwarding",
  "services.firewall.portForwarding.add": "Criar Port Forwarding",
  "services.firewall.portForwarding.del": "Remover Port Forwarding",
  "services.firewall.portForwarding.clone.confirm": "Você tem certeza que deseja clonar o seguinte item?",
  "services.firewall.portForwarding.clone.success": "Política de Port Forwarding clonada com sucesso",
  "services.firewall.portForwarding.clone.error": "Erro ao clonar política de Port Forwarding",
  "services.firewall.portForwarding.modal.policy": "Política",
  "services.firewall.portForwarding.modal.conditions": "Condições",
  "services.firewall.portForwarding.modal.inspection": "Inspeção",
  "services.firewall.portForwarding.modal.advanced": "Avançado",
  "services.firewall.portForwarding.modal.policy.portrange": "Porta / Range",
  "services.firewall.portForwarding.modal.policy.redirect": "Redirecionar Para",
  "services.firewall.portForwarding.modal.policy.snat": "SNAT",
  "services.firewall.portForwarding.modal.policy.snat.default": "Gateway Padrão (Masquerade)",
  "services.firewall.portForwarding.modal.policy.jump": "Redirecionamento de Porta entre Domínios de Rede",
  "services.firewall.portForwarding.modal.condition.src.allowed": "Permitidas",
  "services.firewall.portForwarding.modal.condition.src.blocked": "Bloqueadas",
  "services.firewall.portForwarding.modal.condition.schedule": "Agendamento",
  "services.firewall.portForwarding.modal.inspection.ssl": "SSL Inspection",
  "services.firewall.portForwarding.modal.inspection.atp": "Threat Blocking",
  "services.firewall.portForwarding.modal.inspection.ips": "Intrusion Prevention",
  "services.firewall.portForwarding.modal.inspection.dosProtection": "Proteção DoS",
  "services.firewall.portForwarding.modal.inspection.packetRate": "Taxa de Pacote (pacotes/segundos)",
  "services.firewall.portForwarding.modal.inspection.burstRate": "Taxa de Explosão",
  "services.firewall.portForwarding.modal.dosProtection": "DoS Protection",
  "services.firewall.portForwarding.modal.packetRate": "Taxa de Pacote (pacotes/segundos)",
  "services.firewall.portForwarding.modal.burstRate": "Taxa de Explosão",
  "services.firewall.portForwarding.modal.error.interface.and.protocol":
    "Não é permitido redirecionar tudo da interface que está sendo usado para acessar o servidor",
  "services.firewall.portForwarding.modal.error.equal.redirect":
    "Existe um redirecionamento com essas caracteristicas",
  "services.firewall.portForwarding.ssl.warning":
    "Regras de redirecionamento com Inspeção SSL só funcionarão para serviços em que o protocolo de segurança é suportado",

  "services.vpnng.error.userOrGroup": "Por favor, insira um usuário ou um grupo!",
  "services.vpnng.error.startingIPRangeIsReserved": "IP de início do range já está reservado.",
  "services.vpnng.error.startingIPRangeIsInvalid": "IP de início do range é inválido!",
  "services.vpnng.error.endIPRangeIsReserved": "IP de fim do range já está reservado.",
  "services.vpnng.error.endIPRangeIsInvalid": "IP de fim do range já está reservado.",
  "services.vpnng.error.validLeaseLimit": "Por favor insira um limite de lease válido: Com pelo menos 3 caracteres.",
  "services.vpnng.columns.ipInit": "IP inicial",
  "services.vpnng.columns.ipLimit": "IP limite",
  "services.vpnng.columns.leaseLimit": "Lease limite",
  "services.vpnng.title.settings": "Configuração do servidor DHCP Virtual",
  "services.vpnng.name": "Nome da VPN",
  "services.vpnng.sameName": "Não são permitidos nomes iguais.",
  "services.vpnng.virtual.host.ip": "Endereço IP do host virtual",
  "services.vpnng.start.ip": "Distribui/Distribuiu Endereço IP Iniciar",
  "services.vpnng.limit.ip": "Distribui/Distribuiu Endereço IP Limite",
  "services.vpnng.settings.title.optional": "Opções Aplicadas a Clientes (opcional)",
  "services.vpnng.title.add.users.groups": "Adicinonar usuários e grupos",


  "common.spanish": "Espanhol",
  "system.general.message.disclaimer.es": "Mensagem - Espanhol",
  "system.settings.certificate.nameInvalid": "Nome inválido",
  "system.settings.certificate.nameExists": "Nome de certificado já existe",
  "system.settings.certificate.import": "Certificado importado.",
  "system.settings.certificate.invalid": "Certificado inválido",
  "system.settings.certificate.deleteErrorRemoteCAareUsedInProxy": "Este certificado está em uso no módulo de proxy e/ou no perfil ssl.",
  "system.settings.certificate.importSucces":
    "Certificado importado com sucesso",
  "system.settings.certificate.input.certificateRequired":
    "Certificado é obrigatório",
  "system.settings.certificate.input.privateKeyRequired":
    "Chave privada é obrigatória",
  "system.settings.certificate.input.nameRequired": "Nome é obrigatório",
  "system.settings.certificate.deleteRemoteCA":
    "Certificado removido com sucesso",
  "system.settings.certificate.deleteErrorRemoteCA":
    "Não foi possível remover certificado",
  "system.settings.certificate.title.name": "Nome",
  "system.settings.certificate.title.type": "Tipo",
  "system.settings.certificate.title.action": "Ação",
  "system.settings.certificate.tooltip.upload": "Importar certificado",
  "system.settings.certificate.tooltip.trash": "Excluir certificado",
  "system.settings.certificate.modal.title": "Importar CA",
  "system.settings.certificate.modal.labelCertificate": "Certificado",
  "system.settings.certificate.modal.labelPrivateKey": "Chave Privada",
  "applicationControl.add.custom": "Adicionar Grupo de Aplicativos",
  "applicationControl.add.custom.smart": "Controle de Aplicações Inteligente",
  "applicationControl.add.category": "Categorias de aplicativos",
  "applicationControl.add.group": "Grupos de categorias",
  "applicationControl.add.custom.group": "Adicionar Grupo Customizado",
  "applicationControl.add.custom.category": "Criar Grupo de Assinaturas Customizadas",
  "applicationControl.add.custom.category.group": "Adicionar Grupo Customizado",
  "applicationControl.delete.group": "Deseja deletar este item?",
  "settings.system.updates.Type": "Tipo",
  "settings.system.updates.Product": "Produto",
  "settings.system.updates.Version": "Versão",
  "settings.system.updates.Date": "Data",
  "settings.system.updates.Description": "Descrição",
  "settings.system.updates.Action": "Ação",
  "settings.system.updates.UninstallMessage": "Deseja apagar esse pacote?",
  "settings.system.updates.Uninstall": "Desinstalar",
  "settings.system.updates.InstallMesage": "Instalar Pacote",
  "settings.system.updates.bbValidation": "este arquivo não é do tipo bb",
  "settings.system.updates.bbModalTextUpload": "O arquivo está sendo carregado, Por favor aguarde...",
  "settings.system.updates.bbModalTextremoved": "O pacote está sendo removido, Por favor aguarde...",
  "settings.system.updates.bbModalTextInstalled": "O pacote está sendo instalado, Por favor aguarde...",
  "service.notifications.vpn.monitor.enable": "Monitoramento de VPN Habilitado",
  "service.notifications.vpn.monitor.disable": "Monitoramento de VPN Desabilitado",
  "profiles.title.dnscontentfilter": "DNS Content Filter",
  "common.profile.dnscontent": "Perfil de DNS Content Filter",
  "profiles.default.dnscontentfilter": "Ação padrão",
  "common.modal.form.error.redirect": "O campo Redirecionar é obrigatório",
  "system.settings.title.cardfilter": "Configurações avançadas",
  "system.settings.title.input.processos": "Processos simultâneos",
  "system.settings.title.input.theads": "Threads por processos",
  "system.settings.title.input.webproxy.transparente": "Requisições simultâneas do proxy transparente",
  "system.settings.title.input.webproxy": "Processos do WebProxy",
  "system.settings.title.input.webproxy.ativo": "Requisições simultâneas do proxy ativo",
  "dhcp.allinterfacesv4.inuser": "Opção Todas interfaces IPV4 cadastrada, favor selecionar outra interface",
  "dhcp.interfacesv4.inuser": "Já possui interface com servidores IPV4 cadastrados, por favor, selecione outra opção",
  "common.allip": "Todas interfaces IPV4",
  //MFA
  "system.mfa.portal": "Portal",
  "system.mfa.enable.admin": "Habilitar MFA Administradores",
  "system.mfa.enable.portal": "Habilitar MFA Captive Portal",
  "system.mfa.title.modal": "Gerar Token",
  "system.mfa.message.token.success": "Token gerado com sucesso!",
  "system.mfa.message.token.error": "Erro na geração do token:",
  "system.mfa.message.token.alreadyExists.error": "Token já existente.",
  "system.mfa.message.token.copy": "Token foi copiado.",
  "system.mfa.message.delete.error": "Não foi possível excluir o Token.",
  "system.mfa.settings.title": "Controles do MFA",
  "system.mfa.title": "Multi Factor Authentication",
  "cluster_popup.title1": "Desabilitar o Spanning Tree Protocol (STP):",
  "cluster_popup.paragraph1": "- Desabilite o Spanning Tree Protocol (STP) nas interfaces do switch para evitar conflitos com o UCARP. Isso é necessário para garantir a comunicação eficiente entre os nós do cluster sem a interferência de loops de rede gerenciados pelo STP.",
  "cluster_popup.title2": "Suporte ao Protocolo VRRP:",
  "cluster_popup.paragraph2": "- O switch deve suportar o protocolo VRRP (Virtual Router Redundancy Protocol) conforme as especificações das RFCs 3768, 2787 e 5798. O VRRP é essencial para a redundância de roteamento, permitindo que um IP virtual seja compartilhado entre vários roteadores para aumentar a disponibilidade.",
  "cluster_popup.title3": "Configuração Correta das Interfaces de Rede:",
  "cluster_popup.paragraph3": "- Certifique-se de que todas as interfaces de rede envolvidas no Cluster estejam configuradas corretamente e estejam operacionais. Preste atenção especial às interfaces LAN e DMZ, que são cruciais para a comunicação interna e externa do cluster.",
  "cluster_popup.title4": "Configuração de Endereços IP Virtuais:",
  "cluster_popup.paragraph4": "- Configure os endereços IP virtuais corretamente. O UCARP usa esses endereços para gerenciar a atribuição de papéis Master e Backup entre os servidores. A configuração correta dos IPs virtuais é fundamental para a funcionalidade de failover.",
  "cluster_popup.titleButton": "Para mais informações, consultar o manual do Blockbit NGFW:",
  "cluster_popup.linkButton": "https://docs.blockbit.com/display/RC/System+-+Aba+High+Availability",
  "kibana.service.down": "Para acessar o relatórios personalizados, configure o Logger no dispositivo.",
  "kibana.loading": "Carregando...",
  "kibana.select.logger": "Selecione logger",
  "common.selectAll": "Selecionar Todos",
  "common.deselectAll": "Deselecionar Todos",
};

export default enMessages;
